import { Option } from "./types";

export const LIGHT_MODE = "light";
export const DARK_MODE = "dark";

export interface Recommendation {
  title: string;
  waitingPeriod: string;
  decision: string;
  maxCertification: string;
  questionIds: (number | string)[];
}

export const stateOptionswithAbre: Option[] = [
  { label: "-- Select State --", value: "" },
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const practitionerOptions: Option[] = [
  { label: "MD", value: "MD" },
  { label: "DO", value: "DO" },
  { label: "Physician Assistant", value: "Physician Assistant" },
  { label: "Chiropractor", value: "Chiropractor" },
  { label: "Advanced Practice Nurse", value: "Advanced Practice Nurse" },
];
export const stateOptions: Option[] = [
  // { label: "-- Select State --", value: "" },
  { label: "Alabama", value: "Alabama" },
  { label: "Alaska", value: "Alaska" },
  { label: "Arizona", value: "Arizona" },
  { label: "Arkansas", value: "Arkansas" },
  { label: "California", value: "California" },
  { label: "Colorado", value: "Colorado" },
  { label: "Connecticut", value: "Connecticut" },
  { label: "Delaware", value: "Delaware" },
  { label: "District of Columbia", value: "District of Columbia" },
  { label: "Florida", value: "Florida" },
  { label: "Georgia", value: "Georgia" },
  { label: "Hawaii", value: "Hawaii" },
  { label: "Idaho", value: "Idaho" },
  { label: "Illinois", value: "Illinois" },
  { label: "Indiana", value: "Indiana" },
  { label: "Iowa", value: "Iowa" },
  { label: "Kansas", value: "Kansas" },
  { label: "Kentucky", value: "Kentucky" },
  { label: "Louisiana", value: "Louisiana" },
  { label: "Maine", value: "Maine" },
  { label: "Maryland", value: "Maryland" },
  { label: "Massachusetts", value: "Massachusetts" },
  { label: "Michigan", value: "Michigan" },
  { label: "Minnesota", value: "Minnesota" },
  { label: "Mississippi", value: "Mississippi" },
  { label: "Missouri", value: "Missouri" },
  { label: "Montana", value: "Montana" },
  { label: "Nebraska", value: "Nebraska" },
  { label: "Nevada", value: "Nevada" },
  { label: "New Hampshire", value: "New Hampshire" },
  { label: "New Jersey", value: "New Jersey" },
  { label: "New Mexico", value: "New Mexico" },
  { label: "New York", value: "New York" },
  { label: "North Carolina", value: "North Carolina" },
  { label: "North Dakota", value: "North Dakota" },
  { label: "Ohio", value: "Ohio" },
  { label: "Oklahoma", value: "Oklahoma" },
  { label: "Oregon", value: "Oregon" },
  { label: "Pennsylvania", value: "Pennsylvania" },
  { label: "Rhode Island", value: "Rhode Island" },
  { label: "South Carolina", value: "South Carolina" },
  { label: "South Dakota", value: "South Dakota" },
  { label: "Tennessee", value: "Tennessee" },
  { label: "Texas", value: "Texas" },
  { label: "Utah", value: "Utah" },
  { label: "Vermont", value: "Vermont" },
  { label: "Virginia", value: "Virginia" },
  { label: "Washington", value: "Washington" },
  { label: "West Virginia", value: "West Virginia" },
  { label: "Wisconsin", value: "Wisconsin" },
  { label: "Wyoming", value: "Wyoming" },
];

export const canadaStateOptions: Option[] = [
  { label: "Alberta", value: "Alberta" },
  { label: "British Columbia", value: "British Columbia" },
  { label: "Manitoba", value: "Manitoba" },
  { label: "New Brunswick", value: "New Brunswick" },
  { label: "Newfoundland and Labrador", value: "Newfoundland and Labrador" },
  { label: "Nova Scotia", value: "Nova Scotia" },
  { label: "Ontario", value: "Ontario" },
  { label: "Prince Edward Island", value: "Prince Edward Island" },
  { label: "Quebec", value: "Quebec" },
  { label: "Saskatchewan", value: "Saskatchewan" },
];

export const canadaStateOptionswithAbre: Option[] = [
  { label: "-- Select Province --", value: "" },
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
];

export const allStateOptions: Option[] = [
  ...stateOptions,
  ...canadaStateOptions,
];

export const allStateOptionswithAbre: Option[] = [
  ...stateOptionswithAbre,
  ...canadaStateOptionswithAbre.filter((o) => o.value !== ""),
];

export const sideEffectOptions = [
  "No Side Effects",
  "Weight Gain",
  "Abnormal Heart Rhythms",
  "Anxiety",
  "Bruising",
  "Constipation",
  "Depression",
  "Dizziness",
  "Drowsiness",
  "Elevated Blood Pressure",
  "Headache",
  "Insomnia",
  "Nausea",
  "Upset Stomach",
  "Vomiting",
  "Rash",
];

export const frequencyOptions = [
  "Twice a Day",
  "Once a Day",
  "Three Times a Day",
  "Before Bed",
  "Every Four Hours",
  "Every Six Hours",
  "Every Other Day",
  "As Needed",
  "Before Meals",
  "After Meals",
];

export const bodyPartOptions = [
  "Head",
  "Neck",
  "Shoulder",
  "Arm",
  "Wrist",
  "Hand",
  "Chest",
  "Abdomen",
  "Back",
  "Leg",
  "Knee",
  "Ankle",
  "Foot",
];

export const surgeryTypeOptions = [
  "Appendectomy",
  "Cholecystectomy",
  "Hernia Repair",
  "Mastectomy",
  "Hip Replacement",
  "Knee Replacement",
  "Cataract Surgery",
  "Spinal Fusion",
  "Heart Bypass",
  "Tonsillectomy",
];

export const followUpOptions = [
  "One Week",
  "Two Weeks",
  "One Month",
  "Three Months",
  "Six Months",
  "One Year",
];

export const documentType = [
  "Cardiac Angiogram",
  "Cardiac stress test (nuclear)",
  "Cardiac stress test (treadmill)",
  "Clearance letters",
  "Consent Forms",
  "CPAP Report",
  "CT Report",
  "DOT Physical (External)",
  "Echocardiogram",
  "Electrocardiogram (EKG)",
  "Electroencephalogram (EEG)",
  "Exemptions / Waivers",
  "Hemoglobin A1C",
  "INR Coumadin (warfarin)",
  "Laboratory",
  "Lift Test",
  "MRI Report",
  "Other",
  "Outside Medical Report",
  "Pacemaker function check",
  "Specialist documents",
  "Substance Abuse (SAP) Report",
  "Ultrasound",
  "Visit Note",
  "X-Ray",
];

export const statusOptions = [
  "Scheduled",
  "Completed",
  "Pending",
  "Canceled",
  "In Progress",
  "Follow-Up Required",
];

export interface Question {
  id: number;
  text: string;
  answer: string;
  additionalComment: string;
  options?: string[];
  subQuestions: Question[];
  is_disabled?: boolean;
}

export interface Recommendation {
  title: string;
  waitingPeriod: string;
  decision: string;
  maxCertification: string;
  questionIds: (number | string)[];
}

export interface SurveyData {
  pkid: number;
  id: string;
  created_at: string;
  updated_at: string;
  other_clinic: string;
  certification_type: string;
  employment_type: string;
  employer_name: string;
  is_denied_by_usdot_fmcsa_cert: boolean;
  has_clp_cdl: boolean;
  visit_date: string;
  visit_status: string;
  visit_type: string;
  certification_status: string;
  duration: number;
  expiration: string;
  verfication_doc_type: string;
  is_driver_verified: boolean;
  signature_date: string;
  user_driver: number;
  clinic_office: number;
  assigned_medical_assitant: number;
  assigned_provider: number;
}
export const questionnaireData: Question[] = [
  {
    id: 1,
    text: "Head/brain injuries or illnesses (e.g., concussion)",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 101,
        text: "Was there a known cause for your loss of consciousness?",
        answer: "",
        additionalComment: "Known cause for fainting.",
        subQuestions: [
          {
            id: 1011,
            text: "Did you have a single episode?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1012,
            text: "Do you currently have episodes of loss of consciousness?",
            answer: "",
            additionalComment: "Recurring fainting episodes.",
            subQuestions: [],
          },
          {
            id: 1013,
            text: "Have you ever been evaluated by a cardiologist or neurologist for this condition?",
            answer: "",
            additionalComment: "Evaluated by specialist.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    text: "Seizures/epilepsy",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 201,
        text: "Was your last seizure less than 5 years ago and have you remained asymptomatic since then?",
        answer: "",
        additionalComment: "Recent seizure history.",
        subQuestions: [],
      },
      {
        id: 202,
        text: "Did you have more than one seizure?",
        answer: "",
        additionalComment: "Multiple seizures.",
        subQuestions: [],
      },
      {
        id: 203,
        text: "Was the seizure due to a head injury, surgery, bleeding, or stroke?",
        answer: "",
        additionalComment: "Seizure linked to injury.",
        subQuestions: [],
      },
      {
        id: 204,
        text: "Was your seizure due to metabolic illness?",
        answer: "",
        additionalComment: "Seizure due to illness.",
        subQuestions: [],
      },
      {
        id: 205,
        text: "Was your seizure a 'one-time childhood seizure' with/without known cause?",
        answer: "",
        additionalComment: "Childhood seizure.",
        subQuestions: [],
      },
      {
        id: 206,
        text: "Are you currently taking medications to prevent more seizures?",
        answer: "",
        additionalComment: "Seizure medication use.",
        subQuestions: [],
      },
      {
        id: 207,
        text: "Do you have any residual neurologic deficits (permanent impairments because of seizures)?",
        answer: "",
        additionalComment: "Neurological impairments.",
        subQuestions: [],
      },
      {
        id: 208,
        text: "Do you see a neurologist regularly (annually, biennially)?",
        answer: "",
        additionalComment: "Regular neurologist visits.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 3,
    text: "Eye problems (except glasses or contacts)",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 4,
    text: "Ear and/or hearing problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 5,
    text: "Heart disease, heart attack, bypass, or other heart problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 501,
        text: "Do you currently have a defibrillator?",
        answer: "",
        additionalComment: "Presence of defibrillator.",
        subQuestions: [],
      },
      {
        id: 502,
        text: "When was your pacemaker implanted?",
        answer: "",
        additionalComment: "Pacemaker implantation date.",
        subQuestions: [],
      },
      {
        id: 503,
        text: "Do you currently use nitroglycerin (nitro) more frequently than before?",
        answer: "",
        additionalComment: "Increased nitro use.",
        subQuestions: [],
      },
      {
        id: 504,
        text: "Have you been medically cleared to operate a commercial vehicle since your heart procedure?",
        answer: "",
        additionalComment: "Medical clearance for driving.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 6,
    text: "Pacemaker, stents, implantable devices, or other heart procedures",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 601,
        text: "Do you currently have a combination defibrillator/pacemaker in place?",
        answer: "",
        additionalComment: "Combination device status.",
        subQuestions: [],
      },
      {
        id: 602,
        text: "Do you have regular function checks for your device?",
        answer: "",
        additionalComment: "Device check frequency.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 7,
    text: "High blood pressure",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 701,
        text: "Is your blood pressure less than or equal to 140/90 today?",
        answer: "",
        additionalComment: "Current blood pressure level.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 8,
    text: "High cholesterol",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 9,
    text: "Chronic (long-term) cough, shortness of breath, or other breathing problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 10,
    text: "Lung disease (e.g., asthma)",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1001,
        text: "Do you currently use oxygen for COPD?",
        answer: "",
        additionalComment: "Oxygen use for COPD.",
        subQuestions: [],
      },
      {
        id: 1002,
        text: "Do you have sedentary or activity-limiting shortness of breath?",
        answer: "",
        additionalComment: "Shortness of breath severity.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 11,
    text: "Kidney problems, kidney stones, or pain/problems with urination",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1101,
        text: "Are you currently being treated with dialysis?",
        answer: "",
        additionalComment: "Undergoing dialysis treatment.",
        subQuestions: [],
      },
      {
        id: 1102,
        text: "Did you have a kidney transplant?",
        answer: "",
        additionalComment: "Kidney transplant history.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 12,
    text: "Stomach, liver, or digestive problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 13,
    text: "Diabetes or blood sugar problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1301,
        text: "When were you diagnosed with diabetes?",
        answer: "",
        additionalComment: "Diabetes diagnosis timeline.",
        subQuestions: [],
      },
      {
        id: 1302,
        text: "Do you use insulin for your diabetes?",
        answer: "",
        additionalComment: "Insulin dependency.",
        subQuestions: [],
      },
      {
        id: 1303,
        text: "What is your estimated hemoglobin A1C level?",
        answer: "",
        additionalComment: "Hemoglobin A1C status.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 14,
    text: "Anxiety, depression, nervousness, other mental health problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1401,
        text: "Do you currently have ADHD or ADD?",
        answer: "",
        additionalComment: "Presence of ADHD/ADD.",
        subQuestions: [],
      },
      {
        id: 1402,
        text: "Do you currently have a diagnosis of depression?",
        answer: "",
        additionalComment: "Depression diagnosis.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 15,
    text: "Fainting or passing out",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1501,
        text: "Was there a known cause for your fainting episodes?",
        answer: "",
        additionalComment: "Cause of fainting.",
        subQuestions: [],
      },
      {
        id: 1502,
        text: "Have you been evaluated by a healthcare provider for this condition?",
        answer: "",
        additionalComment: "Evaluation for fainting.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 16,
    text: "Dizziness, headaches, numbness, tingling, or memory loss",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1601,
        text: "Are your headaches associated with any other medical conditions?",
        answer: "",
        additionalComment: "Headaches linked to other conditions.",
        subQuestions: [],
      },
      {
        id: 1602,
        text: "Do you have visual disturbances associated with the headaches?",
        answer: "",
        additionalComment: "Vision issues with headaches.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 17,
    text: "Unexplained weight loss",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 18,
    text: "Stroke, mini-stroke (TIA), paralysis, or weakness",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1801,
        text: "Did your stroke or hemorrhage occur more than 5 years ago?",
        answer: "",
        additionalComment: "Stroke timeline.",
        subQuestions: [],
      },
      {
        id: 1802,
        text: "Are you taking any blood thinners after the stroke?",
        answer: "",
        additionalComment: "Use of blood thinners.",
        subQuestions: [],
      },
      {
        id: 1803,
        text: "Have you seen a neurologist in the last 12 months?",
        answer: "",
        additionalComment: "Neurologist follow-up status.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 19,
    text: "Missing or limited use of arm, hand, finger, leg, foot, toe",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1901,
        text: "Do you have a skilled performance evaluation (SPE) exemption for a missing or functionally limited body part?",
        answer: "",
        additionalComment: "SPE exemption status.",
        subQuestions: [],
      },
      {
        id: 1902,
        text: "Have you been safely driving with the impairment?",
        answer: "",
        additionalComment: "Driving safety with impairment.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 20,
    text: "Neck or back problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 21,
    text: "Bone, muscle, joint, or nerve problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 22,
    text: "Blood clots or bleeding problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 2201,
        text: "Do you currently have a blood clot in your leg or arm?",
        answer: "",
        additionalComment: "Active blood clot.",
        subQuestions: [],
      },
      {
        id: 2202,
        text: "Are you currently taking a blood thinner for the blood clot?",
        answer: "",
        additionalComment: "Blood thinner usage.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 23,
    text: "Cancer",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 24,
    text: "Chronic (long-term) infection or other chronic diseases",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 25,
    text: "Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 2501,
        text: "Do you have a new diagnosis of sleep apnea (within the last 12 months)?",
        answer: "",
        additionalComment: "Recent sleep apnea diagnosis.",
        subQuestions: [],
      },
      {
        id: 2502,
        text: "Have you seen a sleep specialist or primary care provider in the last 12 months regarding your sleep apnea?",
        answer: "",
        additionalComment: "Sleep specialist follow-up.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 26,
    text: "Have you ever had a sleep test (e.g., sleep apnea)?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 27,
    text: "Have you ever spent a night in the hospital?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 28,
    text: "Have you ever had a broken bone?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 29,
    text: "Have you ever used or do you now use tobacco?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 30,
    text: "Do you currently drink alcohol?",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 3001,
        text: "Do you have a current or previous diagnosis of alcoholism?",
        answer: "",
        additionalComment: "Alcoholism history.",
        subQuestions: [],
      },
      {
        id: 3002,
        text: "Are you currently enrolled in a self-help program such as Alcoholics Anonymous?",
        answer: "",
        additionalComment: "Enrollment in AA.",
        subQuestions: [],
      },
    ],
  },
  {
    id: 31,
    text: "Have you used an illegal substance within the past two years?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 32,
    text: "Have you ever failed a drug test or been dependent on an illegal substance?",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 3201,
        text: "Are you currently taking any medications to treat your alcohol or drug addiction?",
        answer: "",
        additionalComment: "Addiction treatment medication.",
        subQuestions: [],
      },
      {
        id: 3202,
        text: "Are you currently or have you ever been enrolled in a substance abuse program (SAP)?",
        answer: "",
        additionalComment: "Substance abuse program history.",
        subQuestions: [],
      },
    ],
  },
];
export const questionnaireDataQuestions: Question[] = [
  {
    id: 1,
    text: "Head/brain injuries or illnesses (e.g., concussion)",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 1_1,
        text: `Syncope ("passing out" or "loss of consciousness")`,
        answer: "",
        additionalComment: "Known cause for fainting.",
        subQuestions: [
          {
            id: 1_1_1,
            text: "Was there a known cause for your loss of consciousness?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_1_2,
            text: "Did you have a single episode?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_1_3,
            text: "Do you currently have episodes of loss of consciousness?",
            answer: "",
            additionalComment: "Recurring fainting episodes.",
            subQuestions: [],
          },
          {
            id: 1_1_4,
            text: "Have you ever been evaluated by a cardiologist or neurologist for this condition?",
            answer: "",
            additionalComment: "Evaluated by specialist.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 1_2,
        text: `Traumatic Brain Injury`,
        answer: "",
        additionalComment: "Known cause for fainting.",
        subQuestions: [
          {
            id: 1_2_1,
            text: "Did the TBI occur over 5 years ago?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_2_2,
            text: "Did you experience seizures as a result of the head injury?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_2_3,
            text: "Do you currently have seizures",
            answer: "",
            additionalComment: "Recurring fainting episodes.",
            subQuestions: [],
          },
          {
            id: 1_2_4,
            text: "Are you currently taking medications to prevent seizures?",
            answer: "",
            additionalComment: "Evaluated by specialist.",
            subQuestions: [],
          },
          {
            id: 1_2_5,
            text: "Have you seen a neurologist in the last 12 months?",
            answer: "",
            additionalComment: "Evaluated by specialist.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 1_3,
        text: `Headaches`,
        answer: "",
        additionalComment: "Known cause for fainting.",
        subQuestions: [
          {
            id: 1_3_1,
            text: "Are your headaches associated with any other medical conditions?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_3_2,
            text: "Have you ever had a motor vehicle accident because of a headache?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_3_3,
            text: "Do you have visual disturbances associated with the headaches?",
            answer: "",
            additionalComment: "Recurring fainting episodes.",
            subQuestions: [],
          },
          {
            id: 1_3_4,
            text: "If taking medications for headache, do you have any side effects?",
            answer: "",
            additionalComment: "Evaluated by specialist.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 1_4,
        text: `Stoke (regular or mini) and brain bleeding (intracerebral/subarachnoid hemorrhages)`,
        answer: "",
        additionalComment: "Known cause for fainting.",
        subQuestions: [
          {
            id: 1_4_1,
            text: "Did you have a stroke or a hemorrhage (brain bleed) without stroke?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_4_2,
            text: "Did your stroke or hemorrhage occur more than 5 years ago?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_4_3,
            text: "Do you have any disabilities as a result of the stroke or brain bleed?",
            answer: "",
            additionalComment: "Recurring fainting episodes.",
            subQuestions: [],
          },
          {
            id: 1_4_4,
            text: "Have you seen a neurologist in the last 12 months?",
            answer: "",
            additionalComment: "Evaluated by specialist.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 1_5,
        text: `Vertigo (Dizziness)`,
        answer: "",
        additionalComment: "Known cause for fainting.",
        subQuestions: [
          {
            id: 1_5_1,
            text: "Do you currently have vertigo or dizziness?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_5_2,
            text: "Have you been asymptomatic (without vertigo) for at least 2 months?",
            answer: "",
            additionalComment: "Single fainting episode.",
            subQuestions: [],
          },
          {
            id: 1_5_3,
            text: "Are you currently taking medications for dizziness?",
            answer: "",
            additionalComment: "Recurring fainting episodes.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    text: "Seizures, epilepsy",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 2_1,
        text: "Seizures",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 2_1_1,
            text: "Was your last seizure less than 5 years ago and have you remained asymptomatic since then?",
            answer: "",
            additionalComment: "Recent seizure history.",
            subQuestions: [],
          },
          {
            id: 2_1_2,
            text: "Did you have more than one seizure?",
            answer: "",
            additionalComment: "Multiple seizures.",
            subQuestions: [],
          },
          {
            id: 2_1_3,
            text: "Was the seizure due to a head injury (traumatic brain injury), surgery, bleeding (intracranial hemorrhage), or stroke?",
            answer: "",
            additionalComment: "Seizure linked to injury.",
            subQuestions: [],
          },
          {
            id: 2_1_4,
            text: "Was your seizure due to metabolic illness?",
            answer: "",
            additionalComment: "Seizure due to metabolic illness.",
            subQuestions: [],
          },
          {
            id: 2_1_5,
            text: 'Was your seizure a "one time childhood seizure" with/without known cause?',
            answer: "",
            additionalComment: "Childhood seizure.",
            subQuestions: [],
          },
          {
            id: 2_1_6,
            text: "Are you currently taking medications to prevent more seizures?",
            answer: "",
            additionalComment: "Seizure medication use.",
            subQuestions: [],
          },
          {
            id: 2_1_7,
            text: "Do you have any residual neurologic deficits (permanent impairments because of seizures)?",
            answer: "",
            additionalComment: "Neurological impairments.",
            subQuestions: [],
          },
          {
            id: 2_1_8,
            text: "Do you see a neurologist regularly (annually, biennially)?",
            answer: "",
            additionalComment: "Regular neurologist visits.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 2_2,
        text: "Epilepsy",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 2_2_1,
            text: "Did your epilepsy resolve and have you been off of all seizure medications, at minimum, 10 years ago?",
            answer: "",
            additionalComment: "Epilepsy resolution timeline.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    text: "Eye problems (except glasses or contacts)",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 4,
    text: "Ear and/or hearing problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 5,
    text: "Heart disease, heart attack, bypass, or other heart problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 5_1,
        text: "Atrial fibrillation",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 5_1_1,
            text: "Are you currently being treated for A. Fib?",
            answer: "",
            additionalComment: "Atrial fibrillation treatment status.",
            subQuestions: [],
          },
          {
            id: 5_1_2,
            text: "When were you diagnosed with A. Fib?",
            answer: "",
            options: ["Less than 1 month ago", "More than 1 month ago"],
            additionalComment: "A. Fib diagnosis timeline.",
            subQuestions: [],
          },
          {
            id: 5_1_3,
            text: "Are you using Coumadin (warfarin) as a blood thinner to treat A. Fib?",
            answer: "",
            additionalComment: "Blood thinner usage for A. Fib.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 5_2,
        text: "Myocardial Infarction (heart attack) or Coronary Artery Disease (CAD) with elective stenting",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 5_2_1,
            text: "Elective stenting (non-emergent scheduled procedure) or stenting after Myocardial Infarction (heart attack)",
            answer: "",
            options: [
              "Elective (non-emergent)",
              "Myocardial Infarction (emergency)",
            ],
            additionalComment: "Stenting type.",
            subQuestions: [],
          },
          {
            id: 5_2_2,
            text: "When did you have a stent placed because of coronary artery disease (CAD)?",
            answer: "",
            options: ["Less than 1 week ago", "More than 1 week ago"],
            additionalComment: "Stent placement timeline.",
            subQuestions: [],
          },
          {
            id: 5_2_3,
            text: "Do you currently have any symptoms that may be related to your heart? (Chest pain, neck pain, or arm pain. Shortness of breath at rest, when lying down, or with exercise)",
            answer: "",
            additionalComment: "Heart-related symptoms.",
            subQuestions: [],
          },
          {
            id: 5_2_4,
            text: "Do you currently use nitroglycerin (nitro) more frequently than you previously did?",
            answer: "",
            additionalComment: "Increased nitro use.",
            subQuestions: [],
          },
          {
            id: 5_2_5,
            text: "Have there been any cardiac changes since your heart attack or elective stenting?",
            answer: "",
            additionalComment: "Post-stenting cardiac changes.",
            subQuestions: [],
          },
          {
            id: 5_2_6,
            text: "Have you completed cardiac testing in the last 2 years (stress test, echocardiogram)?",
            answer: "",
            additionalComment: "Recent cardiac testing status.",
            subQuestions: [],
          },
          {
            id: 5_2_7,
            text: "Has your cardiologist or primary provider medically cleared you to operate a commercial vehicle since the heart attack or elective stenting?",
            answer: "",
            additionalComment: "Medical clearance status.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 5_3,
        text: "Heart murmur (abnormal heart valve sound)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 5_3_1,
            text: "Do you have a benign heart murmur or a murmur that has been present since childhood?",
            answer: "",
            additionalComment: "Childhood murmur presence.",
            subQuestions: [],
          },
          {
            id: 5_3_2,
            text: "Do you currently have symptoms relating to your heart?",
            answer: "",
            additionalComment: "Heart-related symptoms.",
            subQuestions: [],
          },
          {
            id: 5_3_3,
            text: "Did you have surgery on one or more heart valves?",
            answer: "",
            additionalComment: "Heart valve surgery status.",
            subQuestions: [],
          },
          {
            id: 5_3_4,
            text: "When did you have surgery?",
            answer: "",
            options: [
              "Less than 1 month ago",
              "More than 1 month ago but less than 3 months",
              "More than 3 months ago",
            ],
            additionalComment: "Heart valve surgery timeline.",
            subQuestions: [],
          },
          {
            id: 5_3_5,
            text: "Do you take blood thinners because of a heart valve?",
            answer: "",
            additionalComment: "Blood thinner use.",
            subQuestions: [],
          },
          {
            id: 5_3_6,
            text: "Have you developed any blood clotting problems because of the heart valve?",
            answer: "",
            additionalComment: "Blood clot issues.",
            subQuestions: [],
          },
          {
            id: 5_3_7,
            text: "Have you completed an echocardiogram because of the heart valve?",
            answer: "",
            additionalComment: "Heart valve echocardiogram.",
            subQuestions: [],
          },
          {
            id: 5_3_8,
            text: "Have you had a chest x-ray because of the heart valve in the last 12 months?",
            answer: "",
            additionalComment: "Heart valve chest x-ray status.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 5_4,
        text: "Heart transplant",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 5_4_1,
            text: "When was your heart transplant surgery?",
            answer: "",
            options: ["Less than 12 months ago", "More than 12 months ago"],
            additionalComment: "Heart transplant timeline.",
            subQuestions: [],
          },
          {
            id: 5_4_2,
            text: "Do you have any restrictions from your surgeon or cardiologist relating to your heart?",
            answer: "",
            additionalComment: "Post-transplant restrictions.",
            subQuestions: [],
          },
          {
            id: 5_4_3,
            text: "Do you have any symptoms that you think could be related to your heart?",
            answer: "",
            additionalComment: "Heart-related symptoms.",
            subQuestions: [],
          },
          {
            id: 5_4_4,
            text: "Have you seen the surgeon who performed your operation or a cardiologist in the last 6 months?",
            answer: "",
            additionalComment: "Follow-up visit status.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 5_5,
        text: "Coronary Artery Bypass Graft (CABG aka heart bypass)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 5_5_1,
            text: "When was your heart bypass surgery?",
            answer: "",
            options: [
              "Less than 3 months ago",
              "More than 3 months ago, but less than 5 years",
              "More than 5 years ago",
            ],
            additionalComment: "CABG timeline.",
            subQuestions: [],
          },
          {
            id: 5_5_2,
            text: "Do you have any restrictions from your surgeon relating to heart disease or bypass?",
            answer: "",
            additionalComment: "Post-surgery restrictions.",
            subQuestions: [],
          },
          {
            id: 5_5_3,
            text: "Do you have dizziness when you stand up or feel that your heartbeat is different or irregular (something out of the ordinary)?",
            answer: "",
            additionalComment: "Heart function symptoms.",
            subQuestions: [],
          },
          {
            id: 5_5_4,
            text: "Are you tolerating cardiac medications without side effects?",
            answer: "",
            additionalComment: "Medication tolerance.",
            subQuestions: [],
          },
          {
            id: 5_5_5,
            text: "Have you been seen by the surgeon who performed your operation or a cardiologist in the last 1-2 years?",
            answer: "",
            additionalComment: "Follow-up visit status.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 6,
    text: "Pacemaker, stents, implantable devices, or other heart procedures",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 6_1,
        text: "Implantable defibrillator/pacemaker combination",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_1_1,
            text: "Do you currently have a combination device (defibrillator/pacemaker) in place?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_2,
        text: "Implantable cardiac defibrillator (ICD)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_2_1,
            text: "Do you currently have a defibrillator?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_3,
        text: "Pacemaker",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_3_1,
            text: "When was your pacemaker implanted?",
            answer: "",
            options: [
              "Less than 1 month ago",
              "More than 1 month ago but less than 3 months ago",
              "More than 3 months ago",
            ],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_3_2,
            text: "Do you have regular function checks to ensure that the pacemaker is still working properly?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_3_3,
            text: "Do you have medical clearance to operate a commercial vehicle since the pacemaker was placed?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_4,
        text: "Atrial fibrillation",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_4_1,
            text: "Are you currently being treated for A. Fib?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_4_2,
            text: "When were you diagnosed with A. Fib?",
            answer: "",
            options: ["Less than 1 month ago", "More than 1 month ago"],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_4_3,
            text: "Are you using Coumadin (warfarin) as a blood thinner to treat A. Fib?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_5,
        text: "Myocardial Infarction (heart attack) with emergent stenting or Coronary Artery Disease (non-heart attack) with elective stenting (scheduled procedure)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_5_1,
            text: "Elective stenting (non-emergent scheduled procedure) or stenting after Myocardial Infarction (heart attack)",
            answer: "",
            options: [
              "Elective (non-emergent)",
              "Myocardial Infarction (emergency)",
            ],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_5_2,
            text: "When did you have a stent placed because of coronary artery disease (CAD)?",
            answer: "",
            options: ["Less than 1 week ago", "More than 1 week ago"],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_5_3,
            text: "Do you currently have any of the following symptoms that may be related to your heart? (Chest pain, neck pain, or arm pain. Shortness of breath at rest, when lying down, or with exercise)",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_5_4,
            text: "Do you currently use nitroglycerin (nitro) more frequently than you previously did?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_5_5,
            text: "Have there been any cardiac changes since your heart attack or elective stenting?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_5_6,
            text: "Have you completed cardiac testing in last 2 years (stress test, echocardiogram)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_5_7,
            text: "Has your cardiologist or primary provider medically cleared you to operate a commercial vehicle since the heart attack or elective stenting?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_6,
        text: "Heart murmur (abnormal heart valve sound)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_6_1,
            text: "Do you have a benign heart murmur or a murmur that has been present since childhood?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_2,
            text: "Do you currently have symptoms relating to your heart?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_3,
            text: "Did you have surgery on one or more heart valves?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_4,
            text: "When did you have surgery?",
            answer: "",
            options: [
              "Less than 1 month ago",
              "More than 1 month ago, but less than 3 months",
              "More than 3 months ago",
            ],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_5,
            text: "Was surgery for a heart valve recommended?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_6,
            text: "Do you take blood thinners because of a heart valve?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_7,
            text: "Have you developed any blood clotting problems because of the heart valve?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_8,
            text: "Have you completed an echocardiogram because of the heart valve?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_6_9,
            text: "Have you had a chest x-ray because of the heart valve in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_7,
        text: "Heart transplant",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_7_1,
            text: "When was your heart transplant surgery?",
            answer: "",
            options: ["Less than 12 months ago", "More than 12 months ago"],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_7_2,
            text: "Do you have any restrictions from your surgeon or cardiologist relating to your heart?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_7_3,
            text: "Do you have any symptoms that you think could be related to your heart?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_7_4,
            text: "Have you seen the surgeon who performed your operation or a cardiologist in the last 6 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 6_8,
        text: "Coronary Artery Bypass Graft (CABG aka heart bypass)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 6_8_1,
            text: "When was your heart bypass surgery?",
            answer: "",
            options: [
              "Less than 3 months ago",
              "More than 3 months ago, but less than 5 years",
              "More than 5 years ago",
            ],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_8_2,
            text: "Do you have any restrictions from your surgeon relating to heart disease or bypass?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_8_3,
            text: "Do you have dizziness when you stand up or feel that your heartbeat is different or irregular (something out of the ordinary)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_8_4,
            text: "Are you tolerating cardiac medications without side effects?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 6_8_5,
            text: "Have you been seen by the surgeon who performed your operation or a cardiologist in the last 1-2 years?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 7,
    text: "High blood pressure",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 7_1,
        text: "Hypertension (High Blood Pressure)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 7_1_1,
            text: "Is your blood pressure less than or equal to 140/90 today?",
            answer: "",
            additionalComment: "Current blood pressure level.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 8,
    text: "High cholesterol",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 9,
    text: "Chronic (long-term) cough, shortness of breath, or other breathing problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 9_1,
        text: "Pneumothorax (collapsed lung – various types)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 9_1_1,
            text: "Has this happened more than once?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_1_2,
            text: "Was a chest x-ray performed once you felt better and the collapsed lung resolved?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_1_3,
            text: "Did you complete a pulmonary function test (breathing test) after the collapsed lung resolved?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_1_4,
            text: "Have you ever coughed forcefully enough to pass out because of the collapsed lung?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_1_5,
            text: "Do you have work restrictions due to the collapsed lung?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 9_2,
        text: "Pulmonary embolism aka 'PE' (blood clot in the lung)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 9_2_1,
            text: "When did this occur?",
            answer: "",
            options: ["Less than 3 months ago", "More than 3 months ago"],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_2_2,
            text: "Are you currently taking a blood thinner for this condition?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_2_3,
            text: "Do you currently or have you recently experienced any of the following symptoms as a result of the pulmonary embolism? (Chest pain, shortness of breath, cough, lightheadedness, fast heart rate, fast breathing)",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_2_4,
            text: "Did your treating provider clear you to drive a commercial vehicle without restrictions after the pulmonary embolism resolved?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 9_3,
        text: "Chronic Obstructive Pulmonary Disease (COPD)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 9_3_1,
            text: "Do you have sedentary and/or activity limiting shortness of breath due to COPD?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_3_2,
            text: "Have you ever lost consciousness (passed out) due to coughing?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 9_3_3,
            text: "Do you currently use oxygen for COPD?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 10,
    text: "Lung disease (e.g., asthma)",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 10_1,
        text: "Asthma",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 10_1_1,
            text: "Do you feel that your asthma is well controlled?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_1_2,
            text: "Do you have worsening shortness of breath, coughing, or times you pass out after forceful coughing?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_1_3,
            text: "Have you completed a pulmonary function test (breathing test) in the last 1-2 years to determine the severity or changes of your asthma?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 10_2,
        text: "Cystic Fibrosis (CF)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 10_2_1,
            text: "Do you currently experience shortness of breath related to cystic fibrosis?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_2_2,
            text: "Have you ever coughed forcefully enough to lose consciousness (pass out) because of CF?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_2_3,
            text: "Do you see a medical provider annually for the CF?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 10_3,
        text: "Tuberculosis (TB)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 10_3_1,
            text: "Do you currently have active TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_3_2,
            text: "Are you currently taking medications for TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_3_3,
            text: "Do you currently have weakness or fatigue as a result of TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 10_3_4,
            text: "Has your balance or hearing worsened since being diagnosed with TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 11,
    text: "Kidney problems, kidney stones, or pain/problems with urination",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 11_1,
        text: "Nephropathy (Kidney disease)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 11_1_1,
            text: "Do you currently have any of the following symptoms, not related to any other medical conditions? (Fatigue, daytime sleepiness, difficulty with concentration, slow thoughts, trouble remembering, low blood sugar, morning sickness, nausea, vomiting, leg or ankle swelling, decreased urination)",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 11_1_2,
            text: "Are you currently being treated with dialysis?",
            answer: "",
            additionalComment: "Dialysis treatment status.",
            subQuestions: [],
          },
          {
            id: 11_1_3,
            text: "Did you have a kidney transplant?",
            answer: "",
            additionalComment: "Kidney transplant history.",
            subQuestions: [],
          },
          {
            id: 11_1_4,
            text: "Have you completed lab work within the last 12 months to evaluate your kidney function?",
            answer: "",
            additionalComment: "Kidney function testing status.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 12,
    text: "Stomach, liver, or digestive problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 12_1,
        text: "Abdominal Aortic Aneurysm (AAA)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 12_1_1,
            text: "Have you had surgery for the AAA?",
            answer: "",
            additionalComment: "AAA surgery history.",
            subQuestions: [],
          },
          {
            id: 12_1_2,
            text: "Within the last 12 months have you had an abdominal ultrasound?",
            answer: "",
            additionalComment: "Abdominal ultrasound status.",
            subQuestions: [],
          },
          {
            id: 12_1_3,
            text: "Do you have medical records pertaining to the aneurysm and surgery?",
            answer: "",
            additionalComment: "Medical records availability.",
            subQuestions: [],
          },
          {
            id: 12_1_4,
            text: "Are you currently taking medications for the aneurysm?",
            answer: "",
            additionalComment: "Aneurysm medication use.",
            subQuestions: [],
          },
          {
            id: 12_1_5,
            text: "Do you have medical clearance from the specialist or surgeon who manages your aneurysm?",
            answer: "",
            additionalComment: "Specialist clearance for AAA.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 12_2,
        text: "Thoracic Aneurysm",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 12_2_1,
            text: "Have you had surgery for the thoracic aneurysm?",
            answer: "",
            additionalComment: "Thoracic aneurysm surgery history.",
            subQuestions: [],
          },
          {
            id: 12_2_2,
            text: "In the last 12 months, have you had a thoracic ultrasound (chest ultrasound)?",
            answer: "",
            additionalComment: "Thoracic ultrasound status.",
            subQuestions: [],
          },
          {
            id: 12_2_3,
            text: "Do you have medical records pertaining to the aneurysm and surgery?",
            answer: "",
            additionalComment: "Medical records availability.",
            subQuestions: [],
          },
          {
            id: 12_2_4,
            text: "Are you currently taking medications for the aneurysm?",
            answer: "",
            additionalComment: "Aneurysm medication use.",
            subQuestions: [],
          },
          {
            id: 12_2_5,
            text: "Do you have medical clearance from the specialist or surgeon who manages your aneurysm?",
            answer: "",
            additionalComment: "Specialist clearance for thoracic aneurysm.",
            subQuestions: [],
          },
        ],
      },
      {
        id: 12_3,
        text: "Hernia",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 12_3_1,
            text: "Do you have a hernia now?",
            answer: "",
            additionalComment: "Current hernia status.",
            subQuestions: [],
          },
          {
            id: 12_3_2,
            text: "Does the hernia cause pain or discomfort?",
            answer: "",
            additionalComment: "Hernia-related discomfort.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 13,
    text: "Diabetes or blood sugar problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 13_1,
        text: "Diabetes",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 13_1_1,
            text: "When were you diagnosed with diabetes?",
            answer: "",
            options: [
              "Less than 1 month ago",
              "More than 1 month ago, but less than 2 months",
              "More than 2 months ago",
            ],
            additionalComment: "Time since diabetes diagnosis.",
            subQuestions: [],
          },
          {
            id: 13_1_2,
            text: "Do you have a state waiver or federal exemption for insulin use?",
            answer: "",
            additionalComment: "State waiver or federal exemption status.",
            subQuestions: [],
          },
          {
            id: 13_1_3,
            text: "What is your estimated hemoglobin A1C level?",
            answer: "",
            options: ["More than 10%", "Less than 10%"],
            additionalComment: "Estimated hemoglobin A1C level.",
            subQuestions: [],
          },
          {
            id: 13_1_4,
            text: "Have you seen your diabetes doctor in the last 12 months?",
            answer: "",
            additionalComment: "Diabetes doctor visit status.",
            subQuestions: [],
          },
          {
            id: 13_1_5,
            text: "Did you have an ophthalmology (eye doctor) examination within the last 12 months?",
            answer: "",
            additionalComment: "Ophthalmology exam status.",
            subQuestions: [],
          },
          {
            id: 13_1_6,
            text: "In the last 12 months, have you had a hypoglycemic episode (extremely low blood sugar)?",
            answer: "",
            additionalComment:
              "Hypoglycemic episode history within the last 12 months.",
            subQuestions: [],
          },
          {
            id: 13_1_7,
            text: "In the last 5 years, have you had 2 or more hypoglycemic episodes (extremely low blood sugar)?",
            answer: "",
            additionalComment:
              "Hypoglycemic episode history within the last 5 years.",
            subQuestions: [],
          },
          {
            id: 13_1_8,
            text: "Do you have any loss of sensation (feeling) in your feet?",
            answer: "",
            additionalComment: "Loss of sensation in feet status.",
            subQuestions: [],
          },
          {
            id: 13_1_9,
            text: "Have you ever lost consciousness (passed out) while moving from a sitting to standing position?",
            answer: "",
            additionalComment:
              "Loss of consciousness during positional change.",
            subQuestions: [],
          },
          {
            id: 13_1_10,
            text: "Do you use insulin for your diabetes?",
            answer: "",
            additionalComment: "Insulin use for diabetes.",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 14,
    text: "Anxiety, depression, nervousness, other mental health problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 14_1,
        text: "Adult Attention Deficit Hyperactivity Disorder (ADHD) and Attention Deficit Disorder (ADD)?",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 14_1_1,
            text: "Do you currently have ADHD or ADD?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_1_2,
            text: "Are you currently taking medications for ADHD or ADD?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_1_3,
            text: "Have you seen your primary care provider or psychiatrist who treats you for ADHD or ADD in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 14_2,
        text: "Schizophrenia and related psychotic disorders",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 14_2_1,
            text: "Is your schizophrenia a chronic (ongoing) condition?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_2_2,
            text: "Have you been asymptomatic for the last 12 months? Common symptoms include: Compromised judgement, Difficulty with attention, Suicidal behavior or thoughts, Inappropriate acts",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_2_3,
            text: "If you are currently taking medications to treat schizophrenia, do you have side effects from the medication?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_2_4,
            text: "Have you been seen by your treating provider in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_2_5,
            text: "Have you seen a mental health specialist such as a psychiatrist or psychologist in the last 2 years?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 14_3,
        text: "Bipolar Mood Disorder",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 14_3_1,
            text: "In the last 12 months, have you been asymptomatic in regards to your bipolar mood? Common symptoms include: Depression, Suicidal behavior, Suicide attempt, Manic episode",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_3_2,
            text: "If you are currently taking medications for bipolar mood disorder, do you have side effects from the medication?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_3_3,
            text: "Have you been seen by your treating provider in the last 12 months (the one who treats bipolar)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_3_4,
            text: "Have you seen a mental health specialist such as a psychiatrist or psychologist in the last 2 years?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 14_4,
        text: "Depression",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 14_4_1,
            text: "Do you currently have a diagnosis of depression?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_4_2,
            text: "Have you been asymptomatic for the last 12 months? Common symptoms include: Depression, Suicidal behavior, Suicide attempt, Manic episode",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_4_3,
            text: "If you are currently taking medications for depression, do you have side effects from the medication?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_4_4,
            text: "Have you seen your primary care provider in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_4_5,
            text: "Have you seen a mental health specialist such as a psychiatrist or psychologist in the last 2 years?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 14_5,
        text: "Personality Disorders",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 14_5_1,
            text: "Do you currently have a diagnosis of a personality disorder (for example, anti-social, borderline, histrionic, narcissistic, avoidant, obsessive-compulsive, or other)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_5_2,
            text: "Have you been asymptomatic for the last 12 months? Common symptoms include: Compromised judgement, Attention difficulty, Suicidal behavior, Inappropriate acts",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_5_3,
            text: "If you are currently taking medications for a personality disorder, do you have side effects from the medication?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_5_4,
            text: "Have you been seen by your treating provider in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 14_5_5,
            text: "Have you seen a mental health specialist such as a psychiatrist or psychologist in the last 2 years?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 15,
    text: "Fainting or passing out",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 15_1,
        text: "Vertigo (Dizziness)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 15_1_1,
            text: "Do you currently have vertigo or dizziness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_1_2,
            text: "Have you been asymptomatic (without vertigo) for at least 2 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_1_3,
            text: "Are you currently taking medications for dizziness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 15_2,
        text: "Traumatic Brain Injury (TBI)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 15_2_1,
            text: "Did the TBI occur over 5 years ago?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_2_2,
            text: "Did you experience seizures as a result of the head injury?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_2_3,
            text: "Do you currently have seizures?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_2_4,
            text: "Are you currently taking medications to prevent seizures?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_2_5,
            text: "Have you seen a neurologist in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 15_3,
        text: "Diabetes (Hypoglycemia-related questions only)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 15_3_1,
            text: "In the last 12 months, have you had a hypoglycemic episode (extremely low blood sugar)? The FMCSA defines a hypoglycemic episode as one or more of the following: Seizure, Loss of consciousness, Need of assistance from another person, Period of impaired cognitive function that occurred without warning.",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_3_2,
            text: "In the last 5 years, have you had 2 or more hypoglycemic episodes (extremely low blood sugar)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_3_3,
            text: "Do you have any loss of sensation (feeling) in your feet?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_3_4,
            text: "Have you ever lost consciousness (passed out) while moving from a sitting to standing position?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 15_4,
        text: "Syncope ('passing out' or 'loss of consciousness')",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 15_4_1,
            text: "Was there a known cause for your loss of consciousness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_4_2,
            text: "Did you have a single episode?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_4_3,
            text: "Do you currently have episodes of loss of consciousness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 15_4_4,
            text: "Have you ever been evaluated by a cardiologist or neurologist for this condition?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 16,
    text: "Dizziness, headaches, numbness, tingling, or memory loss",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 16_1,
        text: "Central nervous system tumor (brain tumor)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 16_1_1,
            text: "Do you currently have a brain tumor or metastasis to the brain?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_1_2,
            text: "Is surgery planned or previously performed to remove the tumor?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_1_3,
            text: "Are you currently receiving chemotherapy and/or radiation?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 16_2,
        text: "Vertigo (Dizziness)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 16_2_1,
            text: "Do you currently have vertigo or dizziness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_2_2,
            text: "Have you been asymptomatic (without vertigo) for at least 2 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_2_3,
            text: "Are you currently taking medications for dizziness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 16_3,
        text: "Headaches",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 16_3_1,
            text: "Are your headaches associated with any other medical conditions?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_3_2,
            text: "Have you ever had a motor vehicle accident because of a headache?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_3_3,
            text: "Do you have visual disturbances associated with the headaches?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_3_4,
            text: "If taking medications for headaches, do you have any side effects?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 16_4,
        text: "Traumatic Brain Injury (TBI)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 16_4_1,
            text: "Did the TBI occur over 5 years ago?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_4_2,
            text: "Did you experience seizures as a result of the head injury?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_4_3,
            text: "Do you currently have seizures?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_4_4,
            text: "Are you currently taking medications to prevent seizures?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_4_5,
            text: "Have you seen a neurologist in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 16_5,
        text: "Diabetes (Hypoglycemia-related only)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 16_5_1,
            text: "In the last 12 months, have you had a hypoglycemic episode (extremely low blood sugar)? The FMCSA defines a hypoglycemic episode as one or more of the following: Seizure, Loss of consciousness, Need of assistance from another person, Period of impaired cognitive function that occurred without warning.",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_5_2,
            text: "In the last 5 years, have you had 2 or more hypoglycemic episodes (extremely low blood sugar)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_5_3,
            text: "Do you have any loss of sensation (feeling) in your feet?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_5_4,
            text: "Have you ever lost consciousness (passed out) while moving from a sitting to standing position?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 16_6,
        text: "Tuberculosis (TB)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 16_6_1,
            text: "Do you currently have active TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_6_2,
            text: "Are you currently taking medications for TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_6_3,
            text: "Do you have shortness of breath since being diagnosed with TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_6_4,
            text: "Do you currently have weakness or fatigue as a result of TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 16_6_5,
            text: "Has your balance or hearing worsened since being diagnosed with TB?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 17,
    text: "Unexplained weight loss",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 18,
    text: "Stroke, mini-stroke (TIA), paralysis or weakness",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 18_1,
        text: "Seizures",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 18_1_1,
            text: "Was your last seizure less than 5 years ago and have you remained asymptomatic since then?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_2,
            text: "Did you have more than one seizure?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_3,
            text: "Was the seizure due to a head injury (traumatic brain injury), surgery, bleeding (intracranial hemorrhage), or stroke?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_4,
            text: "Was your seizure due to metabolic illness?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_5,
            text: 'Was your seizure a "one time childhood seizure" with/without known cause?',
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_6,
            text: "Are you currently taking medications to prevent more seizures?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_7,
            text: "Do you have any residual neurologic deficits (permanent impairments because of seizures)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_1_8,
            text: "Do you see a neurologist regularly (annually, biennially)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 18_2,
        text: "Myasthenia gravis",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 18_2_1,
            text: "Do you have upper or lower limb weakness as a result of myasthenia gravis?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_2_2,
            text: "Do you have vision changes as a result of myasthenia gravis?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_2_3,
            text: "Are you easily fatigued as a result of myasthenia gravis?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 18_3,
        text: "Stroke (regular or mini) and brain bleeding (intracerebral/subarachnoid hemorrhages)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 18_3_1,
            text: "Did you have a stroke or a hemorrhage (brain bleed) without stroke?",
            answer: "",
            options: ["Stroke", "Hemorrhage not due to stroke"],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_3_2,
            text: "Did your stroke or hemorrhage occur more than 5 years ago?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_3_3,
            text: "Do you have any disabilities as a result of the stroke or brain bleed?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 18_3_4,
            text: "Have you seen a neurologist in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 18_4,
        text: "Muscular Dystrophy",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 18_4_1,
            text: "Have you been evaluated by a neurologist or physiatrist in the last 12 months?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 18_5,
        text: "Epilepsy",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 18_5_1,
            text: "Did your epilepsy resolve and have you been off of all seizure medications, at minimum, 10 years ago?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 19,
    text: "Missing or limited use of arm, hand, finger, leg, foot, or toe",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 19_1,
        text: "Do you have a skilled performance evaluation (SPE) exemption for a missing or functionally limited body part?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 19_2,
        text: "Have you been safely driving with the impairment?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
    ],
  },
  {
    id: 20,
    text: "Neck or back problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 21,
    text: "Bone, muscle, joint, or nerve problems",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 22,
    text: "Blood clots or bleeding problems",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 22_1,
        text: "Deep vein thrombosis (DVT - blood clot in the arm or leg)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 22_1_1,
            text: "Do you currently have a blood clot in your leg or arm?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_1_2,
            text: "Do you have a chronic (ongoing) DVT?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_1_3,
            text: "Are you currently taking a blood thinner for the blood clot?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_1_4,
            text: "I have been taking Coumadin (warfarin) for longer than 1 month and my INR values are between 2.0 – 3.0",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_1_5,
            text: "I have been taking Coumadin (warfarin) for less than 1 month and my INR values are between 2.0 – 3.0",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_1_6,
            text: "I am not taking Coumadin (warfarin), but am taking another blood thinner for the blood clot",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_1_7,
            text: "Has your treating provider medically cleared you to operate a commercial vehicle since the DVT?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 22_2,
        text: "Peripheral Vascular Disease (PVD)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 22_2_1,
            text: "Have you had surgery for peripheral vascular disease?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_2_2,
            text: "Do you have copies of your medical records regarding the peripheral vascular disease?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_2_3,
            text: "Has your treating provider cleared you to operate a commercial vehicle since being treated for peripheral vascular disease?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_2_4,
            text: "How long ago did you have surgery for peripheral vascular disease?",
            answer: "",
            options: ["Less than 3 months ago", "More than 3 months ago"],
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 22_3,
        text: "Pulmonary embolism (PE - blood clot in the lung)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 22_3_1,
            text: "When did this occur?",
            answer: "",
            options: ["Less than 3 months ago", "More than 3 months ago"],
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_3_2,
            text: "Are you currently taking a blood thinner for this condition?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_3_3,
            text: "Do you currently or have you recently experienced any of the following symptoms as a result of the pulmonary embolism? (Chest pain, Shortness of breath, Cough, Lightheadedness, Fast heart rate, Fast breathing)",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_3_4,
            text: "Did you have a pulmonary function test (breathing test) after the blood clot had resolved?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_3_5,
            text: "Did your treating provider clear you to drive a commercial vehicle without restrictions after the pulmonary embolism resolved?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
      {
        id: 22_4,
        text: "Varicose veins (spider veins)",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 22_4_1,
            text: "Do your varicose veins cause discomfort or pain?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 22_4_2,
            text: "Have you had surgery for varicose veins?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 23,
    text: "Cancer",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 23_1,
        text: "Have you been diagnosed with any type of cancer?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_2,
        text: "Are you currently undergoing treatment for cancer (e.g., chemotherapy, radiation, surgery)?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_3,
        text: "Have you completed treatment for cancer?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_4,
        text: "Do you currently experience any symptoms or side effects from cancer or its treatment (e.g., fatigue, nausea, pain)?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_5,
        text: "Has your treating provider cleared you to work or operate a commercial vehicle since your cancer diagnosis or treatment?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_6,
        text: "Are you currently being monitored by an oncologist or another specialist for your cancer?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_7,
        text: "Have you ever experienced a recurrence of cancer after treatment?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
      {
        id: 23_8,
        text: "Was the recurrence successfully treated?",
        answer: "",
        additionalComment: "",
        subQuestions: [],
      },
    ],
  },
  {
    id: 24,
    text: "Chronic (long-term) infection or other chronic diseases",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 25,
    text: "Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 25_1,
        text: "Sleep Apnea",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 25_1_1,
            text: "Do you have a new diagnosis of sleep apnea (within the last 12 months)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 25_1_2,
            text: "Have you seen a sleep specialist or primary care provider in the last 12 months regarding your sleep apnea?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 25_1_3,
            text: "Do you have a compliance data report from your CPAP device?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 26,
    text: "Have you ever had a sleep test (e.g., sleep apnea)?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 27,
    text: "Have you ever spent a night in the hospital?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 28,
    text: "Have you ever had a broken bone?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 29,
    text: "Have you ever used or do you now use tobacco",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 30,
    text: "Do you currently drink alcohol?",
    answer: "",
    additionalComment: "",
    subQuestions: [
      {
        id: 30_1,
        text: "Drug abuse and/or alcoholism",
        answer: "",
        additionalComment: "",
        subQuestions: [
          {
            id: 30_1_1,
            text: "Do you have a current or previous diagnosis of alcoholism?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 30_1_2,
            text: "Are you currently using narcotics (Vicodin, morphine, Percocet, etc.), marijuana, cocaine, or other substances?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 30_1_3,
            text: "Are you currently taking any medications to treat your alcohol or drug addiction?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 30_1_4,
            text: "Do you currently have any side effects from alcohol or drug use (e.g., tremor, restlessness, agitation, headache, or seizure)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 30_1_5,
            text: "Are you currently enrolled in a self-help program such as Alcoholics Anonymous?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
          {
            id: 30_1_6,
            text: "Are you currently or have you ever been enrolled in a substance abuse program (SAP)?",
            answer: "",
            additionalComment: "",
            subQuestions: [],
          },
        ],
      },
    ],
  },
  {
    id: 31,
    text: "Have you used an illegal substance within the past two years?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 32,
    text: "Have you ever failed a drug test or been dependent on an illegal substance?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
  {
    id: 33,
    text: "Do you have any medical issues that have not been mentioned?",
    answer: "",
    additionalComment: "",
    subQuestions: [],
  },
];

export const recommendationData: { [key: string]: Recommendation } = {

  generalHeartCondition: {
    title: "General Heart Condition Reported",
    waitingPeriod: "1 year, pending cardiologist evaluation and clearance.",
    decision:
      "A heart condition has been reported, but no specific disorder was selected. The driver must provide documentation from a specialist (e.g., cardiologist) who understands the demands of commercial driving. Certification depends on the nature, severity, and stability of the condition.",
    maxCertification: "1 year",
    questionIds: [5, 6], // Only parent IDs
  },
  generalNeurologicalIssue: {
    title: "General Neurological Issue Reported",
    waitingPeriod: "1 year, pending neurologist evaluation and clearance.",
    decision:
      "A neurological issue (head/brain, seizure, dizziness) has been reported. A specific condition must be identified. Evaluation and clearance from a neurologist who understands the demands of commercial driving is typically required.",
    maxCertification: "1 year",
    questionIds: [1, 2, 15, 16, 18], // Only parent IDs
  },
  generalBreathingIssue: {
    title: "General Breathing/Lung Issue Reported",
    waitingPeriod: "1-2 years, pending pulmonologist evaluation and PFTs.",
    decision:
      "A breathing or lung issue has been reported. Certification depends on the stability of the condition, pulmonary function test (PFT) results, and whether there is any hypoxemia (low oxygen at rest).",
    maxCertification: "2 years",
    questionIds: [9, 10], // Only parent IDs
  },
  generalDigestiveIssue: {
    title: "General Digestive Issue Reported",
    waitingPeriod: "1 year, pending specialist evaluation.",
    decision: "A stomach, liver, or digestive issue has been reported. The driver must provide documentation from a specialist (e.g., gastroenterologist) to determine certification status.",
    maxCertification: "Varies",
    questionIds: [12], // Only parent ID
  },
  generalMentalHealth: {
    title: "General Mental Health Condition Reported",
    waitingPeriod: "1 year, pending evaluation by a mental health professional.",
    decision:
      "A mental health condition has been reported. Certification depends on the specific diagnosis, stability, and whether any medications or symptoms could interfere with safe driving. A comprehensive evaluation from a mental health professional is often required.",
    maxCertification: "1 year",
    questionIds: [14], // Only parent ID
  },
  generalBloodClotIssue: {
    title: "General Blood Clot/Bleeding Issue Reported",
    waitingPeriod: "1 year, pending specialist evaluation and stable treatment.",
    decision: "A blood clot or bleeding issue has been reported. Specific details are needed to determine certification status, often requiring clearance from a specialist and details on any anticoagulant therapy.",
    maxCertification: "1 year",
    questionIds: [22], // Only parent ID
  },
  generalKidneyIssue: {
    title: "General Kidney Issue Reported",
    waitingPeriod: "1 to 2 years, pending specialist evaluation and lab results.",
    decision: "A kidney problem has been reported. The driver needs to provide documentation regarding kidney function (e.g., lab reports) and clearance from a specialist if necessary.",
    maxCertification: "2 years",
    questionIds: [11], // Only parent ID
  },

  stage1Hypertension: {
    title: "Stage 1 Hypertension",
    waitingPeriod: "No recommended time frame",
    decision:
      "Recommend to certify for 1 year if it's the first examination with stage 1 BP and the driver has no history of hypertension and is not on medication. A one-time, 3-month certificate may be issued for recertification if BP is not below 140/90.",
    maxCertification: "1 year OR one time for 3 months",
    questionIds: [56, 193],
  },
  stage2Hypertension: {
    title: "Stage 2 Hypertension",
    waitingPeriod: "No recommended time frame",
    decision:
      "Recommend a one-time, 3-month certificate. To qualify for a 1-year certificate at follow-up, the driver's BP must be at or below 140/90.",
    maxCertification: "One time for 3 months",
    questionIds: [56, 193],
  },
  stage3Hypertension: {
    title: "Stage 3 Hypertension",
    waitingPeriod: "Not applicable",
    decision:
      "Do not certify a driver with BP in the stage 3 range, regardless of history or treatment. The driver should be advised to seek immediate medical attention.",
    maxCertification: "6 months with history of stage 3 hypertension",
    questionIds: [56, 193],
  },
  anticoagulationTherapy: {
    title: "Anticoagulation Therapy",
    waitingPeriod: "1 month stabilized",
    decision:
      "Certify if the driver is stabilized on medication for at least 1 month, provides INR results at the exam, and has at least monthly INR monitoring.",
    maxCertification: "1 year",
    questionIds: [135, 147, 167, 180, 200, 315, 323, 324, 325, 326, 333],
  },
  abdominalAorticAneurysm: {
    title: "Abdominal Aortic Aneurysm (AAA)",
    waitingPeriod: "3 months for post-surgical repair",
    decision:
      "Certify if AAA is less than 5 cm and asymptomatic. Do not certify if AAA is symptomatic, greater than or equal to 5 cm, or has increased more than 0.5 cm in 6 months.",
    maxCertification: "1 year",
    questionIds: [64, 220, 221, 222, 223, 224],
  },
  thoracicAneurysm: {
    title: "Thoracic Aneurysm",
    waitingPeriod: "3 months post-surgical repair",
    decision:
      "Certify if the aneurysm is less than 3.5 cm or has been surgically repaired. Do not certify if it is greater than 3.5 cm.",
    maxCertification: "1 year",
    questionIds: [65, 225, 226, 227, 228, 229],
  },
  diabetesWithoutInsulin: {
    title: "Diabetes without Insulin",
    waitingPeriod: "No recommended time frame",
    decision:
      "Do not certify if the driver has had a severe low blood sugar reaction within the last year, or two or more in the last 5 years.",
    maxCertification: "Up to 2 years, but FMCSA recommends a maximum of 1 year",
    questionIds: [67, 232, 234, 235, 236, 237, 238, 239, 240, 241, 75, 272, 273, 274, 275, 81, 295, 296, 297, 298],
  },
  diabetesWithInsulin: {
    title: "Diabetes with Insulin",
    waitingPeriod: "1 month if previously on non-insulin treatment; 2 months if newly diagnosed.",
    decision:
      "Certify if the driver meets all other physical requirements and has a Federal diabetes exemption or is eligible to apply.",
    maxCertification: "1 year",
    questionIds: [67, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 75, 272, 273, 274, 275, 81, 295, 296, 297, 298],
  },
  epilepsy: {
    title: "Epilepsy",
    waitingPeriod: "10 years off anticonvulsant medication and seizure free",
    decision: "A driver with an established medical history or clinical diagnosis of epilepsy is generally not qualified.",
    maxCertification: "1 year",
    questionIds: [42, 132, 87, 320],
  },
  acuteSeizures: {
    title: "Acute Seizures – Structural Insult to the Brain",
    waitingPeriod: "Varies from 1 to 5 years seizure-free and off medication depending on the brain insult severity.",
    decision: "Certify only after the required waiting period has been completed seizure-free and with clearance from a neurologist.",
    maxCertification: "1 year",
    questionIds: [41, 124, 125, 126, 127, 128, 129, 130, 131, 83, 304, 305, 306, 307, 308, 309, 310, 311],
  },
  syncope: {
    title: "Syncope",
    waitingPeriod: "Do not certify until the cause is confirmed and treatment is stable.",
    decision: "Certify only if the cause of fainting has been treated and a specialist confirms a low risk of it happening again.",
    maxCertification: "1 year",
    questionIds: [36, 104, 105, 106, 107, 76, 276, 277, 278, 279],
  },
  traumaticBrainInjury: {
    title: "Traumatic Brain Injury (TBI)",
    waitingPeriod: "2 to 5 years seizure-free and off medication depending on severity.",
    decision: "After the required waiting period, certify if all neurological tests are normal and a specialist gives clearance.",
    maxCertification: "1 year or 2 years for mild TBI without early seizures",
    questionIds: [37, 108, 109, 110, 111, 112, 74, 267, 268, 269, 270, 271, 80, 290, 291, 292, 293, 294],
  },
  stroke: {
    title: "Embolic & Thrombotic stroke",
    waitingPeriod: "1 year if not at risk for seizures; 5 years if at risk for seizures.",
    decision: "After the waiting period, certify if a neurologist confirms full recovery and no interfering residuals.",
    maxCertification: "1 year",
    questionIds: [39, 117, 118, 119, 120, 85, 315, 316, 317, 318],
  },
  vertigoAndDizziness: {
    title: "Vertigo & Dizziness",
    waitingPeriod: "2 months asymptomatic for benign positional vertigo or peripheral vestibulopathy.",
    decision: "Certify if the driver has been symptom-free for the required waiting period. Do not certify for conditions like Meniere's disease.",
    maxCertification: "2 years",
    questionIds: [40, 121, 122, 123, 73, 264, 265, 266, 78, 283, 284, 285],
  },
  implantableDefibrillator: {
    title: "Implantable Cardioverter-Defibrillators",
    waitingPeriod: "Not Applicable",
    decision: "Disqualification. Cannot be certified.",
    maxCertification: "Disqualified",
    questionIds: [48, 160, 49, 161],
  },
  pacemaker: {
    title: "Pacemaker",
    waitingPeriod: "1 to 3 months post-implantation, depending on the underlying disease.",
    decision: "Certify if the pacemaker is functioning correctly, has regular checks, and the underlying disease is not disqualifying.",
    maxCertification: "1 year",
    questionIds: [48, 160, 50, 162, 163, 164],
  },
  sleepApnea: {
    title: "Sleep Disorders (Sleep Apnea)",
    waitingPeriod: "No recommended time frame",
    decision: "Drivers at risk may need to be tested. If using a CPAP, the driver must show data proving consistent use (at least 4 hours a night, 70% of the time).",
    maxCertification: "1 year",
    questionIds: [102, 339, 340, 341, 26],
  },
  alcoholism: {
    title: "Alcoholism",
    waitingPeriod: "No recommended time frame",
    decision: "Do not certify if there is a current clinical diagnosis of alcoholism. A driver with a past history can be certified after successful treatment.",
    maxCertification: "2 years",
    questionIds: [30, 103, 342, 344, 345, 346, 347],
  },
  drugAbuse: {
    title: "Drug Abuse",
    waitingPeriod: "No recommended time frame",
    decision: "Do not certify if the driver uses a Schedule I controlled substance or other habit-forming drugs. A driver with a history of drug abuse must complete return-to-duty requirements.",
    maxCertification: "2 years",
    questionIds: [103, 343, 344, 345, 347, 31, 32],
  },
  adultADHD: {
    title: "Adult Attention Deficit Hyperactivity Disorder (ADHD)",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if the driver complies with treatment, tolerates it without disqualifying side effects, and has a comprehensive evaluation from a mental health professional.",
    maxCertification: "1 year",
    questionIds: [68, 242, 243, 244],
  },
  schizophrenia: {
    title: "Schizophrenia & Related Psychotic Disorders",
    waitingPeriod: "6 months to 1 year symptom-free depending on the disorder.",
    decision: "Do not certify a driver with a diagnosis of schizophrenia. For related disorders, certify only after a symptom-free waiting period and with a specialist's clearance.",
    maxCertification: "1 year",
    questionIds: [69, 245, 246, 247, 248, 249],
  },
  bipolarMoodDisorder: {
    title: "Bipolar Mood Disorder",
    waitingPeriod: "6 months to 1 year symptom-free depending on episode severity.",
    decision: "Certify after a symptom-free waiting period, if the driver complies with treatment and has clearance from a mental health professional.",
    maxCertification: "1 year",
    questionIds: [70, 250, 251, 252, 253],
  },
  majorDepression: {
    title: "Major Depression",
    waitingPeriod: "6 months to 1 year symptom-free depending on episode severity.",
    decision: "Certify after a symptom-free waiting period, if the driver complies with treatment and has clearance from a mental health professional.",
    maxCertification: "1 year",
    questionIds: [71, 254, 255, 256, 257, 258],
  },
  personalityDisorders: {
    title: "Personality Disorders",
    waitingPeriod: "No recommended time frame",
    decision: "Do not certify if the disorder causes symptoms that impair judgment, attention, or otherwise make driving unsafe.",
    maxCertification: "1 year",
    questionIds: [72, 259, 260, 261, 262, 263],
  },
  acuteDVT: {
    title: "Acute DVT",
    waitingPeriod: "Do not certify until etiology is confirmed and treatment is stable and effective.",
    decision: "Certify if there is no residual, acute DVT. Do not certify if ineffectively treated.",
    maxCertification: "1 year",
    questionIds: [90, 321, 323, 324, 325, 326, 327],
  },
  chronicThromboticVenousDisease: {
    title: "Chronic Thrombotic Venous Disease",
    waitingPeriod: "Do not certify until etiology is confirmed and treatment is stable and effective.",
    decision: "Certify if the driver has no symptoms.",
    maxCertification: "2 years",
    questionIds: [90, 322],
  },
  peripheralVascularDisease: {
    title: "Peripheral Vascular Disease",
    waitingPeriod: "3 months post-surgical repair",
    decision: "Certify if surgically repaired and meets guidelines or has clearance from a specialist.",
    maxCertification: "1 year",
    questionIds: [91, 328, 329, 330, 331],
  },
  pulmonaryEmbolism: {
    title: "Pulmonary Embolism",
    waitingPeriod: "3 months without pulmonary embolism",
    decision: "Certify if on appropriate long-term treatment and no other disqualifying disease. Do not certify if symptomatic.",
    maxCertification: "1 year",
    questionIds: [58, 199, 200, 201, 202, 92, 332, 333, 334, 335, 336],
  },
  varicoseVeins: {
    title: "Varicose Veins",
    waitingPeriod: "None",
    decision: "Certify if there are no complications.",
    maxCertification: "Biennial",
    questionIds: [93, 337, 338],
  },
  atrialFibrillation: {
    title: "Atrial Fibrillation (A. Fib)",
    waitingPeriod: "1 month after being adequately anticoagulated.",
    decision: "Certify if heart rate is controlled, treatment is effective, no disqualifying underlying disease, and has clearance from a specialist.",
    maxCertification: "1 year",
    questionIds: [43, 133, 134, 135, 51, 165, 166, 167],
  },
  myocardialInfarction: {
    title: "Acute Myocardial Infarction (AMI)",
    waitingPeriod: "2 months",
    decision: "Certify if asymptomatic, tolerates medications, has a satisfactory ETT, and a resting LVEF of 40% or greater.",
    maxCertification: "1 year",
    questionIds: [44, 136, 138, 139, 140, 141, 142, 52, 168, 170, 171, 172, 173, 174],
  },
  percutaneousCoronaryIntervention: {
    title: "Percutaneous Coronary Intervention",
    waitingPeriod: "1 week post-procedure for an uncomplicated, elective procedure.",
    decision: "Certify if asymptomatic and tolerates medications. Initially certify for up to 6 months, then recertify for up to 1 year if an ETT is satisfactory.",
    maxCertification: "Up to 1 year",
    questionIds: [44, 137, 138, 140, 141, 142, 52, 169, 170, 172, 173, 174],
  },
  coronaryArteryBypassGrafting: {
    title: "Coronary Artery Bypass Grafting (CABG)",
    waitingPeriod: "3 months",
    decision: "Certify if asymptomatic, LVEF is 40% or greater, sternum is healed, and has approval from a cardiologist.",
    maxCertification: "1 year",
    questionIds: [47, 155, 156, 157, 158, 159, 55, 188, 189, 190, 191, 192],
  },
  heartTransplantation: {
    title: "Heart Transplantation",
    waitingPeriod: "1 year post transplant",
    decision: "Certify if asymptomatic, tolerates medications, has no signs of rejection, and has clearance from a cardiovascular specialist.",
    maxCertification: "6 months",
    questionIds: [46, 151, 152, 153, 154, 54, 184, 185, 186, 187],
  },
  valvularHeartDisease: {
    title: "Valvular Heart Disease / Heart Murmur",
    waitingPeriod: "Varies; generally 3 months post-repair.",
    decision: "Certification depends on the specific valve, severity, symptoms, and LV function. A specialist's evaluation is crucial.",
    maxCertification: "1 year",
    questionIds: [45, 143, 144, 145, 146, 147, 148, 149, 150, 53, 175, 176, 177, 178, 179, 180, 181, 182, 183],
  },
  asthma: {
    title: "Asthma",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if the condition is stable. Do not certify if asthma is continually uncontrolled or if FEV1 is less than 65%.",
    maxCertification: "2 years",
    questionIds: [60, 206, 207, 208],
  },
  COPD: {
    title: "Chronic Obstructive Pulmonary Disease (COPD)",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if the condition is stable. Do not certify if the driver has hypoxemia at rest, chronic respiratory failure, or a history of cough syncope.",
    maxCertification: "2 years",
    questionIds: [59, 203, 204, 205],
  },
  cysticFibrosis: {
    title: "Cystic Fibrosis (CF)",
    waitingPeriod: "No recommended time frame",
    decision: "Do not certify if the driver has hypoxemia at rest, chronic respiratory failure, history of cough syncope, or an unstable condition.",
    maxCertification: "2 years",
    questionIds: [61, 209, 210, 211],
  },
  tuberculosis: {
    title: "Pulmonary Tuberculosis (TB)",
    waitingPeriod: "Do not certify until determined not to be contagious.",
    decision: "Certify if not contagious and compliant with therapy. Do not certify if there is advanced TB with respiratory insufficiency.",
    maxCertification: "2 years",
    questionIds: [62, 212, 213, 214, 215, 82, 299, 300, 301, 302, 303],
  },
  pneumothorax: {
    title: "Pneumothorax",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if asymptomatic with confirmed resolution. Do not certify if there is a history of two or more spontaneous pneumothoraces on one side without a successful surgical procedure to prevent recurrence.",
    maxCertification: "2 years",
    questionIds: [57, 194, 195, 196, 197, 198],
  },
  headaches: {
    title: "Headaches",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if the examiner believes that the nature and severity of the condition does not endanger the health and safety of the driver and the public.",
    maxCertification: "2 years",
    questionIds: [38, 113, 114, 115, 116, 79, 286, 287, 288, 289],
  },
  neuromuscularDisorders: {
    title: "Neuromuscular Disorders",
    waitingPeriod: "Not applicable",
    decision: "Generally Disqualified. Reconsideration is possible with an evaluation by a neurologist or physiatrist.",
    maxCertification: "Disqualified",
    questionIds: [84, 312, 313, 314, 86, 319],
  },
  nephropathy: {
    title: "Nephropathy",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if the treatment plan manages the disease and does not interfere with safe driving.",
    maxCertification: "2 years",
    questionIds: [63, 216, 217, 218, 219],
  },
  hernia: {
    title: "Hernia",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if it doesn't interfere with safe driving.",
    maxCertification: "2 years",
    questionIds: [66, 230, 231],
  },
  fixedDeficitOfExtremity: {
    title: "Fixed Deficit of Extremity",
    waitingPeriod: "No recommended time frame",
    decision: "Certify if the driver has a fixed deficit of an extremity and is accompanied by a valid Skill Performance Evaluation (SPE) certificate.",
    maxCertification: "2 years",
    questionIds: [19, 88, 89],
  },
  cnsTumors: {
    title: "Central Nervous System Tumors",
    waitingPeriod: "1-2 years post-surgical removal depending on tumor type.",
    decision: "Do not certify primary or metastatic malignant tumors. For benign tumors, certify only after the waiting period and with a neurologist evaluation showing no recurrence.",
    maxCertification: "1 year",
    questionIds: [77, 280, 281, 282, 23],
  },
};

export const HEALTHY_DRIVER_RECOMMENDATION = {
  title: "Healthy Driver",
  waitingPeriod: "None",
  decision: "No medical history reported. Driver is considered healthy.",
  maxCertification: "2 years",
  questionIds: [],
};

export const examOrder = [
  "General",
  "Skin",
  "Eyes",
  "Ears",
  "Mouth/throat",
  "Cardiovascular",
  "Lungs/chest",
  "Abdomen",
  "Genito-urinary system including hernias",
  "Back/spine",
  "Extremities/joints",
  "Neurological system including reflexes",
  "Gait",
  "Vascular system",
  "Would the abnormal findings impact the driver's ability to operate a CMV?"
];

const medication = [
  "ABACAVIR 300MG TABLETS",
  "ABACAVIR/LAMVUDINE 600-300MG TABLET",
  "ACAMPROSATE CAL DR 333MG TABLETS",
  "ACANYA 1.2-2.5% GEL 50GM",
  "ACARBOSE 100MG TABLETS",
  "ACARBOSE 25MG TABLETS",
  "ACARBOSE 50MG TABLETS",
  "ACCU-CHEK AVIVA PLUS TEST STRIP 50S",
  "ACEBUTOLOL 200MG CAPSULES",
  "ACEBUTOLOL 400MG CAPSULES",
  "ACETAMINOPHEN/COD #2 (300/15MG) TAB",
  "ACETAMINOPHEN/COD #3 (300/30MG) TAB",
  "ACETAMINOPHEN/COD #4 (300/60MG) TAB",
  "ACETAMINOPHEN/COD 120-12MG/5ML SOL",
  "ACETAZOLAMIDE 125MG TABLETS",
  "ACETAZOLAMIDE 250MG TABLETS",
  "ACETAZOLAMIDE 500MG ER CAPSULES",
  "ACETIC ACID 2% AL ACTATE60ML (EAR)",
  "ACETIC ACID 2% OTIC SOLN 15ML (EAR)",
  "ACETYLCYSTEINE 10% INH SOLN 25 X4ML",
  "ACETYLCYSTEINE 20% INH SOL 25X4ML",
  "ACITRETIN 10MG CAPSULES",
  "ACITRETIN 17.5MG CAPSULES",
  "ACITRETIN 25MG CAPSULES",
  "ACITRETIN 25MG CAPSULES",
  "ACTEMRA 200MG/10ML INJ, 10ML",
  "ACTEMRA 200MG/10ML INJ, 10ML",
  "ACTEMRA 400MG/20ML INJ, 20ML",
  "ACTEMRA 400MG/20ML INJ, 20ML",
  "ACTEMRA 80MG/4ML INJ, 4ML",
  "ACTEMRA 80MG/4ML INJ, 4ML",
  "ACYCLOVIR 200MG CAPS",
  "ACYCLOVIR 200MG/5ML ORAL SUSP",
  "ACYCLOVIR 200MG/5ML ORAL SUSP",
  "ACYCLOVIR 400MG TABLETS",
  "ACYCLOVIR 400MG TABLETS",
  "ACYCLOVIR 5% OINTMENT 15GM",
  "ACYCLOVIR 5% OINTMENT 15GM",
  "ACYCLOVIR 800MG TABLETS",
  "ACYCLOVIR 800MG TABLETS",
  "ADAPAL/BENZ 0.1-2.5% GEL (PMP) 45G",
  "ADAPAL/BENZ 0.1-2.5% GEL (PMP) 45G",
  "ADAPALENE 0.1% CREAM 45GM",
  "ADAPALENE 0.1% CREAM 45GM",
  "ADAPALENE 0.1% GEL 45GM",
  "ADAPALENE 0.1% GEL 45GM",
  "ADAPALENE 0.3% GEL (PUMP) 45GM",
  "ADAPALENE 0.3% GEL (PUMP) 45GM",
  "ADAPALENE 0.3% GEL 45GM",
  "ADAPALENE 0.3% GEL 45GM",
  "ADDYI 100MG TABLETS",
  "ADDYI 100MG TABLETS",
  "ADEFOVIR DIPIVOXIL 10MG TABLETS",
  "ADEFOVIR DIPIVOXIL 10MG TABLETS",
  "ADRIAMYCIN 10MG INJ, 1VIAL",
  "ADRIAMYCIN 10MG INJ, 1VIAL",
  "ADVAIR DISKUS 100/50MCG (GREEN)60'S",
  "ADVAIR DISKUS 100/50MCG (GREEN)60'S",
  "ADVAIR DISKUS 250/50MCG (YELLOW) 60",
  "ADVAIR DISKUS 250/50MCG (YELLOW) 60",
  "ADVAIR DISKUS 500/50MCG (RED) 60'S",
  "ADVAIR DISKUS 500/50MCG (RED) 60'S",
  "AEROCHAMBER PLUS W/MASK (REGULAR)",
  "AEROCHAMBER PLUS W/MASK (REGULAR)",
  "AK-CIDE OPHTH OINTMENT",
  "AK-CIDE OPHTH OINTMENT",
  "ALBUTEROL 0.021%(0.63MG/3ML) 25X3ML",
  "ALBUTEROL 0.021%(0.63MG/3ML) 25X3ML",
  "ALBUTEROL 0.042%(1.25MG/3ML) 25X3ML",
  "ALBUTEROL 0.042%(1.25MG/3ML) 25X3ML",
  "ALBUTEROL 0.083% INH SOLN 25X3ML",
  "ALBUTEROL 0.5%(5MG/ML) CONC 20ML",
  "ALBUTEROL 0.5%(5MG/ML) CONC 20ML",
  "ALBUTEROL SULF ER 4MG TABLETS",
  "ALBUTEROL SULF ER 4MG TABLETS",
  "ALBUTEROL SULFATE 2MG TABLETS",
  "ALBUTEROL SULFATE 2MG TABLETS",
  "ALBUTEROL SULFATE 4MG TABLETS",
  "ALBUTEROL SULFATE 4MG TABLETS",
  "ALBUTEROL SULFATE SYRUP (2MG/5ML)",
  "ALBUTEROL SULFATE SYRUP (2MG/5ML)",
  "ALCLOMETASONE 0.05% CREAM 45GM",
  "ALCLOMETASONE 0.05% CREAM 45GM",
  "ALCLOMETASONE 0.05% OINTMENT 15GM",
  "ALCLOMETASONE 0.05% OINTMENT 15GM",
  "ALENDRONATE 10MG TAB",
  "ALENDRONATE 35MG TAB",
  "ALENDRONATE 40MG TABLETS",
  "ALENDRONATE 40MG TABLETS",
  "ALENDRONATE 5MG TABLETS",
  "ALENDRONATE 5MG TABLETS",
  "ALENDRONATE 70MG TAB",
  "ALFERON N 5MU/ML VIAL FOR INJECTION",
  "ALFUZOSIN 10MG TABLETS",
  "ALLER-CHLOR 4MG TAB",
  "ALLOPURINOL 100MG TAB",
  "ALLOPURINOL 300MG TAB",
  "ALMOTRIPTAN 12.5MG TABLETS",
  "ALMOTRIPTAN 6.25MG TABLETS",
  "ALOCRIL 2% OPHTH SOLN 5ML",
  "ALOMIDE 0.1% OPHTH DROP 10ML",
  "ALOSETRON 0.5MG TABLETS",
  "ALOSETRON 1MG TABLETS",
  "ALPHAGAN P 0.1% OPHTH SOLN 5ML",
  "ALPHAQUIN HP 4% CREAM 56.7GM",
  "ALPRAZOLAM 0.25MG ODT TABLETS",
  "ALPRAZOLAM 0.25MG TABLETS",
  "ALPRAZOLAM 0.5MG ODT TABLETS",
  "ALPRAZOLAM 0.5MG TABLETS",
  "ALPRAZOLAM 1MG ODT TABLETS",
  "ALPRAZOLAM 1MG TABLETS",
  "ALPRAZOLAM 2MG ODT TABLETS",
  "ALPRAZOLAM 2MG TABLETS",
  "ALPRAZOLAM CON 1MG/ML SOLUTION",
  "ALPRAZOLAM ER 0.5MG TABLETS",
  "ALPRAZOLAM ER 1MG TABLETS",
  "ALPRAZOLAM ER 2MG TABLETS",
  "ALPRAZOLAM ER 3MG TABLETS",
  "ALPROSTADIL 500MCG INJ, 1ML",
  "ALREX 0.2% OPHTHALMIC SUSP 5ML",
  "ALTABAX 1% OINTMENT 15GM",
  "ALTOPREV 20MG ER TABLETS",
  "ALTOPREV 40MG ER TABLETS",
  "ALTOPREV 60MG ER TABLETS",
  "AMANTADINE 100MG CAPSULES",
  "AMANTADINE 100MG TABLETS",
  "AMANTADINE 50MG/5ML SYRUP",
  "AMCINONIDE 0.1% CREAM 60GM",
  "AMCINONIDE 0.1% LOTION",
  "AMETHIA LO TABLETS",
  "AMETHYST 90-20MCG TABLETS",
  "AMIBID LA 600MG CR TABLETS",
  "AMIKACIN 1GM/4ML INJ, 4ML",
  "AMIKACIN SULFATE 500/2ML INJ, 2ML",
  "AMILORIDE 5MG / HCTZ 50MG TAB",
  "AMILORIDE 5MG TABLETS",
  "AMINOPHYLLINE 100MG TAB",
  "AMINOPHYLLINE 200MG TAB",
  "AMINOPHYLLINE 25MG/ML INJ, 10ML",
  "AMIODARONE 100MG TABLETS",
  "AMIODARONE 200MG TAB",
  "AMIODARONE 400MG TABLETS",
  "AMITIZA 24MCG CAPSULES",
  "AMITRIPTYLINE 100MG (HUNDRED MG)TAB",
  "AMITRIPTYLINE 10MG TAB",
  "AMITRIPTYLINE 150MG TABLETS",
  "AMITRIPTYLINE 25MG TAB",
  "AMITRIPTYLINE 50MG TAB",
  "AMITRIPTYLINE 75MG TABLETS",
  "AMLO/VAL/HCTZ 10/160/12.5MG TABLETS",
  "AMLOD/VAL/HCTZ 10/160/25MG TABLETS",
  "AMLOD/VAL/HCTZ 10/320/25MG TABLETS",
  "AMLOD/VAL/HCTZ 5/160/12.5MG TABLETS",
  "AMLOD/VAL/HCTZ 5/160/25MG TABLETS",
  "AMLODIPINE BESYLATE 10MG TAB",
  "AMLODIPINE BESYLATE 2.5MG TAB",
  "AMLODIPINE BESYLATE 5MG TAB",
  "AMLODIPINE/OLMES MEDOXOM 5-20MG T",
  "AMLODIPINE/OLMES MEDOXOM 5-40MG T",
  "AMLODIPINE/OLMES MEDOXOM10-20MG T",
  "AMLODIPINE/OLMES MEDOXOM10-40MG T",
  "AMLODIPINE-ATORVASTATIN 10/10MG TAB",
  "AMLODIPINE-ATORVASTATIN 10/20MG TAB",
  "AMLODIPINE-ATORVASTATIN 10/40MG TAB",
  "AMLODIPINE-ATORVASTATIN 10/80MG TAB",
  "AMLODIPINE-ATORVASTATIN 5/10MG TABS",
  "AMLODIPINE-ATORVASTATIN 5/20MG TABS",
  "AMLODIPINE-ATORVASTATIN 5/40MG TABS",
  "AMLODIPINE-ATORVASTATIN 5/80MG TABS",
  "AMLODIPINE-BENAZ 10/20MG CAPSULES",
  "AMLODIPINE-BENAZ 10/40MG CAPSULES",
  "AMLODIPINE-BENAZ 2.5/10MG CAPSULES",
  "AMLODIPINE-BENAZ 5/10MG CAPSULES",
  "AMLODIPINE-BENAZ 5/20MG CAPSULES",
  "AMLODIPINE-BENAZ 5/40MG CAPSULES",
  "AMLODIPINE-VALSARTAN 10-160MG TABS",
  "AMLODIPINE-VALSARTAN 10-320MG TABS",
  "AMLODIPINE-VALSARTAN 5-160MG TABS",
  "AMLODIPINE-VALSARTAN 5-320MG TABS",
  "AMMONIUM LAC 12% CREAM 280GM",
  "AMMONIUM LACT 12% LOTION 225GM",
  "AMOXAPINE 100MG TABLETS",
  "AMOXAPINE 25MG TABLETS",
  "AMOXAPINE 50MG TABLETS",
  "AMOX-CLAV 200/28.5MG CHEW TABS",
  "AMOX-CLAV 200MG/5ML SUSP 100ML",
  "AMOX-CLAV 250MG TABLETS",
  "AMOX-CLAV 250MG/5ML SUSP 75ML",
  "AMOX-CLAV 400MG CHEW TABLETS",
  "AMOX-CLAV 400MG/5ML SUSP 100ML",
  "AMOX-CLAV 500MG TABLETS",
  "AMOX-CLAV 875MG TABLETS",
  "AMOX-CLAV ES 600MG/5ML SUSP 125ML",
  "AMOX-CLAV ES 600MG/5ML SUSP 75ML",
  "AMOXICILLIN 125MG CHEWABLE TAB",
  "AMOXICILLIN 125MG/5ML SUSP 100ML",
  "AMOXICILLIN 125MG/5ML SUSP 150ML",
  "AMOXICILLIN 125MG/5ML SUSP 150ML",
  "AMOXICILLIN 125MG/5ML SUSP 80ML",
  "AMOXICILLIN 200MG/5ML SUSP 100ML",
  "AMOXICILLIN 200MG/5ML SUSP 75ML",
  "AMOXICILLIN 250MG CAP",
  "AMOXICILLIN 250MG CHEW TAB",
  "AMOXICILLIN 250MG/5ML SUSP 100ML",
  "AMOXICILLIN 250MG/5ML SUSP 100ML",
  "AMOXICILLIN 250MG/5ML SUSP 150ML",
  "AMOXICILLIN 250MG/5ML SUSP 80ML",
  "AMOXICILLIN 400MG/5ML SUSP 100ML",
  "AMOXICILLIN 400MG/5ML SUSP 50ML\r\nAMOXICILLIN 400MG/5ML SUSP 75ML",
  "AMOXICILLIN 500MG CAP",
  "AMOXICILLIN 500MG TAB",
  "AMOXICILLIN 875MG TAB",
  "AMPHOTERICIN B 50MG INJ",
  "AMPICILLIN 10GM VIAL FOR INJECTION",
  "AMPICILLIN 250/5ML SUSP 100 ML",
  "AMPICILLIN 250MG CAP",
  "AMPICILLIN 250MG/5ML SUSP 200ML",
  "AMPICILLIN 2GM INJ, 1 VIAL",
  "AMPICILLIN 500MG CAP",
  "AMPICILLIN 500MG INJ, 1 VIAL",
  "AMPICILLIN SOD 2GM INJ, 1 VIAL",
  "AMPICILLIN-SULBACT 2-1GMINJ,1 VIAL",
  "AMPICILLIN-SULBACTAM 15GM INJ, 1VL",
  "ANAGRELIDE 0.5MG CAPSULES",
  "ANAGRELIDE 1MG CAPSULES",
  "ANASTROZOLE 1MG TABLETS",
  "ANDROGEL 1.62% (20.25MG/1.25GM)PUMP",
  "ANTHRALIN 1% CREAM 50GM",
  "ANTIPY/BENZ 5.5-1.4% OTIC SOL (EAR)",
  "ANTIPYRINE BENZOCAINE OTIC SOL 15ML",
  "ANUCORT-HC 25MG RECTAL SUPP 24'S",
  "APEXICON E 0.05% CREAM 30GM",
  "APIDRA SOLOSTAR PEN INJ,5 X 3ML",
  "APIDRA U-100 INJECTION 10ML",
  "APRACLONIDINE 0.5% OPHTH SOL 10ML",
  "APREPITANT 125MG CAPSULES",
  "APREPITANT 40MG CAPSULES",
  "APREPITANT 80MG CAPSULES",
  "APREPITANT 80MG/125MG CAPS TRI-PACK",
  "APRISO 0.375GM CAPSULES",
  "APTIVUS 250MG CAPSULES",
  "ARANESP 100MCG/0.5ML SGJCT ALB FREE",
  "ARANESP 100MCG/ML VL ALBUMIN FREE",
  "ARANESP 200MCG/0.4ML INJ ALB FREE",
  "ARANESP 200MCG/ML VL ALBUMIN FREE",
  "ARANESP 25MCG INJ, 0.42ML",
  "ARANESP 25MCG/ML INJ, 1ML",
  "ARANESP 40MCG/0.4ML INJ ALB FREE",
  "ARANESP 40MCG/ML INJ SRCLK ALB FREE",
  "ARANESP 500MCG/ML INJ ALB FREE",
  "ARANESP 60MCG INJ, 1ML",
  "ARANESP 60MCG/0.3ML SGJCT ALB FREE",
  "ARIPIPRAZOLE 10MG TABLETS",
  "ARIPIPRAZOLE 15MG (FIFTEEN MG) TABS",
  "ARIPIPRAZOLE 1MG/ML ORAL SOLUTION",
  "ARIPIPRAZOLE 20MG (TWENTY MG) TABS",
  "ARIPIPRAZOLE 2MG TABLETS",
  "ARIPIPRAZOLE 30MG TABLETS",
  "ARIPIPRAZOLE 5MG TABLETS",
  "ARIPIPRAZOLE ODT 10MG TABLETS",
  "ARIPIPRAZOLE ODT 15MG TABLETS",
  "ARMODAFINIL 150MG TABLETS",
  "ARMODAFINIL 200MG TABLETS",
  "ARMODAFINIL 250MG TABLETS",
  "ARMODAFINIL 50MG TABLETS",
  "ASCORBIC ACID 500MG/ML INJ, 50ML",
  "ASHLYNA TABLETS 91S",
  "ASPIRIN-DIPYRIDAMOLE ER 25/200MG C",
  "ATAZANAVIR 150MG CAPSULES",
  "ATENOLOL 100MG TAB",
  "ATENOLOL 100MG TABLETS",
  "ATENOLOL 100MG/CHLORTHAL 25MG TABS",
  "ATENOLOL 25MG TAB",
  "ATENOLOL 50MG TAB",
  "ATENOLOL/CHLORTHALIDONE 50/25 TAB",
  "ATOMOXETINE 100MG CAPSULES",
  "ATOMOXETINE 10MG CAPSULES",
  "ATOMOXETINE 18MG CAPSULES",
  "ATOMOXETINE 25MG CAPSULES",
  "ATOMOXETINE 40MG CAPSULES",
  "ATOMOXETINE 60MG CAPSULES",
  "ATOMOXETINE 80MG CAPSULES",
  "ATORVASTATIN 10MG TAB",
  "ATORVASTATIN 20MG TAB",
  "ATORVASTATIN 40MG TAB",
  "ATORVASTATIN 80MG TAB",
  "ATOVAQUONE 750MG/5ML SUSPENSION",
  "ATOVAQUONE-PROGUANIL 250/100 TABS",
  "ATRIPLA (EFV600/FTC200/TDF300) TAB",
  "ATROPINE SULF 1% OPH SOLN 15ML",
  "ATROPINE SULF 1% OPH SOLN 5ML",
  "ATROPINE SULF 1% OPHTH OINTMENT",
  "ATROPINE SULFATE 0.4MG/ML INJ, 1ML",
  "ATROPINE SULFATE 1MG/ML INJ , 1ML",
  "AUGMENTIN 125MG/5ML SUSP 150ML",
  "AUTOPEN 2-42 UNIT",
  "AVASTIN SOL FOR INJ 16ML (400MG)",
  "AVIANE-28 TABLETS 28",
  "AZATHIOPRINE 50MG TABLETS",
  "AZELASTINE 0.05% OPHTH SOLUTION 6ML",
  "AZELASTINE 0.1%(137MCG) NASAL-200SP",
  "AZELASTINE 0.15% NASAL SP(200 DOSE)",
  "AZITHROMYCIN 100MG/5ML SUSP 15ML",
  "AZITHROMYCIN 1GM PAK POWDER",
  "AZITHROMYCIN 200MG/5ML SUSP 15ML",
  "AZITHROMYCIN 200MG/5ML SUSP 30ML",
  "AZITHROMYCIN 250MG TABLETS 6-PAK",
  "AZITHROMYCIN 500MG INJ, 1VIAL",
  "AZITHROMYCIN 500MG TABLETS",
  "AZITHROMYCIN 600MG TABLETS",
  "BACIIM 50000UNT INJ , 1VIAL",
  "BACITRACIN OPHTH OINTMENT 3.5GM",
  "BACITRACIN/POLYMYX OPHTHOINT 3.5GM",
  "BACLOFEN 10MG TAB",
  "BACLOFEN 20MG TABLETS",
  "BACTERIOSTATIC WATER INJ, 30ML",
  "BALSALAZIDE 750MG CAPSULES",
  "BARACLUDE 0.05MG/ML ORALSOLUTION",
  "B-D #9605 SYRINGE 10ML W/LL",
  "B-D PEN NDL MINI 31GX5MM(3/16)PRPL",
  "B-D PEN NDL ORIG29GX12.7MM(1/2) RED",
  "B-D PEN NDL SHRT 31GX8MM(5/16) BLU",
  "BELLADONNA 16.2MG / OPIUM 60MG SUPP",
  "BELLADONNA ALKALOIDS W/PB TABLETS",
  "BELVIQ 10MG TABLETS",
  "BENAZEPRIL 10MG TAB",
  "BENAZEPRIL 20MG TAB",
  "BENAZEPRIL 5MG TAB",
  "BENAZEPRIL/HCTZ 10/12.5MG TABLETS",
  "BENAZEPRIL/HCTZ 20/12.5MG TABLETS",
  "BENAZEPRIL/HCTZ 20/12.5MG TABLETS",
  "BENAZEPRIL/HCTZ 20/25MG TABLETS",
  "BENZEFOAM 9.8% ULTRA FOAM",
  "BENZOIC ACID CRYSTALS",
  "BENZONATATE 100MG CAP",
  "BENZONATATE 200MG CAP",
  "BENZONATATE 200MG CAPSULES",
  "BENZOYL PER 4% CRM WASH COMP KIT",
  "BENZOYL PER 4% CRM WASH COMP KIT",
  "BENZOYL PER 8% CRM WASH COMP KIT",
  "BENZOYL PER 8% CRM WASH COMP KIT",
  "BENZOYL PER-4 ACNE WASH KIT",
  "BENZOYL PEROX 4.5%-10% CLNSER 400ML",
  "BENZOYL PEROX 8.5%-10% CLNSER 400ML",
  "BENZOYL PEROXIDE 10% WASH 237ML",
  "BENZOYL PEROXIDE 4% GEL 42.5GM",
  "BENZOYL PEROXIDE 5% AQ GEL 60GM",
  "BENZOYL PEROXIDE 5% WASH 148GM",
  "BENZOYL PEROXIDE 5.75% WASH LIQUID",
  "BENZOYL PEROXIDE 8% GEL 42.5GM",
  "BENZPHETAMINE 50MG TABLETS",
  "BENZTROPINE 0.5MG TAB",
  "BENZTROPINE 1MG TAB",
  "BENZTROPINE 2MG TAB",
  "BEPREVE 1.5% OPTH DROPS 10ML",
  "BESIVANCE 0.6% OPTH SUSP 5ML",
  "BETAMETHASON DIP AUG 0.05% LOT 30ML",
  "BETAMETHASONE DIP 0.05% CRM 15GM",
  "BETAMETHASONE DIP 0.05% LOTN 60ML",
  "BETAMETHASONE DIP 0.05% OINT 45GM",
  "BETAMETHASONE DIP AUG .05% GEL 50GM",
  "BETAMETHASONE DIP AUG .05% OIN 45GM",
  "BETAMETHASONE DIP AUG CREAM 50GM",
  "BETAMETHASONE VAL 0.1% CRM 15GM",
  "BETAMETHASONE VAL 0.1% LOTN 60ML",
  "BETAMETHASONE VAL 0.1% OINT 45GM",
  "BETAMETHASONE VAL 0.12% FOAM 50GM",
  "BETAMETHASONE VAL 0.12% FOAM 50GM",
  "BETASERON 0.3MG VIAL FOR INJ KIT",
  "BETAXOLOL 0.5% OPHTH SOLN 15ML",
  "BETAXOLOL 10MG TABLETS",
  "BETAXOLOL 20MG TABLETS",
  "BETHANECHOL 10MG TABLETS",
  "BETHANECHOL 25MG TABLETS",
  "BETHANECHOL 50MG TABLETS",
  "BETHANECHOL 5MG TABLETS",
  "BETIMOL 0.25% OPHTH SOLN 5ML",
  "BICALUTAMIDE 50MG TABLETS",
  "BIDEX 400MG TABLETS",
  "BIMATOP 0.03% OPHTH SOLN 5ML",
  "BIMATOPROST 0.03% OPH SOLW/BRUSHES",
  "BIMATOPROST 0.03% OPHTH SOLN 2.5ML",
  "BIO GLO 1MG OPTH TEST STRIPS 300",
  "BIONECT 0.2% CREAM 25GM",
  "BIONECT 0.2% GEL 100GM",
  "BISOPROLOL FUMARATE 10MGTABLETS",
  "BISOPROLOL FUMARATE 10MGTABLETS",
  "BISOPROLOL FUMARATE 5MG TAB",
  "BISOPROLOL/HCTZ 10MG/6.25MG TAB",
  "BISOPROLOL/HCTZ 2.5MG/6.25MG TAB",
  "BISOPROLOL/HCTZ 5MG/6.25MG TAB",
  "BLEPHAMIDE S.O.P. OPHTH OINTMENT",
  "BLISOVI 24 FE TABLETS 28'S",
  "BLISOVI FE 1.5/30 TABLETS 28S",
  "BOTOX 200UNIT INJ, 1 VIAL",
  "BOTOX COSMETIC 100UNIT INJECTION",
  "BP 10-1 EMULSION",
  "BP 5% GEL 60GM",
  "BP GEL 10% GEL",
  "BP VIT 3 CAPSULES",
  "BP WASH 2.5% LIQUID 227GM",
  "BRAVELLE 75IU FOR INJECTION",
  "BREATHERITE AERO HOLDING CHAMBER",
  "BREEZE 2 TEST DISCS 100'S",
  "BRILINTA 90MG TABLETS",
  "BRIMONIDINE 0.15% OPHTH SOL 5ML",
  "BRIMONIDINE 0.2% OPHTH SOLN 5ML",
  "BROMFENAC 0.09% OPHTH SOLN 2.5ML",
  "BROMHIST DM PEDIATRIC DROPS 30ML",
  "BROMOCRIPTINE 2.5MG TABLETS",
  "BROMOCRIPTINE 5MG CAPSULES",
  "BROMPHEN/PSEUDO/DEXTRO HBR SYRUP",
  "BRONKIDS DROPS",
  "BUCALSEP SOLUTION",
  "BUCALSEP SPRAY",
  "BUDESONIDE 0.25MG/2ML VIALS 30X2ML",
  "BUDESONIDE 0.5MG/2ML VIALS 30X2ML",
  "BUDESONIDE 1MG/2ML RESPULES 30X2ML",
  "BUDESONIDE 32MCG NS SP (120INH) RX",
  "BUDESONIDE 3MG CAPSULES",
  "BUMETANIDE 0.5MG TABLETS",
  "BUMETANIDE 1MG TABLETS",
  "BUMETANIDE 2MG TABLETS",
  "BUMINATE 5% INJECTION",
  "BUPIVACAINE 0.25% INJ , 10ML",
  "BUPIVACAINE 0.5% INJ, 10 ML",
  "BUPIVACAINE 0.5% INJ, 50ML",
  "BUPIVACAINE 0.75% INJ, 30ML",
  "BUPIVACAINE 0.75% INJ, 30ML",
  "BUPRENEX 0.324MG/ML 1ML AMPS",
  "BUPRENEX 0.3MG/ML INJ, 1ML AMPULES",
  "BUPRENORPHINE 0.3MG/ML INJ , 1ML",
  "BUPRENORPHINE 10MCG/HR TD PATCH",
  "BUPRENORPHINE 15MCG/HR TDPATCH",
  "BUPRENORPHINE 20MCG/HR TD PATCH",
  "BUPRENORPHINE 2MG SL TABLETS",
  "BUPRENORPHINE 8MG SL TABLETS",
  "BUPRENORPHINE/NALOX 2MG/0.5MG SL TB",
  "BUPRENORPHINE/NALOX 8MG/2MG SL TAB",
  "BUPROPION 100MG TABLETS",
  "BUPROPION 75MG TABLETS",
  "BUPROPION SR 100MG TABLETS (12H)",
  "BUPROPION SR 150MG TABLETS",
  "BUPROPION SR 150MG TABLETS (12 H)",
  "BUPROPION SR 200MG TABLETS (12 HR)",
  "BUPROPION XL 150MG TABLETS (24 H)",
  "BUPROPION XL 300MG TABLETS",
  "BUSPIRONE 10MG TAB",
  "BUSPIRONE 15MG TABLETS",
  "BUSPIRONE 30MG TABLETS",
  "BUSPIRONE 5MG TAB",
  "BUSPIRONE 7.5MG TABLETS",
  "BUT/ACETAMI/CAFF COD 50-300-40-30 C",
  "BUT/ACETAMINOPHEN CAFF 50-300-40 CP",
  "BUTAL/ACETA/CAFF/COD 50-325-40-30MG",
  "BUTALB/ACETAMINOPHEN 325MG TABS",
  "BUTALB/APAP/CAFF 50/325/40MG CAPS",
  "BUTALB/ASPIRIN 325MG/CAFFEINE TAB",
  "BUTALB/ASPIRIN/CAFF/CODEINE 30MG CP",
  "BUTALBITAL/ACETAMINOPHEN/CAFF TABS",
  "BUTALBITAL/ASPIRIN/CAFFEINE CAPS",
  "BUTORPHANOL 2MG/ML INJ, 1ML",
  "BUTORPHANOL NS NASAL SPRAY 2.5ML",
  "BYSTOLIC 10MG TABLETS",
  "BYSTOLIC 2.5MG TABLETS",
  "BYSTOLIC 20MG TABLETS",
  "BYSTOLIC 5MG TABLETS",
  "CABERGOLINE 0.5MG TABLETS",
  "CALCIPOTRIEN/BETAMET DIP OINT 60GM",
  "CALCIPOTRIENE 0.005% CREAM 60GM",
  "CALCIPOTRIENE 0.005% OINTMENT 120GM",
  "CALCIPOTRIENE 0.005% OINTMENT 60GM",
  "CALCIPOTRIENE 0.005% SCALP SOLUTION",
  "CALCITONIN 200IU/NASAL SPR 30 DOSES",
  "CALCITRIOL 0.25MCG CAPSULES",
  "CALCITRIOL 0.5MCG CAPSULES",
  "CALCITRIOL 1MCG/ML SOL 15ML",
  "CALCITRIOL 3MCG/GM OINTMENT 100GM",
  "CALCIUM ACETATE 667MG CAPSULES",
  "CALCIUM ACETATE 667MG TABLETS",
  "CALCIUM CHLORIDE 10% INJ, 10ML",
  "CALCIUM CHLORIDE 10% INJ, 10ML",
  "CALCIUM GLUCONATE 10% INJ , 100ML",
  "CALCIUM GLUCONATE 10% INJ 50ML",
  "CALCIUM-FA PLUS D CHEW WAFERS",
  "CAMBIA 50MG POWDER",
  "CAMBIA 50MG POWDER",
  "CAMRESE TABLETS 91S",
  "CANDESARTAN 16MG TABLETS",
  "CANDESARTAN 32MG TABLETS",
  "CANDESARTAN 4MG TABLETS",
  "CANDESARTAN 8MG TABLETS",
  "CANDESARTAN HCT 16-12.5MG TABLETS",
  "CANDESARTAN HCT 32/25MG TABLETS",
  "CANDESARTAN HCT 32-12.5MG TABLETS",
  "CAPECITABINE 150MG TABLETS",
  "CAPECITABINE 500MG TABLETS",
  "CAPEX 0.01% SHAMPOO 120ML",
  "CAPTOPRIL 100MG TABLETS",
  "CAPTOPRIL 100MG TABLETS",
  "CAPTOPRIL 12.5MG TABLETS",
  "CAPTOPRIL 12.5MG TABLETS",
  "CAPTOPRIL 25MG TABLETS",
  "CAPTOPRIL 50MG TABLETS",
  "CAPTOPRIL/HCTZ 25/15 TABLETS",
  "CAPTOPRIL/HCTZ 25/25 TABLETS",
  "CAPTOPRIL/HCTZ 50/15 TABLETS",
  "CAPTOPRIL/HCTZ 50/25 TABLETS",
  "CARAFATE 1GM/10ML SUSPENSION",
  "CARB/LEV/ENTAC 37.5-150-200MG TABS",
  "CARBAMAZEPINE 100MG CHEWABLE TABS",
  "CARBAMAZEPINE 100MG ER CAPSULES",
  "CARBAMAZEPINE 100MG/5ML SHAKE WELL",
  "CARBAMAZEPINE 200MG ER CAPSULES",
  "CARBAMAZEPINE 200MG TABLETS",
  "CARBAMAZEPINE 300MG ER CAPSULES",
  "CARBAMAZEPINE ER 100MG TABLETS",
  "CARBAMAZEPINE ER 200MG TABLETS",
  "CARBAMAZEPINE ER 400MG TABLETS",
  "CARBI/LEVO/ENTOCAP 100 TABS",
  "CARBIDOPA 25MG TABLETS",
  "CARBIDOPA/LEV/ENTAC 18.75-75-200MG",
  "CARBIDOPA/LEV/ENTAC 31.25-125-200MG",
  "CARBIDOPA/LEV/ENTAC 50-200-200MG",
  "CARBIDOPA/LEVODOPA 10-100MG DIS TAB",
  "CARBIDOPA/LEVODOPA 10-100MG TABS",
  "CARBIDOPA/LEVODOPA 25-100MG CR TABS",
  "CARBIDOPA/LEVODOPA 25-100MG DIS TAB",
  "CARBIDOPA/LEVODOPA 25-100MG TABS",
  "CARBIDOPA/LEVODOPA 25-250MG DIS TAB",
  "CARBIDOPA/LEVODOPA 25MG-250MG TABS",
  "CARBIDOPA/LEVODOPA 50-200MG CR TABS",
  "CARBINOXAMINE 4MG TABLETS",
  "CARBINOXAMINE 4MG/5ML LIQUID",
  "CARBOPLATIN 450MG/45ML INJ",
  "CARDEC DM DROPS 30ML",
  "CARDIOTEK-RX TABLETS",
  "CARISOPRODOL 250MG TABLETS",
  "CARISOPRODOL 350MG TABLETS",
  "CARISOPRODOL/ASA/CODEINE TABLETS",
  "CARTEOLOL HCL 1% OPH SOL 10ML",
  "CARTIA (DILTIAZEM) 120MGXT CAPS",
  "CARTIA (DILTIAZEM) 180MGXT CAPS",
  "CARTIA (DILTIAZEM) 240MGXT CAPS",
  "CARTIA (DILTIAZEM) 300MGXT CAPS",
  "CARVEDILOL 12.5MG TAB",
  "CARVEDILOL 25MG TAB",
  "CARVEDILOL 3.125MG TAB",
  "CARVEDILOL 6.25MG TAB",
  "CARVEDILOL ER 20MG CAPSULES",
  "CARVEDILOL ER 40MG CAPSULES",
  "CAVERJECT 20MCG VIAL INJ",
  "CAVERJECT 40MCG INJ VIAL",
  "CAVERJECT IMPULSE 20MCG KIT (2 SYR)",
  "CAZIANT TABLETS 28",
  "CEFACLOR 250MG CAPSULES",
  "CEFACLOR 500MG CAPSULES",
  "CEFADROXIL 1GM TABLETS",
  "CEFADROXIL 250MG/5ML SUSP 100ML",
  "CEFADROXIL 500MG CAPSULES",
  "CEFADROXIL 500MG/5ML SUSP 100ML",
  "CEFAZOLIN 1GM INJ, 1 VIAL",
  "CEFAZOLIN 1GM INJ, 1 VIAL",
  "CEFDINIR 125MG/5ML SUSPENSION 60ML",
  "CEFDINIR 250MG/5ML SUSPENSION 60ML",
  "CEFDINIR 300MG CAPSULES",
  "CEFEPIME 1GM INJ, 1 VIAL",
  "CEFEPIME 2GM INJ, 1 VIAL",
  "CEFIXIME 100MG/5ML SUSP 50ML",
  "CEFIXIME 200MG/5ML SUSP 50ML",
  "CEFOTETAN 1GM/10ML INJ, 1VIAL",
  "CEFPODOXIM PROX 100MG/5ML SUS 100ML",
  "CEFPODOXIME PRO 100MG TABLETS",
  "CEFPODOXIME PRO 200MG TABLETS",
  "CEFPODOXIME PROX 50MG/5ML SUSP 50ML",
  "CEFPROZIL 125MG/5ML SUSP 100ML",
  "CEFPROZIL 125MG/5ML SUSP 50ML",
  "CEFPROZIL 125MG/5ML SUSP 75ML",
  "CEFPROZIL 250MG/5ML SUSP 100ML",
  "CEFPROZIL 500MG TABLETS",
  "CEFTIBUTEN 180MG/5ML ORAL SUSP 60ML",
  "CEFTRIAXONE 1GM INJ, 1 VIAL",
  "CEFTRIAXONE 2GM INJ, 1VIAL",
  "CEFUROXIME 125MG/5ML SUSP 100ML",
  "CEFUROXIME 250MG TABLETS",
  "CEFUROXIME 250MG/5ML SUSP 100ML",
  "CEFUROXIME 500MG TABLETS",
  "CELECOXIB 100MG CAPSULES",
  "CELECOXIB 200MG CAPSULES",
  "CELECOXIB 400MG CAPSULES",
  "CELECOXIB 50MG CAPSULES",
  "CEPHALEXIN 125MG/5ML SUSP 200ML",
  "CEPHALEXIN 250MG CAP",
  "CEPHALEXIN 250MG TABLETS",
  "CEPHALEXIN 250MG/5ML SUSP 100ML",
  "CEPHALEXIN 500MG CAP",
  "CEPHALEXIN 500MG TABLETS",
  "CEREZYME 200U VIAL FOR INJECTION",
  "CEREZYME 400U INJ, 1VL",
  "CETIRIZINE 1MG/ML SYRUP",
  "CETROTIDE 0.25MG VIAL FOR INJ KIT",
  "CEVIMELINE 30MG CAPSULES",
  "CHANTIX 0.5MG TABLETS",
  "CHANTIX 1MG TABLETS",
  "CHANTIX STARTING MONTH PAK 53'S",
  "CHEMSTRIP 2 LN TEST STRIPS 100'S",
  "CHLORAMPHEN 1GM INJ, 1VIAL",
  "CHLORDIAZEPOX/AMITRIP 5/12.5MG TAB",
  "CHLORDIAZEPOXIDE/AMIT 10-25MG TABS",
  "CHLORDIAZEPOXIDE/CLIDINIUM5-2.5MG C",
  "CHLORHEXIDINE ORAL RINSE 473ML",
  "CHLOROQUINE 250MG TABLETS",
  "CHLOROQUINE PHOSPHATE 500MG TABLETS",
  "CHLOROTHIAZIDE 250MG TABLETS",
  "CHLOROTHIAZIDE 500MG TABLETS",
  "CHLORPROMAZINE 100MG** TABLETS",
  "CHLORPROMAZINE 10MG TABLETS",
  "CHLORPROMAZINE 200MG TABLETS",
  "CHLORPROMAZINE 200MG TABS",
  "CHLORPROMAZINE 25MG TABLETS",
  "CHLORPROMAZINE 50MG TABLETS",
  "CHLORPROPAMIDE 100MG TABLETS",
  "CHLORPROPAMIDE 250MG TABLETS",
  "CHLORTHALIDONE 25MG TABLETS",
  "CHLORTHALIDONE 50MG TABLETS",
  "CHLORZOXAZONE 500MG TABLETS",
  "CHOLESTYRAMINE 4GM LGHT POW PK 60'S",
  "CHOLESTYRAMINE 4GM PACKETS 60'S",
  "CHOLESTYRAMINE LIGHT POWDER (CAN)",
  "CHOLESTYRAMINE POWDER (CAN) 378GM",
  "CHORIONIC GONADOTROPIN 10,000 U/VL",
  "CIALIS 10MG TAB (QTY 6)",
  "CIALIS 10MG TABLETS",
  "CIALIS 2.5MG BLISTER PAK TABLETS",
  "CIALIS 2.5MG TAB (QTY 6)",
  "CIALIS 20MG TAB (QTY 6)",
  "CIALIS 20MG TABLETS",
  "CIALIS 5MG TAB (QTY 6)",
  "CIALIS 5MG TABLETS",
  "CICLOPIROX 0.77% CREAM 15GM",
  "CICLOPIROX 0.77% GEL 30GM",
  "CICLOPIROX 1% SHAMPOO 120ML",
  "CICLOPIROX 8% NAIL LACQUER TOP SOLN",
  "CICLOPIROX 8% TOPICAL SOL KIT",
  "CICLOPIROX TOPICAL SUSPENSION 60ML",
  "CILOSTAZOL 100MG TABLETS",
  "CILOSTAZOL 50MG TABLETS",
  "CIMETIDINE 200MG TABLETS",
  "CIMETIDINE 300MG TABLETS",
  "CIMETIDINE 400MG TABLETS",
  "CIMETIDINE 800MG TABLETS",
  "CIMETIDINE ORAL LIQ 300MG/5ML",
  "CIMZIA 200MG/ML INJ KIT (2 VIALS)",
  "CIMZIA 200MG/ML PRF SYR KIT (2 SYR)",
  "CIPRODEX OTIC SUSPENSION (EAR)",
  "CIPROFLOXACIN 0.3% OP SOL5ML-EYE",
  "CIPROFLOXACIN 100MG PACK",
  "CIPROFLOXACIN 10GM/100ML SUSP",
  "CIPROFLOXACIN 250MG TAB",
  "CIPROFLOXACIN 500MG TAB",
  "CIPROFLOXACIN 750MG TAB",
  "CIPROFLOXACN 250MG/5ML SUSP",
  "CIPROFLOXCN 0.2% PF OTIC SOL (EAR)",
  "CISPLATIN AQ INJ, 100ML",
  "CITALOPRAM 10MG TAB",
  "CITALOPRAM 10MG/5ML SOLUTION",
  "CITALOPRAM 20MG TAB",
  "CITALOPRAM 40MG TAB",
  "CITRANATAL DHA PAK",
  "CITRIC ACID (ANHYDROUS)POWDER 500GM",
  "CLARIFOAM EF EMOLLIENT FOAM 60GM",
  "CLARINEX-D 12 HOUR TABLETS",
  "CLARITHROMYCIN 125MG/5ML SUSP 50ML",
  "CLARITHROMYCIN 250MG TABLETS",
  "CLARITHROMYCIN 250MG/5ML SUSP 100ML",
  "CLARITHROMYCIN 500MG ER TABLETS",
  "CLARITHROMYCIN 500MG TABLETS",
  "CLEMASTINE 2.68MG TABLETS",
  "CLEOCIN 100MG VAGINAL OVULE 3'S",
  "CLIMARA PRO 0.045MG/DAY PATCHES 4'S",
  "CLINDAGEL 1% TOPICAL GEL",
  "CLINDAMYCIN 1% FOAM 50GM",
  "CLINDAMYCIN 1% GEL 30GM",
  "CLINDAMYCIN 1% LOTION 60ML",
  "CLINDAMYCIN 1% PLEDGETS 60'S",
  "CLINDAMYCIN 1% TOPICAL SOLN 60ML",
  "CLINDAMYCIN 150MG CAP",
  "CLINDAMYCIN 2% VAGINAL CREAM 40GM",
  "CLINDAMYCIN 900MG INJ, 50ML",
  "CLINDAMYCIN PED 75MG/5MLSOL 100ML",
  "CLINDAMYCIN/BENZ PER 1/5% GEL 35GM",
  "CLINDAMYCIN/BENZ PER 1/5% GEL 50GM",
  "CLINDAMYCIN/BPO 1.2-5% GEL 45GM",
  "CLOBETASOL 0.05% EMOLLIENT CRM 15GM",
  "CLOBETASOL 0.05% EMOLLNT FOAM 100GM",
  "CLOBETASOL 0.05% EMOLLNT FOAM 50GM",
  "CLOBETASOL 0.05% FOAM 100GM",
  "CLOBETASOL 0.05% SPRAY 59ML",
  "CLOBETASOL PROP 0.05% CREAM 60GM",
  "CLOBETASOL PROP 0.05% GEL 15GM",
  "CLOBETASOL PROP 0.05% OINT 60GM",
  "CLOBETASOL PROP 0.05% SOLN 50ML",
  "CLOBETASOL PROPIONATE POWDER",
  "CLOCORTOLONE PIV 0.1% CRM 75GM PUMP",
  "CLOCORTOLONE PIVALATE 0.1% CRM 45GM",
  "CLOMIPHENE CITRATE 50MG TAB",
  "CLOMIPRAMINE 25MG CAPSULES",
  "CLOMIPRAMINE 50MG CAPSULES",
  "CLOMIPRAMINE 75MG CAPSULES",
  "CLONAZEPAM 0.5MG TABLETS",
  "CLONAZEPAM 1MG TABLETS",
  "CLONAZEPAM 2MG TABLETS",
  "CLONAZEPAM ODT 0.125MG TABLETS",
  "CLONAZEPAM ODT 0.25MG TABLETS",
  "CLONAZEPAM ODT 0.5MG TABLETS",
  "CLONAZEPAM ODT 1MG TABLETS",
  "CLONAZEPAM ODT 2MG TABLETS",
  "CLONIDINE 0.1MG EXTENDED RELEASE TB",
  "CLONIDINE 0.1MG TAB",
  "CLONIDINE 0.1MG/24H WEEKLY PATCH",
  "CLONIDINE 0.2MG TAB",
  "CLONIDINE 0.2MG/24H WEEKLY PATCHES",
  "CLONIDINE 0.3MG TAB",
  "CLONIDINE 0.3MG/24H WEEKLY PATCH",
  "CLOPIDOGREL 75MG TABLETS",
  "CLOTRIMAZOLE 1% CREAM 30GM",
  "CLOTRIMAZOLE 1% TOPICAL SOLUTION",
  "CLOTRIMAZOLE 10MG LOZENGE",
  "CLOTRIMAZOLE-BETAMETHASONE CRM 15GM",
  "CLOTRIMAZOLE-BETAMETHASONE CRM 45GM",
  "CLOTRIMAZOLE-BETAMETHASONE LOT 30ML",
  "CLOZAPINE 100MG TABLETS",
  "CLOZAPINE 25MG TAB",
  "CODEINE SULF 30MG TABLETS",
  "CODEINE SULFATE 15MG TABLETS",
  "CODEINE SULFATE 60MG TABLETS",
  "COLCHICINE 0.6MG CAPSULES",
  "COLCHICINE 0.6MG TABLETS",
  "COLESTIPOL 1GM TABLETS",
  "COLESTIPOL 5GM GRANULE PACKETS 90'S",
  "COLESTIPOL HCL 5GM GRANULES",
  "COLISTIMETHATE 150MG INJ,1 VIAL",
  "COMBIGAN 0.2/0.5% OPTH SOLN 5ML",
  "COMBIPATCH .05MG/.14MG/DAY PATCHES",
  "COMBIVIR 150MG/300MG TABLETS",
  "COMPLETENATE CHEWABLE TABLETS",
  "CONDYLOX 0.5% GEL 3.5GM",
  "CONTOUR NEXT TEST STRIPS100'S",
  "CONTRAVE ER 8-90MG TABLETS",
  "CORDRAN 0.05% LOTION 60ML",
  "CORDRAN 80X3 4MCG/CM TAPE",
  "COREG CR 10MG CAPSULES",
  "CORTISONE ACETATE 25MG TABLETS",
  "CORVITA 150 TABLETS",
  "CORVITE FREE TABLETS",
  "COSOPT PF OPHTH SOLN 60S",
  "COUMADIN 10MG (TEN MG) TABS (WHITE)",
  "COUMADIN 1MG TABLETS (PINK)",
  "COUMADIN 2.5MG TABLETS (GREEN)",
  "COUMADIN 2MG TABLETS (PURPLE)",
  "COUMADIN 3MG TABLETS (TAN)",
  "COUMADIN 4MG TABLETS (BLUE)",
  "COUMADIN 5MG TABLETS (PEACH)",
  "COUMADIN 6MG TABLETS (BLUE/GREEN)",
  "COUMADIN 7.5MG TABLETS (YELLOW)",
  "COVARYX 1.25/2.5MG TABLETS",
  "CRINONE 8% (90MG)VAG GEL 15X1.125GM",
  "CRIXIVAN 400MG CAPSULES",
  "CROMOLYN SOD 100/5ML ORAL CONC 5ML",
  "CROMOLYN SOD 20/2ML INH SOLN 60X2ML",
  "CROMOLYN SODIUM 4% OPHTH SOLN 10ML",
  "CUPRIMINE 250MG CAPSULES",
  "CYANOCOBALAMIN 1000MCG/ML INJ, 1ML",
  "CYCLOBENZAPRINE 10MG TAB",
  "CYCLOBENZAPRINE 5MG TAB",
  "CYCLOBENZAPRINE 5MG TABLETS",
  "CYCLOBENZAPRINE 7.5MG TABLETS",
  "CYCLOPENTOLATE 0.5% OPHTH SOLN 15ML",
  "CYCLOPENTOLATE 1% OPTH SOL 2ML",
  "CYCLOPENTOLATE 1% OPTH SOLN 15ML",
  "CYCLOPHOSPHA 1GM INJ, 1 VIAL",
  "CYCLOPHOSPHAMIDE 25MG CAPSULES",
  "CYCLOPHOSPHAMIDE 2GM VIAL FOR INJ",
  "CYCLOPHOSPHAMIDE 500MG INJ 1 VIAL",
  "CYCLOPHOSPHAMIDE 50MG CAPSULES",
  "CYCLOSPORINE 100MG (MOD) CAPS",
  "CYCLOSPORINE 100MG CAPSULES",
  "CYCLOSPORINE 100MG/ML MOD ORAL SOLN",
  "CYCLOSPORINE 25MG (MOD) CAPS",
  "CYCLOSPORINE 25MG CAPSULES",
  "CYCLOSPORINE 50MG (MOD) CAPS",
  "CYCLOSPORINE 50MG/ML INJ, 5ML",
  "CYPROHEPTADINE 2MG/5ML SYRUP",
  "CYPROHEPTADINE 4MG TABLETS",
  "CYTRA-2 SOLUTION",
  "DACARBAZINE 100MG INJ, 1VIAL",
  "DACARBAZINE 200MG INJ, 1VIAL",
  "DACARBAZINE 200MG INJ, 1VIAL",
  "D-AMPHETAMINE SALT COM ER(XR)10MG C",
  "D-AMPHETAMINE SALT COM ER(XR)15MG C",
  "D-AMPHETAMINE SALT COM ER(XR)20MG C",
  "D-AMPHETAMINE SALT COM ER(XR)25MG C",
  "D-AMPHETAMINE SALT COM ER(XR)30MG C",
  "D-AMPHETAMINE SALT COM ER(XR)5MG C",
  "D-AMPHETAMINE SALT COMBO 10MG TAB",
  "D-AMPHETAMINE SALT COMBO 20MG TABS",
  "D-AMPHETAMINE SALT COMBO 30MG TABS",
  "D-AMPHETAMINE SALT COMBO 5MG TABS",
  "D-AMPHETAMINE SALT COMBO12.5MG TB",
  "D-AMPHETAMINE SALT COMBO15MG TABS",
  "D-AMPHETAMINE SALT COMBO7.5MG TAB",
  "DANAZOL 100MG CAPSULES",
  "DANAZOL 200MG CAPSULES",
  "DANAZOL 50MG CAPSULES",
  "DANTROLENE 100MG CAPSULES",
  "DANTROLENE 25MG CAPSULES",
  "DANTROLENE 50MG CAPSULES",
  "DARIFENACIN ER 7.5MG TABLETS",
  "DAYTRANA 15MG TRANSDERMAL PATCHES",
  "DAYTRANA 20MG TRANSDERMALPATCHES",
  "DAYTRANA 30MG TRANSDERMAL PATCHES",
  "DE-CHLOR DM LIQUID",
  "DE-CHLOR DR SYRUP",
  "DEFEROXAMIN 2GM INJ, 1VIAL",
  "DEFEROXAMINE 500MG INJ",
  "DEHISTINE SYRUP",
  "DEMECLOCYCLINE 150MG TABLETS",
  "DEMECLOCYCLINE 300MG TABLETS",
  "DENAVIR 1% CREAM 1.5GM",
  "DENAVIR 1% CREAM 5GM",
  "DEPEN TITRA 250MG TAB",
  "DEPO-ESTRADIOL 5MG/ML 5ML",
  "DEPO-PROVERA *104MG* SUBQ SYRINGE",
  "DESIPRAMINE 100MG** TABLETS",
  "DESIPRAMINE 10MG TABLETS",
  "DESIPRAMINE 150MG TABLETS",
  "DESIPRAMINE 25MG TABLETS",
  "DESIPRAMINE 50MG TABLETS",
  "DESIPRAMINE 75MG TABLETS",
  "DESLORATADINE 5MG TABLETS",
  "DESMOPRESSIN 0.01% RHINAL TUBE SOL",
  "DESMOPRESSIN 0.01%(0.1ML/NASAL SPR)",
  "DESMOPRESSIN 0.01%(0.1ML/NASAL SPR)",
  "DESMOPRESSIN 0.1MG TABLETS",
  "DESMOPRESSIN 0.2MG TABLETS",
  "DESMOPRESSIN 4MCG/ML INJ 10ML MDV",
  "DESMOPRESSIN 4MCG/ML INJ SINGLE USE",
  "DESONIDE 0.05% CREAM 15GM",
  "DESONIDE 0.05% LOTION 59ML",
  "DESONIDE 0.05% OINTMENT 15GM",
  "DESOXIMETASONE 0.05% CREAM 60GM",
  "DESOXIMETASONE 0.05% GEL 60GM",
  "DESOXIMETASONE 0.05% OINTMENT 100GM",
  "DESOXIMETASONE 0.05% OINTMENT 60GM",
  "DESOXIMETASONE 0.25% CRM 60GM",
  "DESOXIMETASONE 0.25% OINTMENT 100GM",
  "DESVENLAFAXINE ER 100MG TABLETS",
  "DESVENLAFAXINE ER 100MG TABLETS",
  "DESVENLAFAXINE ER 50MG TABLETS",
  "DESVENLAFAXINE ER 50MG TABLETS",
  "DESVENLAFAXINE SUCCINATE 100MG ER T",
  "DESVENLAFAXINE SUCCINATE 50MG ER TB",
  "DESVENLAFAXINE SUCCINATE25MG ER T",
  "DEXAMETHASONE 0.1% OPHTH SOLN 5ML",
  "DEXAMETHASONE 0.5MG/5ML ELIXIR",
  "DEXAMETHASONE 0.5MG/5ML ORAL SOLN",
  "DEXAMETHASONE 0.5MG/5ML ORAL SOLN",
  "DEXAMETHASONE 2MG TABLETS",
  "DEXAMETHASONE INTENSOL 1MG/ML SOLN",
  "DEXAMETHASONE PHO 4MG/ML INJECTION",
  "DEXAMETHASONE SOD PHOS 10MG/ML INJ",
  "DEXILANT 30MG CAP(FORMERLY KAPIDEX)",
  "DEXILANT 60MG CAP(FORMERLY KAPIDEX)",
  "DEXMETHYLPHENIDATE 10MG TABLETS",
  "DEXMETHYLPHENIDATE 15MG ER CAPSULES",
  "DEXMETHYLPHENIDATE 2.5MG TABLETS",
  "DEXMETHYLPHENIDATE 30MG ER CAPSULES",
  "DEXMETHYLPHENIDATE 40MG ER CAPSULES",
  "DEXMETHYLPHENIDATE 5MG TABLETS",
  "DEXMETHYLPHENIDATE ER 10MG CAPSULES",
  "DEXMETHYLPHENIDATE ER 20MG CAPSULES",
  "DEXMETHYLPHENIDATE ER 5MG CAPSULES",
  "DEXRAZOXANE 500MG INJ, 1 VIAL",
  "DEXTROAMPHETAMINE 10MG ER CAPSULES",
  "DEXTROAMPHETAMINE 10MG ER CAPSULES",
  "DEXTROAMPHETAMINE 10MG TABLETS",
  "DEXTROAMPHETAMINE 15MG ER CAPSULES",
  "DEXTROAMPHETAMINE 5MG ER CAPSULES",
  "DEXTROAMPHETAMINE 5MG TABLETS",
  "DEXTROSE 5%/NACL 0.45% 500ML",
  "DEXTROSE 50% INJ, 50ML",
  "DIALYVITE 3000 TABLETS",
  "DIALYVITE TABLETS",
  "DIALYVITE WITH ZINC TABLETS",
  "DIAZEPAM 10MG RECTAL GEL (2 PACK)",
  "DIAZEPAM 10MG TABLETS",
  "DIAZEPAM 2.5MG RECTAL GEL (2 PACK)",
  "DIAZEPAM 20MG RECTAL GEL",
  "DIAZEPAM 2MG TABLETS",
  "DIAZEPAM 5MG TABLETS",
  "DIAZEPAM 5MG/1ML ORAL CONCENTRATE",
  "DIAZEPAM 5MG/5ML (1MG/1ML) ORAL SOL",
  "DIAZEPAM 5MG/ML INJ, 10ML",
  "DIAZEPAM 5MG/ML INJECTION 10X2ML",
  "DICLOFENAC 1% GEL 100GM",
  "DICLOFENAC 1.5% TOPICAL SOL 150ML",
  "DICLOFENAC 3% GEL 100GM",
  "DICLOFENAC POTASSIUM 50MG TABLETS",
  "DICLOFENAC SOD 0.1% OPHTH SOLN 5ML",
  "DICLOFENAC SODIUM 100MG ER TABLETS",
  "DICLOFENAC SODIUM 25MG DR TABLETS",
  "DICLOFENAC SODIUM 50MG DR TABLETS",
  "DICLOFENAC SODIUM 75MG EC TAB",
  "DICLOFENAC/MISOPROSTOL 50-0.2MG TAB",
  "DICLOFENAC/MISOPROSTOL 75-0.2MG TAB",
  "DICLOXACILLIN 250MG CAPSULES",
  "DICLOXACILLIN 500MG CAPSULES",
  "DICYCLOMINE 10MG CAP",
  "DICYCLOMINE 10MG/5ML SOLUTION",
  "DICYCLOMINE 10MG/ML INJ, 2ML",
  "DICYCLOMINE 20MG TAB",
  "DIDANOSINE (DDI) 200MG DR CAPSULES",
  "DIDANOSINE (DDI) 250MG DR CAPSULES",
  "DIDANOSINE (DDI) 400MG DR CAPSULES",
  "DIETHYLPROPION 25MG TABLETS",
  "DIETHYLPROPION 75MG ER TABLETS",
  "DIFLORASONE DIACETATE .05% CRM 60GM",
  "DIFLORASONE DIACETATE .05% ONT 15GM",
  "DIFLORASONE DIACETATE .05% ONT 30GM",
  "DIFLUNISAL 500MG TABLETS",
  "DIGOXIN 0.125MG TABLETS (YELLOW)",
  "DIGOXIN 0.25MG TABLETS (WHITE)",
  "DIGOXIN 0.25MG/ML INJ, 1ML",
  "DIGOXIN 50 MCG/ML (0.05 MG/ML) DRP",
  "DIHYDROERGOTAMINE (1MG/ML) 1ML AMP",
  "DIHYDROERGOTAMINE 1MG/ML INJ, 1ML",
  "DILTIAZEM 120MG TAB",
  "DILTIAZEM 30MG TAB",
  "DILTIAZEM 60MG TAB",
  "DILTIAZEM 90MG TABLETS",
  "DILTIAZEM ER 120MG CAPSULES (24 HR)",
  "DILTIAZEM ER 180MG CAPS (XR-24H)",
  "DILTIAZEM ER 240MG CAPSULES (24 HR)",
  "DILTIAZEM ER 360MG (24 HR/CD) CAPS",
  "DILTIAZEM ER 420MG CAPSULES (24 HR)",
  "DILTIAZEM ER 60MG CAPSULES (12 HR)",
  "DILTIAZEM ER 90MG CAPSULES (12 HR)",
  "DILTIAZEM SR 120MG CAPSULES (12 HR)",
  "DILTIAZEM XR 120MG CAPSULES (24 HR)",
  "DILTIAZEM XR 240MG CAPSULES (24 HR)",
  "DIPHENHYDRAMINE 12.5MG/5ML ELIXIR",
  "DIPHENHYDRAMINE 50MG CAP",
  "DIPHENHYDRAMINE 50MG/ML INJ 1ML",
  "DIPHENHYDRAMINE 50MG/ML VIAL",
  "DIPHENOXYLATE/ATROPINE LIQUID",
  "DIPHENOXYLATE/ATROPINE TABLETS",
  "DIPYRIDAMOLE 25MG TABLETS",
  "DIPYRIDAMOLE 50MG TABLETS",
  "DIPYRIDAMOLE 75MG TABLETS",
  "DISOPYRAMIDE 100MG CAPSULES",
  "DISOPYRAMIDE 150MG CAPSULES",
  "DISULFIRAM 250MG TABLETS",
  "DISULFIRAM 500MG TABLETS",
  "DIURIL 250MG/5ML SUSPENSION",
  "DIVALPROEX 125MG SPRINKLES",
  "DIVALPROEX DELAYED RELEASE 125MG TB",
  "DIVALPROEX DELAYED RELEASE 250MG TB",
  "DIVALPROEX DELAYED RELEASE 500MG TB",
  "DIVALPROEX EXTENDED RELEASE 250MG T",
  "DIVALPROEX EXTENDED RELEASE 500MG T",
  "DIVIGEL 0.1% (1MG/DAY) TOP GEL",
  "DOC-Q-LACE 100MG CAP",
  "DOFETILIDE 125MCG CAPSULES",
  "DOFETILIDE 250MCG CAPSULES",
  "DOFETILIDE 500MCG CAPSULES",
  "DONEPEZIL 10MG TABLETS",
  "DONEPEZIL 23MG TABLETS",
  "DONEPEZIL 5MG TABLETS",
  "DOPAMINE 80MG/ML INJ , 5ML",
  "DORZOLAMIDE 2% OPHTH SOLN 10ML",
  "DORZOLAMIDE-TIMOLOL OPHTHSOLN 10ML",
  "DOXAZOSIN 1MG TAB",
  "DOXAZOSIN 1MG TABLETS",
  "DOXAZOSIN 2MG TAB",
  "DOXAZOSIN 2MG TABLETS",
  "DOXAZOSIN 4MG TAB",
  "DOXAZOSIN 8MG TABLETS",
  "DOXEPIN 100MG (HUNDRED MG) CAPSULES",
  "DOXEPIN 10MG CAP",
  "DOXEPIN 10MG CAPSULES",
  "DOXEPIN 150MG CAPSULES",
  "DOXEPIN 25MG CAP",
  "DOXEPIN 25MG CAPSULES",
  "DOXEPIN 50MG CAPSULES",
  "DOXEPIN 75MG CAPSULES",
  "DOXEPIN HCL 10MG/ML CONC 118ML",
  "DOXORUBICIN 2MG/ML INJ 5ML VIAL",
  "DOXYCYCLINE 100MG DR TABLETS",
  "DOXYCYCLINE 150MG CAPSULES",
  "DOXYCYCLINE 40MG CAPSULES",
  "DOXYCYCLINE HYC 150MG DR TABLETS",
  "DOXYCYCLINE HYC 200MG DR TABLETS",
  "DOXYCYCLINE HYCLATE 100MG CAPSULES",
  "DOXYCYCLINE HYCLATE 100MG TABLETS",
  "DOXYCYCLINE HYCLATE 100MGCAPSULES",
  "DOXYCYCLINE HYCLATE 20MG TABLETS",
  "DOXYCYCLINE HYCLATE 50MG CAPSULES",
  "DOXYCYCLINE MONOHYD 25MG/5ML SUSP",
  "DOXYCYCLINE MONOHYDRATE 100MG CAPS",
  "DOXYCYCLINE MONOHYDRATE 100MG TABS",
  "DOXYCYCLINE MONOHYDRATE 150MG TABS",
  "DOXYCYCLINE MONOHYDRATE 50MG CAPS",
  "DOXYCYCLINE MONOHYDRATE 50MG TABS",
  "DOXYCYCLINE MONOHYDRATE 75MG TABS",
  "DRONABINOL 10MG CAPSULES",
  "DRONABINOL 2.5MG CAPSULES",
  "DRONABINOL 5MG CAPSULES",
  "DROPERIDOL 2.5MG/ML INJECTION",
  "DROSPIRE/ETH ESTR/LEV TABS",
  "DROSPIRENONE-ETHINYL 3-0.03MG T 28",
  "DULOXETINE DR 20MG CAPSULES",
  "DULOXETINE DR 30MG CAPSULES",
  "DULOXETINE DR 40MG CAPSULES",
  "DULOXETINE DR 60MG CAPSULES",
  "DUREZOL 0.05% OPHTH EMULSION 5ML",
  "DUTASTERIDE 0.5MG CAPSULES",
  "DUTASTERIDE/TAMSULOSIN 0.5-0.4MG CP",
  "DYPHYLLINE-GG 100-100 ELIXIR",
  "DYPHYLLIN-GG TAB",
  "DYRENIUM 100MG CAPSULES",
  "DYRENIUM 50MG CAPSULES",
  "ECONAZOLE NITRATE 1% CREAM 30GM",
  "EDARBI 40MG TABLETS",
  "EDEX 20MCG INJ CARTRIDGEKIT (6 PK)",
  "EDEX 40MCG INJ CARTRIDGE KIT (6 PK)",
  "EDURANT 25MG TABLETS",
  "ELETRIPTAN 20MG TABLETS",
  "ELETRIPTAN 40MG TABLETS",
  "ELIDEL 1% CREAM 30GM",
  "ELIQUIS 2.5MG TABLETS",
  "ELIQUIS 5MG TABLETS",
  "ELITE-OB TABLETS",
  "ELMIRON 100MG CAPSULES",
  "EMADINE 0.05% OPHTH SOLN 5ML",
  "EMSAM 12MG/24H PATCH",
  "EMSAM 6MG/24HR PATCH",
  "EMSAM 9MG/24HR PATCH",
  "EMTRIVA 200MG CAPSULES",
  "ENABLEX 15MG ER TABLETS",
  "ENABLEX 7.5MG ER TABLETS",
  "ENALAPRIL 10MG TABLETS",
  "ENALAPRIL 2.5MG TAB",
  "ENALAPRIL 20MG TABLETS",
  "ENALAPRIL 5MG TAB",
  "ENALAPRIL-HCTZ 10-25MG TAB",
  "ENALAPRIL-HCTZ 5-12.5MG TAB",
  "ENBREL 25MG VIAL FOR INJ (4 VIALS)",
  "ENBREL 25MG/0.5ML INJ (4 SYRINGE)",
  "ENBREL 50MG/ML INJ (4 SYRINGE)",
  "ENBREL SURECLICK 50MG/ML(4 SYRINGE)",
  "ENDOMETRIN 100MG VAGINAL INSERT",
  "ENOXAPARIN 100MG/1ML SYR (10 X 1ML)",
  "ENOXAPARIN 120MG/0.8ML SYR 10X0.8ML",
  "ENOXAPARIN 150MG/1ML SYR(10X1ML)",
  "ENOXAPARIN 300MG/3ML INJ, 3ML",
  "ENOXAPARIN 30MG/0.3ML SYR(10X0.3ML)",
  "ENOXAPARIN 40MG/0.4ML SYR(10X0.4ML)",
  "ENOXAPARIN 60MG/0.6ML SYR(10X0.6ML)",
  "ENOXAPARIN 80MG/0.8ML SYR(10X0.8ML)",
  "ENTACAPONE 200MG TABLETS",
  "ENTECAVIR 0.5MG TABLETS",
  "ENTECAVIR 1MG TABLETS",
  "ENTECAVIR 1MG TABLETS",
  "ENTRESTO 49-51MG TABLETS",
  "EPINASTINE 0.05% OPHTH SOL 5ML",
  "EPINEPHRINE 0.15MG INJ, 2 PAK",
  "EPINEPHRINE 0.1MG/ML INJ, 10ML",
  "EPINEPHRINE 0.3MG INJ 2 PACK",
  "EPINEPHRINE 0.3MG PRE-FILLED(1 SYR)",
  "EPIPEN 0.3MG INJ 2 PACK (YELLOW)",
  "EPIPEN-JR 0.15MG INJ 2 PACK (GREEN)",
  "EPIRUBICIN 50MG INJ , 1VIAL",
  "EPIVIR 150MG TABLETS",
  "EPLERENONE 25MG TABLETS",
  "EPLERENONE 50MG TABLETS",
  "EPOGEN 10,000 U/ML 1ML SDV VIALS",
  "EPOGEN 10,000 U/ML 2ML MDV VIALS",
  "EPOGEN 2,000 U/ML 1ML SDV VIALS",
  "EPOGEN 4,000 U/ML 1ML SDV VIALS",
  "EPZICOM TABLETS",
  "EQUETRO 200MG CAPSULES",
  "ERGOLOID MES 1MG ORAL TAB",
  "ERTACZO 2% CREAM 60GM",
  "ERY 2% PADS 60S",
  "ERY-TAB 333MG EC TABLETS",
  "ERY-TAB 500MG EC TABLETS",
  "ERYTH-BENZ PEROX GEL 23.3GM",
  "ERYTH-BENZ PEROX GEL 46.6GM",
  "ERYTHROCIN 250MG TABLETS",
  "ERYTHROMYCIN 2% GEL 30GM",
  "ERYTHROMYCIN 2% GEL 60GM",
  "ERYTHROMYCIN 2% TOPICAL SOLN 60ML",
  "ERYTHROMYCIN 250MG ER CAPSULES",
  "ERYTHROMYCIN BASE 250MG TABLETS",
  "ERYTHROMYCIN BASE 500MG TABLETS",
  "ERYTHROMYCIN DR 250MG CAPSULES",
  "ERYTHROMYCIN ETH 400MG TABLETS",
  "ERYTHROMYCIN OPHTH OINT 3.5GM",
  "ERYTHROMYCIN/SULFISOX SUSP 100ML",
  "ESCITALOPRAM 10MG TABLETS",
  "ESCITALOPRAM 20MG TABLETS",
  "ESCITALOPRAM 5MG TABLETS",
  "ESOMEPRAZOLE MAGNESIUM 20MG DR CAPS",
  "ESOMEPRAZOLE MAGNESIUM 40MG DR CAPS",
  "EST ESTRGN METHTEST 0.625/1.25MG TB",
  "EST ESTRGN METHTEST 1.25/2.5MG TAB",
  "ESTAZOLAM 1MG TABLETS",
  "ESTAZOLAM 2MG TABLETS",
  "ESTRADIOL 0.01% VAG CREAM 42.5GM",
  "ESTRADIOL 0.025MG PATCH (ONCE WK)",
  "ESTRADIOL 0.025MG PATCH (TWICE WK)",
  "ESTRADIOL 0.0375MG PATCH (TWICE WK)",
  "ESTRADIOL 0.05MG PATCH (ONCE WK)",
  "ESTRADIOL 0.05MG PATCH (TWICE WK)",
  "ESTRADIOL 0.075MG PATCH (ONCE WK)",
  "ESTRADIOL 0.075MG PATCH (TWICE WK)",
  "ESTRADIOL 0.1MG PATCH (ONCE WK)",
  "ESTRADIOL 0.1MG PATCH (TWICE WK)",
  "ESTRADIOL 0.5MG TAB",
  "ESTRADIOL 10MCG VAGINAL TABS 8S",
  "ESTRADIOL 1MG TAB",
  "ESTRADIOL 2MG TAB",
  "ESTRADIOL TDS 0.0375MG PATCHES 4'S",
  "ESTRADIOL TDS 0.06MG PATCH 4'S",
  "ESTRADIOL VALERATE 20MG/ML INJ, 5ML",
  "ESTRING 2MG VAGINAL RING",
  "ESTROPIPATE 0.625MG (0.75MG) TAB",
  "ESTROPIPATE 1.5MG (1.25MG) TABS",
  "ESZOPICLONE 1MG TABLETS",
  "ESZOPICLONE 2MG TABLETS",
  "ESZOPICLONE 3MG TABLETS",
  "ETHAMBUTOL 400MG TABLETS",
  "ETHOSUXIMIDE 250MG CAPSULES",
  "ETHOSUXIMIDE 250MG/5ML SYRUP",
  "ETHYL CHLORIDE FINE STREAM SPRAY",
  "ETHYNODIOL-ETH EST 1/35 TABLETS 28S",
  "ETIDRONATE DISODIUM 400MG TABLETS",
  "ETODOLAC 200MG CAPSULES",
  "ETODOLAC 300MG CAPSULES",
  "ETODOLAC 400MG TABLETS",
  "ETODOLAC 500MG ER TABLETS",
  "ETODOLAC 500MG TABLETS",
  "ETODOLAC 600MG ER TABLETS",
  "ETODOLAC ER 400MG TABLETS",
  "EUFLEXXA 10MG/ML INJ, 2ML SYRINGE",
  "EURAX 10% CREAM 60GM",
  "EURAX 10% LOTION 60GM",
  "EVAMIST 1.53MG TOPICAL SP/56 SPRAYS",
  "EVOXAC 30MG CAPSULES",
  "EXELDERM 1% SOLUTION 30ML",
  "EXEMESTANE 25MG TABLETS",
  "EXJADE 125MG TABLETS",
  "EXJADE 500MG TABLETS",
  "EXTINA 2% FOAM 100GM",
  "EXXOTIC HC EAR DROPS 10ML",
  "EZETIMIBE 10MG TABLETS",
  "EZETIMIBE/SIMVASTATIN 10-10MG TABS",
  "EZETIMIBE/SIMVASTATIN 10-20MG TABS",
  "EZETIMIBE/SIMVASTATIN 10-40MG TABS",
  "EZETIMIBE/SIMVASTATIN 10-80MG TABS",
  "FABB TAB",
  "FAMCICLOVIR 125MG TABLETS",
  "FAMCICLOVIR 250MG TABLETS",
  "FAMCICLOVIR 500MG TABLETS",
  "FAMOTIDINE 10MG/ML INJ, 2ML",
  "FAMOTIDINE 10MG/ML INJ, 4ML",
  "FAMOTIDINE 20MG TAB",
  "FAMOTIDINE 40MG TAB",
  "FAMOTIDINE 40MG/5ML SUSPENSION 50ML",
  "FARXIGA 10MG TABLETS",
  "FE C PLUS TAB",
  "FELBAMATE 400MG TABLETS",
  "FELBAMATE 600MG TABLETS",
  "FELBAMATE OS 600MG/5ML SUSPENSION",
  "FELODIPINE 10MG ER TABLETS",
  "FELODIPINE 2.5MG ER TABLETS",
  "FELODIPINE 5MG ER TABLETS",
  "FENOFIBRATE 120MG TABLETS",
  "FENOFIBRATE 130MG CAPSULES",
  "FENOFIBRATE 134MG CAPSULES",
  "FENOFIBRATE 145MG TABLETS",
  "FENOFIBRATE 150MG CAPSULES",
  "FENOFIBRATE 160MG TABLETS",
  "FENOFIBRATE 200MG CAPSULES",
  "FENOFIBRATE 40MG TABLETS",
  "FENOFIBRATE 43MG CAPSULES",
  "FENOFIBRATE 48MG TABLETS",
  "FENOFIBRATE 50MG CAPSULES",
  "FENOFIBRATE 54MG TAB",
  "FENOFIBRATE 67MG CAPSULES",
  "FENOFIBRIC 135MG DR CAPSULES",
  "FENOFIBRIC 45MG DR CAPSULES",
  "FENOPROFEN 600MG TABLETS",
  "FENTANYL 100MCG/HR PATCH",
  "FENTANYL 12MCG/HR PATCH",
  "FENTANYL 25MCG/HR PATCH",
  "FENTANYL 50MCG/HR PATCH",
  "FENTANYL 75MCG/HR PATCH",
  "FENTANYL CIT 200MCG ORAL TRANSMCSL",
  "FENTANYL CIT 600MCG ORAL TRANSMCSL",
  "FERAHEME 510MG/17ML INJ, 17ML",
  "FEROCON CAPSULES",
  "FEROTRIN CAP",
  "FERRALET 90 TABS (NEW FORMULA)",
  "FERRAPLUS 90 TABLETS",
  "FERREX 150 FORTE CAP",
  "FERREX 150 PLUS CAPSULES",
  "FERROUS SULFATE 300MG/5ML SYRUP",
  "FERROUS SULFATE 325MG (5GR) TABS",
  "FERROUS SULFATE 325MG EC TABS RED",
  "FEXOFENADINE 180MG TABLETS (OTC)",
  "FINASTERIDE 1MG TABLETS",
  "FINASTERIDE 5MG TAB",
  "FLAREX 0.1% OPHTH SUSPENSION",
  "FLAVOXATE 100MG TABLETS",
  "FLEBOGAMMA DIF 5% INJ, 10ML",
  "FLECAINIDE 100MG TABLETS",
  "FLECAINIDE 150MG TABLETS",
  "FLECAINIDE 50MG TABLETS",
  "FLECTOR 1.3% PATCH",
  "FLOVENT HFA 110 MCG ORAL INH 120INH",
  "FLOVENT HFA 44MCG ORAL INH 120INH",
  "FLOXURIDINE 0.5GM INJ, 1VIAL",
  "FLUCONAZOLE 100MG TABLETS",
  "FLUCONAZOLE 10MG/ML ORALSUSP 35ML",
  "FLUCONAZOLE 150MG TAB",
  "FLUCONAZOLE 200MG TABLETS",
  "FLUCONAZOLE 40MG/ML ORAL SUSP 35ML",
  "FLUCONAZOLE 50MG TABLETS",
  "FLUCONAZOLE/NACL 200MG INJ, 100ML",
  "FLUDARABINE 50MG INJ, 1 VIAL",
  "FLUDROCORTISONE 0.1MG TABLETS",
  "FLUMAZENIL 0.5MG/5ML INJ, 5ML",
  "FLUNISOLIDE 0.025% NASALSOLN 25ML",
  "FLUOCINOLONE 0.01% CREAM 60GM",
  "FLUOCINOLONE 0.01% OIL DROPS (EAR)",
  "FLUOCINOLONE ACET 0.01% CRM 15GM",
  "FLUOCINOLONE ACET 0.01% SOLN 60ML",
  "FLUOCINOLONE ACET 0.025% CRM 15GM",
  "FLUOCINOLONE ACET 0.025% OINT 15GM",
  "FLUOCINOLONE ACET 0.025% OINT 60GM",
  "FLUOCINOLONE ACETONIDE BODY OIL",
  "FLUOCINOLONE ACETONIDE SCALP OIL",
  "FLUOCINONIDE 0.05% CREAM 60GM",
  "FLUOCINONIDE 0.05% GEL 15GM",
  "FLUOCINONIDE 0.05% OINTMENT 30GM",
  "FLUOCINONIDE 0.05% SOLN 60ML",
  "FLUOCINONIDE 0.1% CREAM 120GM",
  "FLUOCINONIDE -E 0.05% CREAM 60GM",
  "FLUORIDE 0.25MG F CHEWABLE TAB",
  "FLUORIDE 0.5MG F CHEWABLE TAB",
  "FLUORIDE 1.0MG F CHEWABLE TAB",
  "FLUORIDEX SENSITIVE PASTE",
  "FLUOROMETHOLONE 0.1% OPHTSUSP 5ML",
  "FLUOROURACIL 0.5% CREAM 30GM",
  "FLUOROURACIL 2% SOLUTION 10ML",
  "FLUOROURACIL 5% CREAM 40GM",
  "FLUOROURACIL 5% SOLUTION 10ML",
  "FLUOROURACIL 50MG/ML INJ, 10ML",
  "FLUOXETINE 10MG (PMDD) CAPSULES 28S",
  "FLUOXETINE 10MG CAP",
  "FLUOXETINE 10MG CAPSULES",
  "FLUOXETINE 10MG TABLETS",
  "FLUOXETINE 20MG (PMDD) CAPSULES 28S",
  "FLUOXETINE 20MG CAP",
  "FLUOXETINE 20MG CAPSULES",
  "FLUOXETINE 20MG TABLETS",
  "FLUOXETINE 20MG/5ML LIQUID",
  "FLUOXETINE 40MG CAP",
  "FLUOXETINE 90MG CAPSULES",
  "FLUPHENAZINE 10MG** TABLETS",
  "FLUPHENAZINE 1MG TABLETS",
  "FLUPHENAZINE 2.5MG TAB",
  "FLUPHENAZINE 5MG TABLETS",
  "FLUPHENAZINE 5MG TABLETS",
  "FLUPHENAZINE DEC 25MG/ML INJ",
  "FLURANDRENOLIDE 0.05% CREAM 120GM",
  "FLURANDRENOLIDE 0.05% LOTION",
  "FLURAZEPAM 15MG CAPSULES",
  "FLURAZEPAM 30MG CAPSULES",
  "FLURBIPROFEN 0.03% OPHTHSOLN 2.5ML",
  "FLURBIPROFEN 100MG TABLETS",
  "FLURBIPROFEN 50MG TABLETS",
  "FLUTAMIDE 125MG CAPSULES",
  "FLUTICASONE 0.005% OINTMENT 30GM",
  "FLUTICASONE 0.05% CREAM 60GM",
  "FLUTICASONE 0.05% LOTION 60ML",
  "FLUTICASONE NASAL SP (120INH) 16GM",
  "FLUVASTATIN 20MG CAPSULES",
  "FLUVASTATIN 40MG CAPSULES",
  "FLUVASTATIN ER 80MG TABLETS",
  "FLUVOXAMINE 100MG ER CAPSULES",
  "FLUVOXAMINE 100MG TABLETS",
  "FLUVOXAMINE 150MG ER CAPSULES",
  "FLUVOXAMINE 25MG TAB",
  "FLUVOXAMINE 50MG TABLETS",
  "FML OPHTH OINTMENT 3.5GM",
  "FOLBECAL TAB",
  "FOLBEE PLUS CZ TABLETS",
  "FOLBEE PLUS TAB",
  "FOLBEE TAB",
  "FOLGARD OS TABLETS",
  "FOLIC ACID 1MG TAB",
  "FOLIC ACID 5MG/ML INJ, 10ML",
  "FOLITAB 500MG TABLETS",
  "FOLIVANE-PLUS CAPSULES",
  "FOLLISTIM AQ (DLVRING 300IU) 0.42ML",
  "FOLLISTIM AQ (DLVRING 300IU) 0.42ML",
  "FOLLISTIM AQ (DLVRING 300IU) 0.42ML",
  "FOLLISTIM AQ (DLVRING 600IU) 0.78ML",
  "FOLLISTIM AQ (DLVRING 600IU) 0.78ML",
  "FOLLISTIM AQ (DLVRING 600IU) 0.78ML",
  "FOLLISTIM AQ (DLVRING 900IU) 1.17ML",
  "FOLLISTIM AQ (DLVRING 900IU) 1.17ML",
  "FOLLISTIM AQ VIAL 150IU/0.5ML",
  "FOLLISTIM AQ VIAL 75IU/0.5ML",
  "FOLPLEX 2.2 TABLETS",
  "FONDAPARINUX 10MG/0.8ML SL 2X0.8ML",
  "FONDAPARINUX 7.5MG/0.6ML SL 2X0.6ML",
  "FORTAVIT CAPSULES",
  "FORTEO 600MCG PEN(20MCG/DOSE)28DOSE",
  "FOSINOPRIL 10MG TAB",
  "FOSINOPRIL 20MG TAB",
  "FOSINOPRIL 40MG TAB",
  "FOSINOPRIL-HCTZ 10MG/12.5MG TABLETS",
  "FOSRENOL 1000MG CHEWABLE TABLETS",
  "FOSRENOL 500MG CHEWABLE TABLETS",
  "FRAGMIN 15,000IU/0.6ML INJ, 0.6ML",
  "FRESHKOTE DROPS",
  "FROVATRIPTAN 2.5MG TABLETS",
  "FUROSEMIDE 10MG/ML INJ, 2ML",
  "FUROSEMIDE 10MG/ML ORAL SOLN 60ML",
  "FUROSEMIDE 20MG TAB",
  "FUROSEMIDE 40MG TAB",
  "FUROSEMIDE 80MG TAB",
  "FUROSEMIDE 8MG/ML SOLUTION",
  "GABAPENTIN 100MG CAP",
  "GABAPENTIN 250MG/5ML SOLN\r\nHALOPERIDOL 0.5MG TAB",
  "GABAPENTIN 300MG CAPSULES",
  "GABAPENTIN 400MG CAPSULES",
  "GABAPENTIN 600MG TABLETS",
  "GABAPENTIN 800MG TABLETS",
  "GABITRIL 16MG TABLETS",
  "GALANTAMINE ER 16MG CAPSULES",
  "GALANTAMINE ER 24MG CAPSULES",
  "GALANTAMINE ER 8MG CAPSULES",
  "GALANTAMINE HBR 12MG TABLETS",
  "GALANTAMINE HBR 4MG TABLETS",
  "GALANTAMINE HBR 8MG TABLETS",
  "GAMMAGARD 10GM/100ML INJECTION",
  "GAMMAGARD SD 10GM HU INJ",
  "GAMMAGARD SD 2.5GM HU INJ",
  "GANIRELIX AC INJ 0.5ML",
  "GATIFLOXACIN 0.5% OPTH SOL 2.5ML",
  "GAVILYTE-G SOLUTION 4000ML",
  "GEMFIBROZIL 600MG TAB",
  "GEMZAR 1GM INJ, 1VL",
  "GENOTROPIN 0.2MG PREFILLED SYRINGES",
  "GENOTROPIN 0.4MG PREFILLED SYRINGES",
  "GENOTROPIN 0.6MG PREFILLED SYRINGES",
  "GENOTROPIN 1.2MG PREFILLED SYRINGES",
  "GENOTROPIN 1.4MG PREFILLED SYRINGES",
  "GENOTROPIN 1.6MG PREFILLED SYRINGES",
  "GENOTROPIN 1.8MG PREFILLED SYRINGES",
  "GENOTROPIN 12MG(13.8MG OVERFILL)1'S",
  "GENOTROPIN 2MG PREFILLED SYRINGES",
  "GENOTROPIN 5MG CARTRIDGE",
  "GENTAMICIN - GENTAK 0.3%OPHTH OINT",
  "GENTAMICIN 0.1% CREAM 30GM",
  "GENTAMICIN 0.1% OINT 15GM (TOPICAL)",
  "GENTAMICIN 0.3% OPHTH SOLN 5ML",
  "GENTAMICIN 40MG/ML INJ, 2ML",
  "GENTAMICIN SULFATE 10MG/ML INJ, 2ML",
  "GESTICARE DHA PAK (NEW FORMULA)",
  "GILPHEX TR 10-388MG TABLETS",
  "GLADASE 0.83MMU/GM OINTMENT 30GM",
  "GLATOPA 20MG/ML SOL FOR INJ 30X1ML",
  "GLIMEPIRIDE 1MG TAB",
  "GLIMEPIRIDE 2MG TAB",
  "GLIMEPIRIDE 4MG TAB",
  "GLIPIZIDE 10MG TAB",
  "GLIPIZIDE 5MG TAB",
  "GLIPIZIDE ER 10MG TAB",
  "GLIPIZIDE ER 2.5MG TABLET",
  "GLIPIZIDE XL 2.5MG TAB",
  "GLIPIZIDE XL 5MG TAB",
  "GLIPIZIDE XL 5MG TABLETS",
  "GLIPIZIDE-METFORMIN 2.5MG/250MG TAB",
  "GLIPIZIDE-METFORMIN 2.5MG/500MG TAB",
  "GLIPIZIDE-METFORMIN 5MG/500MG TABS",
  "GLYBURIDE 1.25MG TAB",
  "GLYBURIDE 2.5MG TAB",
  "GLYBURIDE 5MG TAB",
  "GLYBURIDE MICRO 1.5MG TAB",
  "GLYBURIDE MICRO 3MG TAB",
  "GLYBURIDE MICRO 6MG TAB",
  "GLYBURIDE/METFORMIN 1.25/250MG TAB",
  "GLYBURIDE/METFORMIN 2.5/500MG TAB",
  "GLYBURIDE/METFORMIN 5/500MG TABLETS",
  "GLYCOPYRROLATE 0.2MG/ML INJ, 20ML",
  "GLYCOPYRROLATE 1MG TABLETS",
  "GLYCOPYRROLATE 2MG TABLETS",
  "GONAL-F 1050UNIT INJ, 1 VIAL",
  "GONAL-F 450IU VIAL",
  "GONAL-F RFF 300IU INJ, 0.5ML",
  "GONAL-F RFF 450IU INJ, 0.75ML",
  "GONAL-F RFF 75IU INJ, 1 VIAL (10VL)",
  "GONAL-F RFF 900IU INJ, 1.5ML",
  "GRANISETRON 1MG TABLETS",
  "GRANISETRON 1MG/ML INJ, 1ML (PF)",
  "GRANIX 300MGG/0.5ML INJ, 0.5ML",
  "GRANIX 480MCG/0.8ML INJ, 0.8ML",
  "GRANULEX SPRAY 113.4GM",
  "GRISEOFULVIN 125MG/5ML ORAL SUSP",
  "GRISEOFULVIN MICR 500MG TABLETS",
  "GRISEOFULVIN ULTR 250MG TABLETS",
  "GUAIFENESIN DM SYRUP",
  "GUANFACINE 1MG TAB",
  "GUANFACINE 2MG TAB",
  "GUANFACINE ER 1MG TABLETS",
  "GUANFACINE ER 2MG TABLETS",
  "GUANFACINE ER 3MG TABLETS",
  "GUANFACINE ER 4MG TABLETS",
  "HALOBETASOL 0.05% CREAM 50GM",
  "HALOBETASOL 0.05% OINTMENT 50GM",
  "HALOG 0.1% CREAM 60GM",
  "HALOG 0.1% OINTMENT 60GM",
  "HALOPERIDOL 10MG (TEN MG) TABLETS",
  "HALOPERIDOL 1MG TAB",
  "HALOPERIDOL 20MG (TWENTY MG) TABLET",
  "HALOPERIDOL 2MG TAB",
  "HALOPERIDOL 2MG/ML CONCENTRATE",
  "HALOPERIDOL 5MG (FIVE MG) TABS",
  "HALOPERIDOL DEC 100MG/ML INJ, 1ML",
  "HALOPERIDOL DEC 50MG/ML INJ",
  "HALOPERIDOL DEC 50MG/ML INJ 3X1ML",
  "HALOPERIDOL LACTATE 5MG/ML INJ 10ML",
  "HALOTIN 1% CREAM 20GM",
  "HC PRAMOXINE 1-1% CREAM 30GM",
  "HC PRAMOXINE 2.5-1% CREAM 30GM",
  "HC PRAMOXINE 2.5-1% CREAM 48GM",
  "HECTOROL 1MCG CAPSULES",
  "HEMATINIC PLUS TAB 10 X 10",
  "HEMATINIC/ FA TAB",
  "HEMATOGEN FA CAPSULES",
  "HEMENATAL OB + DHA",
  "HEMOCYTE-F TABLETS",
  "HEPARIN L/FLUSH 10UNT/ML , 1ML",
  "HEPARIN LOCK FLUSH 100U/ML INJ, 5ML",
  "HEPARIN SOD 10,000U/ML INJ, 0.5ML",
  "HEPARIN SOD 10,000U/ML INJ, 1ML",
  "HEPARIN SOD 1000U/ML INJ, 2ML",
  "HEPARIN SOD 20,000/ML INJECTION,1ML",
  "HEPARIN SOD 5000U/ML INJ, 1ML",
  "HEPARIN SOD LOCK FLUSH INJ, 5ML",
  "HEPSERA 10MG TABLETS",
  "HERCEPTIN 440MG INJ, 1 VIAL",
  "HOMATROPINE (HOMATROPAIRE)5% OP SOL",
  "HUMALOG 100 U/ML KWIKPEN INJ 5X3ML",
  "HUMALOG 100/ML INJ, 3ML",
  "HUMALOG CARTRIDGE 5 X 3ML",
  "HUMALOG INSULIN (VL-7510) 10ML",
  "HUMALOG MIX 50/50 INJ, 10ML",
  "HUMALOG MIX 50/50 KWIKPEN INJ 5X3ML",
  "HUMALOG MIX 75/25 KWIKPEN INJ 5X3ML",
  "HUMALOG MIX 75/25 VIAL 10ML",
  "HUMATROPE 5MG INJ, VIAL",
  "HUMATROPE 6MG CARTRIGE KIT INJ",
  "HUMIRA 40MG/0.8ML KIT (2PRF SYR)",
  "HUMIRA PEN 40MG/0.8ML KIT(2 PENS)",
  "HUMULIN 70/30 INSULIN (HI-710)",
  "HUMULIN 70/30 U-100 KWIKPEN 5X3ML",
  "HUMULIN N INSULIN (HI-310)",
  "HUMULIN N U-100 KWIKPEN 5X3ML",
  "HUMULIN R U-100 INSULIN (HI-210)",
  "HUMULIN R U-500 (CONCEN) VL 20ML",
  "HYDRALAZINE 100MG (HUNDRED MG) TABS",
  "HYDRALAZINE 10MG TAB",
  "HYDRALAZINE 25MG TAB",
  "HYDRALAZINE 50MG TABLETS (ORANGE)",
  "HYDROCHLOROTHIAZIDE 12.5MG CAP",
  "HYDROCHLOROTHIAZIDE 25MG TAB",
  "HYDROCHLOROTHIAZIDE 50MG TAB",
  "HYDROCOD/ACETAMINOPHEN 7.5-325/15ML",
  "HYDROCODONE/ACETAMINOPHEN 10-325 T",
  "HYDROCODONE/ACETAMINOPHEN 5-300 TB",
  "HYDROCODONE/ACETAMINOPHEN 5-325 TB",
  "HYDROCODONE/ACETAMINOPHEN 7.5-300 T",
  "HYDROCODONE/ACETAMINOPHEN 7.5-325 T",
  "HYDROCODONE/CHLORPHEN ER SUSPENSION",
  "HYDROCODONE/HOMATROPINE 5/1.5MG TAB",
  "HYDROCODONE/IBUPROF 7.5-200MG TB",
  "HYDROCODONE/IBUPROFEN 10-200MG TAB",
  "HYDROCORT ACET/PRAMOX 2.5%-1% CREAM",
  "HYDROCORT BUTYRATE 0.1% SOLN 20ML",
  "HYDROCORT/ACETIC ACID OTIC SOL(EAR)",
  "HYDROCORTISONE 1% CREAM 28.35GM",
  "HYDROCORTISONE 1% IN ABSOBASE OINT",
  "HYDROCORTISONE 1%/IODOQUINOL 1% CRM",
  "HYDROCORTISONE 100MG ENEMA 7 X 60ML",
  "HYDROCORTISONE 10MG TABLETS",
  "HYDROCORTISONE 2.5% CREAM 30GM",
  "HYDROCORTISONE 2.5% LOTION 59ML",
  "HYDROCORTISONE 2.5% OINT 28.35GM",
  "HYDROCORTISONE 20MG TABLETS",
  "HYDROCORTISONE 5MG TAB",
  "HYDROCORTISONE 5MG TABLETS",
  "HYDROCORTISONE BUT 0.1% CREAM 15GM",
  "HYDROCORTISONE BUT 0.1% CREAM 15GM",
  "HYDROCORTISONE BUT 0.1% OINT 15GM",
  "HYDROCORTISONE BUTYR 0.1% CRM 45GM",
  "HYDROCORTISONE VAL 0.2% CREAM 15GM",
  "HYDROCORTISONE VAL 0.2% OINT 60GM",
  "HYDROMET (HYDROCOD/HOMA)5/1.5MG SYR",
  "HYDROMORPHONE 12MG ER TABLETS",
  "HYDROMORPHONE 16MG ER TABLETS",
  "HYDROMORPHONE 1MG/ML LIQUID",
  "HYDROMORPHONE 32MG ER TABLETS",
  "HYDROMORPHONE 4MG TABLETS",
  "HYDROMORPHONE 8MG ER TABLETS",
  "HYDROMORPHONE 8MG TABLETS",
  "HYDROMORPHONE HCL 2MG TABLETS",
  "HYDROQUINONE 4% CREAM 28.35GM",
  "HYDROXOCOBALAM 1000MCG/ML INJ, 30ML",
  "HYDROXYCHLOROQUINE 200MG TABLETS",
  "HYDROXYUREA 500MG CAPSULES",
  "HYDROXYZINE 10MG/5ML SYRUP",
  "HYDROXYZINE 10MG/5ML SYRUP",
  "HYDROXYZINE HCL 10MG TABLETS",
  "HYDROXYZINE HCL 25MG TAB",
  "HYDROXYZINE HCL 25MG/ML INJ 1ML",
  "HYDROXYZINE HCL 50MG TAB",
  "HYDROXYZINE HCL 50MG/ML INJ, 1ML",
  "HYDROXYZINE PAMOATE 100MG CAPSULES",
  "HYDROXYZINE PAMOATE 25MG CAP",
  "HYDROXYZINE PAMOATE 25MG CAPSULES",
  "HYDROXYZINE PAMOATE 50MG CAPSULES",
  "HYFIBER WITH FOS LIQUID 946ML",
  "HYOPHEN TABLETS",
  "HYOSCYAMINE 0.125MG ORAL DIS TABS",
  "HYOSCYAMINE 0.125MG SUBLINGUAL TABS",
  "HYOSCYAMINE 0.125MG TABLETS",
  "HYOSCYAMINE 0.375MG ER TABLETS",
  "HYOSCYAMINE 0.375MG ER TABLETS",
  "HYOSYNE 0.125/5ML ELXIR",
  "HYOSYNE 0.125/ML ORAL DROPS",
  "HYPERCARE 20% SOL DAB-O-MATIC 60ML",
  "IBANDRONATE SODIUM 150MG TABLETS",
  "IBUPROFEN 100MG/5ML ORAL SUSP",
  "IBUPROFEN 200MG TABLETS",
  "IBUPROFEN 400MG TAB",
  "IBUPROFEN 600MG TAB",
  "IBUPROFEN 800MG TAB",
  "IBUPROFEN 800MG TABLETS",
  "IFOSFAMIDE 1GM/20ML INJ,20ML",
  "IFOSFAMIDE 3GM/60ML INJ,60ML",
  "ILEVRO 0.3% OPHTH DROPS",
  "IMATINIB MESYLATE 100MG TABLETS",
  "IMATINIB MESYLATE 400MG TABLETS",
  "IMIPRAMINE 10MG TAB",
  "IMIPRAMINE 25MG TAB",
  "IMIPRAMINE 50MG TAB",
  "IMIPRAMINE PAMOATE 100MG CAPSULES",
  "IMIPRAMINE PAMOATE 125MG CAPSULES",
  "IMIPRAMINE PAMOATE 150MG CAPSULES",
  "IMIPRAMINE PAMOATE 75MG CAPSULES",
  "IMIQUIMOD 5% CREAM",
  "INDAPAMIDE 1.25MG TAB",
  "INDAPAMIDE 2.5MG TAB",
  "INDERAL XL 80MG CAPSULES",
  "INDOMETHACIN 25MG CAP",
  "INDOMETHACIN 50MG CAP",
  "INDOMETHACIN 75MG ER CAPSULES",
  "INFED 50MG/ML INJ",
  "INNOSPIRE ESSENCE COMPRES NEBULIZER",
  "INOVA 4/1 ACNE CONTROL THERAPY",
  "INTEGRA F CAPSULES",
  "INTELENCE 100MG TABLETS",
  "INTRALIPID 20% EMUL FOR INJ, 1000ML",
  "INTRON A 10 MIL IU POWDERSDV",
  "INTRON A 18 MIL IU POWDERSDV",
  "INTRON A 50 MIL IU POWDERSDV",
  "INVANZ 1GM INJ, 1 VIAL",
  "INVEGA SUSTENNA 117MG/0.75ML INJ",
  "INVEGA SUSTENNA 234MG/1.5ML INJ",
  "INVIRASE 200MG CAPSULES",
  "INVIRASE 500MG TABLETS",
  "INVOKANA 100MG TABLETS",
  "INVOKANA 300MG TABLETS",
  "IODOSORB 0.9% GEL 40GM",
  "IOPHEN DM-NR 10-100/5ML LIQUID",
  "IPRATROPI/ALB 0.5/3MG INH SL 30X3ML",
  "IPRATROPIUM 0.03% NAS SP 30ML (345)",
  "IPRATROPIUM 0.06% NAS SP 15ML (165)",
  "IPRATROPIUM INHAL SOLN 60 X 2.5ML",
  "IRBESARTAN 150MG TABLETS",
  "IRBESARTAN 300MG TABLETS",
  "IRBESARTAN 75MG TABLETS",
  "IRBESARTAN/HCTZ 150-12.5MG TABLETS",
  "IRBESARTAN/HCTZ 300-12.5MG TABLETS",
  "IRINOTECAN 20MG/ML SOL, 5ML",
  "IRINOTECAN 40MG/2ML INJ, 2ML",
  "IRO-PLEX TABLETS",
  "ISENTRESS 400MG TABLETS",
  "ISIBLOOM 0.15MG-0.03MG TABLETS 28S",
  "ISOMETH/ACETAMINOPHEN/DICHLOR CAPS",
  "ISONIAZID 300MG TABLETS",
  "ISONIAZID 50MG/5ML SYRUP",
  "ISOSORBIDE DINITRATE 10MG ORAL TABS",
  "ISOSORBIDE DINITRATE 2.5MG SL TAB",
  "ISOSORBIDE DINITRATE 20MG ORAL TABS",
  "ISOSORBIDE DINITRATE 30MG ORAL TABS",
  "ISOSORBIDE DINITRATE 40MGER TABS",
  "ISOSORBIDE DINITRATE 5MG ORAL TABS",
  "ISOSORBIDE DINITRATE 5MG SUBL TAB",
  "ISOSORBIDE MONONITRATE 10MG TABS",
  "ISOSORBIDE MONONITRATE 120MG ER TAB",
  "ISOSORBIDE MONONITRATE 20MG TABS",
  "ISOSORBIDE MONONITRATE 30MG ER TAB",
  "ISOSORBIDE MONONITRATE 60MG ER TAB",
  "ISRADIPINE 2.5MG CAPSULES",
  "ISRADIPINE 5MG CAPSULES",
  "ISTALOL 0.5% OPHTH SOLUTION 2.5ML",
  "ITRACONAZOLE 100MG CAPSULES",
  "IVERMECTIN 3MG TABLETS",
  "JANUMET 50/1000MG TABLETS",
  "JANUVIA 100MG TABLETS",
  "JANUVIA 25MG TABLETS",
  "JINTELI 1MG/5MCG TABLETS",
  "JOLIVETTE 0.35MG TAB",
  "JUBLIA 10% TOPICAL NAIL SOL 4ML",
  "JULUCA 50-25MG TABLETS",
  "K EFFERVESCENT 25MEQ TABLETS",
  "KALETRA 200-50MG TABLETS",
  "KERAFOAM 30% AER 60GM",
  "KETOCONAZOLE 2% CREAM 30GM",
  "KETOCONAZOLE 2% CREAM 60GM",
  "KETOCONAZOLE 2% SHAMPOO 120ML",
  "KETOCONAZOLE 200MG TABLETS",
  "KETOPROFEN 200MG E.R. CAPSULES",
  "KETOPROFEN 50MG CAP",
  "KETOPROFEN 50MG CAPSULES",
  "KETOPROFEN 75MG CAP",
  "KETOPROFEN 75MG CAPSULES",
  "KETOROLAC 0.4% OPTH SOLN5ML",
  "KETOROLAC 0.5% OPHTH SOLN 5ML",
  "KETOROLAC 10MG TABLETS",
  "KETOROLAC 15MG/ML INJ, 1ML",
  "KETOROLAC 30MG/ML INJ 1ML",
  "KETOROLAC 30MG/ML INJ, 2ML",
  "KETOROLAC 30MG/ML INJ, CARPUJECT LL",
  "KEYTRUDA 100MG/4ML INJ, 4ML",
  "KEYTRUDA 50MG SOLUTION",
  "KIONEX 15GM/60ML SUSPENSION",
  "KIONEX 15GM/60ML SUSPENSION",
  "KLOR-CON 10MEQ TAB",
  "KRISTALOSE 10GM PACKETS",
  "LABETALOL 100MG TABLETS",
  "LABETALOL 200MG TABLETS",
  "LABETALOL 300MG TABLETS",
  "LACTATED RINGERS INJ, 1000ML",
  "LACTIC ACID 10% E CREAM 113.4GM",
  "LACTULOSE 20GM/30ML SOLUTION",
  "LAMISIL 1% SOLUTION 30ML",
  "LAMIVUD/ZIDOVUD 150MG/300MG TABS",
  "LAMIVUDINE 100MG TABLETS",
  "LAMIVUDINE 150MG TABLETS",
  "LAMIVUDINE 300MG TABLETS",
  "LAMOTRIGINE 100MG TABLETS",
  "LAMOTRIGINE 150MG TABLETS",
  "LAMOTRIGINE 200MG TABLETS",
  "LAMOTRIGINE 25MG CHEW/DISPRSBL TAB",
  "LAMOTRIGINE 25MG TABLETS",
  "LAMOTRIGINE 300MG ER TABLETS",
  "LAMOTRIGINE 5MG CHEW/DISPRSBL TAB",
  "LAMOTRIGINE ER 100MG TABLETS",
  "LAMOTRIGINE ER 200MG TABLETS",
  "LAMOTRIGINE ER 250MG TABLETS",
  "LAMOTRIGINE ER 25MG TABLETS",
  "LAMOTRIGINE ER 50MG TABLETS",
  "LAMOTRIGINE ODT 100MG TABLETS",
  "LAMOTRIGINE ODT 200MG TABLETS",
  "LAMOTRIGINE ODT 25MG TABLETS",
  "LAMOTRIGINE ODT 50MG TABLETS",
  "LANSO/AMOX/CLAR PACK CARD",
  "LANSOPRAZOLE 15MG DR CAPSULES",
  "LANSOPRAZOLE 30MG DR CAPSULES",
  "LANTHANUM 750MG CHEWABLE TABLETS",
  "LANTUS SOLOSTAR PEN INJ 5 X 3ML",
  "LANTUS U-100 INSULIN 10ML",
  "LATANOPROST 0.005% OPHTH SOLN 2.5ML",
  "LATRIX 50% SUSPENSION",
  "LATUDA 40MG TABLETS",
  "LATUDA 80MG TABLETS",
  "LAVOCLEN-4% CREAMY WASH 170.1GM",
  "LAVOCLEN-8 ACNE WASH KIT",
  "LAYOLIS FE CHEW TABLETS",
  "LEENA TABLETS 28S",
  "LEFLUNOMIDE 10MG TABLETS",
  "LEFLUNOMIDE 20MG TABLETS",
  "LETROZOLE 2.5MG TABLETS",
  "LEUCOVOR CA 100MG INJ, 1ML",
  "LEUCOVORIN CALCIUM 10MG TABLETS",
  "LEUCOVORIN CALCIUM 5MG TABLETS",
  "LEUKERAN 2MG TABLETS",
  "LEUPROLIDE 1MG/0.2 ML 2-WK INJ KIT",
  "LEVALBUTEROL 0.31MG/3ML NEB 24X3ML",
  "LEVALBUTEROL 0.63MG/3ML NEB 25X3ML",
  "LEVALBUTEROL 1.25MG/3ML NEB 25X3ML",
  "LEVALBUTEROL CONC 1.25MG/0.5ML 30VL",
  "LEVALBUTEROL HFA INH (200PF) 15GM",
  "LEVEMIR 100 UNITS/ML VIAL",
  "LEVEMIR FLEX TOUCH PEN INJ 5X3ML",
  "LEVEMIR FLEXTOUCH PEN",
  "LEVEMIR SOLUTION FOR INJ, 10ML",
  "LEVETIRACETAM 1000MG TABLETS",
  "LEVETIRACETAM 100MG/ML SOLUTION",
  "LEVETIRACETAM 250MG TABLETS",
  "LEVETIRACETAM 500MG TABLETS",
  "LEVETIRACETAM 750MG TABLETS",
  "LEVETIRACETAM ER 500MG TABLETS",
  "LEVETIRACETAM ER 750MG TABLETS",
  "LEVITRA 10MG TABLETS",
  "LEVITRA 2.5MG TABLETS",
  "LEVITRA 20MG TABLETS",
  "LEVITRA 5MG TABLETS",
  "LEVO PYRIDOX PHOSPHA PWD CAPS",
  "LEVOBUNOLOL 0.5% OPTH SOLN 5ML",
  "LEVOCARNITINE 10% ORAL SOLUTION",
  "LEVOCARNITINE 200MG/ML INJ, 5ML",
  "LEVOCARNITINE 330MG TABLETS",
  "LEVOCETIRIZINE 2.5MG/5ML ORAL SOL",
  "LEVOCETIRIZINE 5MG TABLETS",
  "LEVOFLOXACIN 0.5% OPHTH SOLN 5ML",
  "LEVOFLOXACIN 250MG TABLETS",
  "LEVOFLOXACIN 500MG TABLETS",
  "LEVOFLOXACIN 750MG TABLETS",
  "LEVONOR/ETHINYL ESTRADIOL TABS 28S",
  "LEVOPHED 1MG/ML INJ, 4ML",
  "LEVOTHROID 0.1MG TAB",
  "LEVOTHYROXIN/LIOTHYRONINE 90MG TABS",
  "LEVOTHYROXINE 0.025MG (25MCG) TAB",
  "LEVOTHYROXINE 0.05MG (50MCG) TAB",
  "LEVOTHYROXINE 0.075MG (75MCG) TAB",
  "LEVOTHYROXINE 0.088MG (88MCG) TAB",
  "LEVOTHYROXINE 0.100MG (100MCG) TAB",
  "LEVOTHYROXINE 0.112MG (112MCG) TAB",
  "LEVOTHYROXINE 0.125MG (125MCG) TAB",
  "LEVOTHYROXINE 0.137MG (137MCG) TAB",
  "LEVOTHYROXINE 0.150MG (150MCG) TAB",
  "LEVOTHYROXINE 0.175MG (175MCG) TAB",
  "LEVOTHYROXINE 0.2MG (200MCG) TAB",
  "LEVOTHYROXINE 0.3MG (300MCG) TAB",
  "LEXIVA 700MG TABLETS",
  "LIALDA 1.2GM TABLETS",
  "LIDOCAINE 1% INJ, 10ML",
  "LIDOCAINE 1% INJ, 30ML",
  "LIDOCAINE 1% INJ, 5ML",
  "LIDOCAINE 1%/EPINE:100000 INJ, 20ML",
  "LIDOCAINE 10MG/ML INJ, 5ML",
  "LIDOCAINE 2% INJ, 10ML",
  "LIDOCAINE 2% INJ, 50ML",
  "LIDOCAINE 2% TOPICAL JELLY 30ML",
  "LIDOCAINE 2%/EPINEPHRINE 0.001% INJ",
  "LIDOCAINE 3% CREAM 28.35GM",
  "LIDOCAINE 3% CREAM 85GM",
  "LIDOCAINE 3%/HC 0.5% CREAM 14X7GM",
  "LIDOCAINE 3%/HC 0.5% CREAM 28.35GM",
  "LIDOCAINE 4% INJECTION, 5ML",
  "LIDOCAINE 5% PATCH",
  "LIDOCAINE 5% TOPICAL OINTMENT 30GM",
  "LIDOCAINE VISCOUS 2% ORAL SOL 100ML",
  "LIDOCAINE/HC 3%-1% KIT",
  "LIDOCAINE/HC 3%-1% KIT",
  "LIDOCAINE/HC 3-2.5% KIT",
  "LIDOCAINE/HC 3-2.5% KIT",
  "LIDOCAINE/PRILOCAINE CREAM 30GM",
  "LIDOCAINE-HYDROCORTISONEW/ALOE GEL",
  "LIMBREL 250MG CAPSULES",
  "LIMBREL 500MG CAPSULES",
  "LINCOCIN VIAL 300MG/ML2ML",
  "LINDAMYCIN 300MG CAP",
  "LINDANE 1% LOTION 60ML",
  "LINDANE 1% SHAMPOO",
  "LINEZOLID 100MG/5ML ORALSUSP 150ML",
  "LINEZOLID 600MG TABLETS",
  "LIOTHYRONINE 25MCG TABLETS",
  "LIOTHYRONINE 50MCG** TABLETS",
  "LIOTHYRONINE 5MCG TABLETS",
  "LIPOCHOL PLUS TABLETS",
  "LISINOPRIL 10MG TAB",
  "LISINOPRIL 2.5MG TAB",
  "LISINOPRIL 20MG TAB",
  "LISINOPRIL 30MG TAB",
  "LISINOPRIL 40MG TAB",
  "LISINOPRIL 5MG TAB",
  "LISINOPRIL-HCTZ 10/12.5MG TAB",
  "LISINOPRIL-HCTZ 20/12.5MG TAB",
  "LISINOPRIL-HCTZ 20/25MG TAB",
  "LITHIUM CARBONATE 150MG CAP",
  "LITHIUM CARBONATE 300MG CAP",
  "LITHIUM CARBONATE 300MG TAB",
  "LITHIUM CARBONATE 600MG CAP",
  "LITHIUM CARBONATE ER 300MG TABLETS",
  "LITHIUM CARBONATE ER 450MG TABLETS",
  "LIVALO 2MG TABLETS",
  "L-METHYLFOLATE 15MG TABLETS",
  "L-METHYLFOLATE 7.5MG TABLETS",
  "L-METHYLFOLATE W/B6-B12 TABLETS",
  "L-METHYL-MC NAC TABLETS",
  "L-M-X 4% CREAM 15GM",
  "LO LOESTRIN FE TABLETS 28S",
  "LOCOID 0.1% LOTION 59ML",
  "LOPERAMIDE 2MG CAPSULES",
  "LOPREEZA 0.5MG/0.1MG TABLETS 28'S",
  "LOPREEZA 1MG/0.5MG TABLETS 28'S",
  "LORATADINE 10MG TAB",
  "LORAZEPAM 0.5MG TABLETS",
  "LORAZEPAM 1MG TABLETS",
  "LORAZEPAM 2MG TABLETS",
  "LORAZEPAM 2MG/ML DROPS 30ML",
  "LORAZEPAM 2MG/ML DROPS 30ML",
  "LOSARTAN 100MG TABLETS",
  "LOSARTAN 25MG TABLETS",
  "LOSARTAN 50MG TABLETS",
  "LOSARTAN/HCTZ 100/12.5MG TABLETS",
  "LOSARTAN/HCTZ 100/25MG TABLETS",
  "LOSARTAN/HCTZ 50/12.5MG TABLETS",
  "LOTEMAX 0.5% OPHTH OINTMENT",
  "LOTEMAX 0.5% OPHTHALMIC SUSP 5ML",
  "LOTEMAX 0.5% OPTH GEL DROPS 5GM",
  "LOVASTATIN 10MG TAB",
  "LOVASTATIN 20MG TAB",
  "LOVASTATIN 40MG TAB",
  "LOW-OGESTREL TAB",
  "LOW-OGESTREL TABLETS 28",
  "LOXAPINE 10MG CAPSULES",
  "LOXAPINE 25MG CAPSULES",
  "LOXAPINE 50MG (FIFTY MG) CAPSULES",
  "LOXAPINE 5MG CAPSULES",
  "LUDENT 1MG F CHEWABLE TABLETS",
  "LUGOLS SOLUTION (STRONG IODINE 5%)",
  "LUMIGAN 0.01% OPHTH SOLN 2.5ML",
  "LUPRON DEPOT 11.25MG INJ/3 MTH KIT",
  "LUPRON DEPOT 22.5MG INJ KIT (3MTH)",
  "LUPRON DEPOT 3.75MG INJ/1MTH KIT",
  "LUPRON DEPOT 45MG INJ/6 MTH KIT",
  "LUPRON DEPOT 7.5MG INJ/1MTH KIT",
  "LUPRON DEPOT-PED 11.25MGINJ/1 MTH",
  "LUPRON DEPOT-PED 15MG INJ/1 MTH KIT",
  "LUPRON DEPOT-PED 7.5MG INJ/1MTH KIT",
  "LUTERA TAB",
  "LUZU 1% CREAM 60GM",
  "LYRICA 100MG CAPSULES",
  "LYRICA 150MG CAPSULES",
  "LYRICA 200MG CAPSULES",
  "LYRICA 50MG CAPSULES",
  "LYRICA 75MG CAPSULES",
  "LYSIPLEX PLUS TABLETS",
  "LYSODREN 500MG TABLETS",
  "LYSTEDA 650MG TABLETS",
  "MAGNESIUM SULFATE 50% INJ, 10ML",
  "MAGNESIUM SULFATE 50% INJ, 50ML",
  "MALATHION 0.5% LOTION 59ML",
  "MANGANESE SULF 0.1MG/ML INJ , 10ML",
  "MAPROTILINE 25MG TABLETS",
  "MAPROTILINE 50MG TABLETS",
  "MAPROTILINE 75MG TABLETS",
  "MARGESIC CAPSULES",
  "MATZIM LA 180MG TABLETS",
  "MATZIM LA 240MG TABLETS",
  "MATZIM LA 360MG TABLETS",
  "MECLIZINE 12.5MG (RX) TABLETS",
  "MECLIZINE 25MG RX TABLETS",
  "MECLOFENAMATE 100MG CAPSULES",
  "MEDROXYPROGESTERONE 150MG/ML PF SYR",
  "MEDROXYPROGESTERONE 150MG/ML VIAL",
  "MEDROXYPROGESTERONE 2.5MG TAB",
  "MEDROXYPROGESTERONE 2.5MG TABLETS",
  "MEFENAMIC ACID 250MG CAPSULES",
  "MEFLOQUINE 250MG TABLETS",
  "MEGESTROL ACETATE 40MG TABLETS",
  "MEGESTROL ACETATE 40MG/ML SUSP",
  "MELOXICAM 15MG TAB",
  "MELOXICAM 7.5MG TAB",
  "MEMANTINE 10MG TABLETS",
  "MEMANTINE 2MG/ML SOLUTION",
  "MEMANTINE 5MG TABLETS",
  "MEMANTINE ER 14MG CAPSULES",
  "MEMANTINE ER 21MG CAPSULES",
  "MEMANTINE ER 28MG CAPSULES",
  "MEMANTINE TABLETS TITRATION PAK",
  "MENOPUR 75 UNIT INJ, 1VIAL",
  "MEPERIDINE 50MG TABLETS",
  "MEPERIDINE 50MG/ML INJ, 1ML",
  "MEPROBAMATE 200MG TABLETS",
  "MEPROBAMATE 400MG TABLETS",
  "MERCAPTOPURINE (6-MP) 50MG TABLETS",
  "MESALAMINE 1.2GM TABLETS",
  "MESALAMINE 4GM KIT( 7 X 60ML)",
  "MESALAMINE RECTAL SUSP 7X60ML",
  "METAPROTERENOL 10MG TABLETS",
  "METAPROTERENOL 20MG TABLETS",
  "METAXALONE 400MG TABLETS",
  "METAXALONE 800MG TABLETS",
  "METFORMIN 1000MG TAB",
  "METFORMIN 500MG TAB",
  "METFORMIN 850MG TAB",
  "METFORMIN ER 1000MG MODIFIED TABS",
  "METFORMIN ER 1000MG OSMOTIC TABS",
  "METFORMIN ER 500MG 24HR TAB",
  "METFORMIN ER 500MG OSMOTIC TABS",
  "METFORMIN ER 750MG 24HR TABS",
  "METHADONE 10MG TABLETS",
  "METHADONE 5MG TABLETS",
  "METHADONE 5MG/5ML SOLN",
  "METHAMPHETAMINE 5MG TABLETS",
  "METHAZOLAMIDE 25MG TABLETS",
  "METHAZOLAMIDE 50MG TABLETS",
  "METHENAMINE HIPPURATE 1GMTABLETS",
  "METHENAMINE MANDELATE 1GM TABLETS",
  "METHIMAZOLE 10MG TAB",
  "METHIMAZOLE 5MG TAB",
  "METHOCARBAMOL 500MG TAB",
  "METHOCARBAMOL 750MG TAB",
  "METHOTREXATE 2.5MG TABLETS - YELLOW",
  "METHOTREXATE 25MG/ML PRESV MULT USE",
  "METHOTREXATE 25MG/ML PRESV MULT USE",
  "METHOTREXATE 50MG/2ML PFSINGLE USE",
  "METHSCOPOLAMINE BR 2.5MG TABLETS",
  "METHSCOPOLAMINE BR 5MG TABLETS",
  "METHYCLOTHIAZIDE 5MG TABS",
  "METHYLDOPA 250MG TAB",
  "METHYLDOPA 500MG TAB",
  "METHYLDOPA/HCTZ 250/15MG TABS",
  "METHYLDOPA/HCTZ 250/25MGTABLETS",
  "METHYLENE BLUE 1% INJ, 10ML",
  "METHYLPHENIDATE 10MG ER TABLETS",
  "METHYLPHENIDATE 10MG TABLETS",
  "METHYLPHENIDATE 10MG/5ML ORAL SOLN",
  "METHYLPHENIDATE 18MG ER TABLETS",
  "METHYLPHENIDATE 20MG ER (LA) CAPS",
  "METHYLPHENIDATE 20MG ER TABLETS",
  "METHYLPHENIDATE 20MG TABLETS",
  "METHYLPHENIDATE 27MG ER TABLETS",
  "METHYLPHENIDATE 30MG ER (LA) CAPS",
  "METHYLPHENIDATE 36MG ER TABLETS",
  "METHYLPHENIDATE 40MG ER (LA) CAPS",
  "METHYLPHENIDATE 54MG ER TABLETS",
  "METHYLPHENIDATE 5MG TABLETS",
  "METHYLPHENIDATE 5MG/5ML ORAL SOLN",
  "METHYLPHENIDATE CD 10MG CAPSULES",
  "METHYLPHENIDATE CD 20MG CAPSULES",
  "METHYLPHENIDATE CD 30MG CAPSULES",
  "METHYLPHENIDATE CD 40MG CAPSULES",
  "METHYLPHENIDATE CD 50MG CAPSULES",
  "METHYLPHENIDATE CD 60MG CAPSULES",
  "METHYLPR ACE 40MG/ML INJ, 10ML",
  "METHYLPRED ACE 80MG/ML INJ, 1ML",
  "METHYLPREDNISOLONE 16MG TABLETS",
  "METHYLPREDNISOLONE 32MG TABS",
  "METHYLPREDNISOLONE 4MG DOSPAK 21'S",
  "METHYLPREDNISOLONE 4MG TABLETS",
  "METHYLPREDNISOLONE 8MG TABLETS",
  "METIPRANOLOL 0.3% OPTH SOLN 10ML",
  "METOCLOPRAM 5MG/ML INJ, 2ML",
  "METOCLOPRAM 5MG/ML INJ, 2ML",
  "METOCLOPRAMIDE 10MG TAB",
  "METOCLOPRAMIDE 5MG TAB",
  "METOCLOPRAMIDE HCL 5MG/5ML SOLN",
  "METOLAZONE 10MG TABLETS",
  "METOLAZONE 2.5MG TABLETS",
  "METOLAZONE 5MG TABLETS",
  "METOPROLOL ER SUCCINATE 100MG TABS",
  "METOPROLOL ER SUCCINATE 200MG TABS",
  "METOPROLOL ER SUCCINATE 25MG TABS",
  "METOPROLOL ER SUCCINATE 50MG TABS",
  "METOPROLOL HCT 100/25MG TABLETS",
  "METOPROLOL HCT 100/50MG TABLETS",
  "METOPROLOL HCT 50/25MG TABLETS",
  "METOPROLOL TARTRATE 100MG TAB",
  "METOPROLOL TARTRATE 25MG TAB",
  "METOPROLOL TARTRATE 50MG TAB",
  "METRONIDAZOLE 0.75% TOPICAL CRM 45G",
  "METRONIDAZOLE 0.75% TOPICAL GEL 45G",
  "METRONIDAZOLE 0.75% TOPICAL LOTION",
  "METRONIDAZOLE 0.75% VAGINAL GEL 70G",
  "METRONIDAZOLE 1% TOPICAL GEL PUMP",
  "METRONIDAZOLE 1% TOPICAL GEL TUBE",
  "METRONIDAZOLE 250MG TAB",
  "METRONIDAZOLE 500MG TAB",
  "METRONIDAZOLE/NACL 500MG INJ, 100ML",
  "MEXILETINE 150MG CAPSULES",
  "MEXILETINE 200MG CAPSULES",
  "MEXILETINE 250MG CAPSULES",
  "MICONAZOLE 2% VAGINAL CREAM 45GM",
  "MICONAZOLE 3 DS VAG SUPP 3'S",
  "MICROGESTIN 1.5/30 TAB 21",
  "MICROGESTIN 1/20 FE TABS 28S",
  "MICROGESTIN 1/20 TABS 21S WHITE",
  "MIDAZOLAM 1MG/ML INJ, 2ML",
  "MIDAZOLAM 2MG/2ML INJECTION 2ML",
  "MIDAZOLAM 5MG/ML INJ, 1ML",
  "MIDODRINE 10MG TABLETS",
  "MIDODRINE 2.5MG TABLETS",
  "MIDODRINE 5MG TABLETS",
  "MIGRANAL 4.0MG/ML NASAL SPRAY",
  "MILRINONE DW5 INJ, 100ML",
  "MINOCYCLINE 100MG CAPSULES",
  "MINOCYCLINE 100MG TABLETS",
  "MINOCYCLINE 100MG TABLETS",
  "MINOCYCLINE 50MG CAPSULES",
  "MINOCYCLINE 50MG TABLETS",
  "MINOCYCLINE 75MG CAPSULES",
  "MINOCYCLINE 75MG TABLETS",
  "MINOXIDIL 10MG TABLETS",
  "MINOXIDIL 2.5MG TABLETS",
  "MIRENA IUD SYSTEM",
  "MIRTAZAPINE 15MG ORAL DSNTGRT TABS",
  "MIRTAZAPINE 15MG TAB",
  "MIRTAZAPINE 30MG ORAL DSNTGRT TABS",
  "MIRTAZAPINE 30MG TABLETS",
  "MIRTAZAPINE 45MG ORAL DSNTGRT TABS",
  "MIRTAZAPINE 45MG TABLETS",
  "MIRTAZAPINE 7.5MG TABLETS",
  "MISOPROSTOL 100MCG TABLETS",
  "MISOPROSTOL 200MCG TABLETS",
  "MITOMYCIN 20MG INJ, 1VIAL",
  "MITOMYCIN 40MG INJ 1VIAL",
  "MITOMYCIN 5MG INJ, 1 VIAL",
  "MITOXANTRON 2MG/ML INJ 10ML VIAL",
  "MODAFINIL 100MG TABLETS",
  "MODAFINIL 200MG TABLETS",
  "MOEXIPRIL 15MG TABLETS",
  "MOEXIPRIL 7.5MG TABLETS",
  "MOEXIPRIL/HCTZ 15-12.5MG TABLETS",
  "MOEXIPRIL/HCTZ 15-25MG TABLETS",
  "MOEXIPRIL/HCTZ 7.5-12.5MG TABLETS",
  "MOMETASONE 0.1% CREAM 15GM",
  "MOMETASONE 0.1% OINT 15GM",
  "MOMETASONE 0.1% OINT 45GM",
  "MOMETASONE 0.1% OINTMENT 45GM",
  "MOMETASONE 0.1% TOP SOLN/LOT 30ML",
  "MOMETASONE 0.1% TOP SOLN/LOT 60ML",
  "MOMETASONE 0.1% TOPICAL SOLN 60ML",
  "MOMETASONE 50MCG NASAL SPRAY (120)",
  "MONONESSA TAB",
  "MONONINE 500IU INJ",
  "MONTELUKAST 10MG TABLETS",
  "MONTELUKAST 4MG CHEW TABS",
  "MONTELUKAST 4MG ORAL GRANULES",
  "MONTELUKAST 5MG CHEW TABS",
  "MORGIDOX 100MG KIT 1 (30 CAPS&WASH)",
  "MORPHINE SUL 100MG/5ML(20MG/ML) SOL",
  "MORPHINE SUL 10MG/5ML(2MG/ML) SOL",
  "MORPHINE SUL 20MG/5ML(4MG/ML) SOL",
  "MORPHINE SUL 25MG/ML INJ , 20ML",
  "MORPHINE SULF 100MG ER TABS (12H)",
  "MORPHINE SULF 10MG/ML SYR, 1ML",
  "MORPHINE SULF 15MG ER TABS (12H)",
  "MORPHINE SULF 200MG ER TABS (12H)",
  "MORPHINE SULF 60MG ER TABS (12H)",
  "MORPHINE SULF 80MG ER CAPS (24H)",
  "MORPHINE SULF ER 100MG CAPS (24H)",
  "MORPHINE SULF ER 20MG CAPS (24H)",
  "MORPHINE SULF ER 30MG CAPS (24H)",
  "MORPHINE SULF ER 50MG CAPS (24H)",
  "MORPHINE SULFATE 30MG ER CAPS (24H)",
  "MORPHINE SULFATE 30MG ER TABS (12H)",
  "MORPHINE SULFATE 60MG ER CAPS (24H)",
  "MORPHINE SULFATE ER 10MG CAPS (24H)",
  "MORPHINE SULFATE ER 60MG CAPS (24H)",
  "MORPHINE SULFATE IMM REL 15MG TAB",
  "MORPHINE SULFATE IMM REL 30MG TAB",
  "MOVIPREP SOLUTION",
  "MOXEZA 0.5% OPHTH SOLN 3ML",
  "MOXIFLOXACIN 0.5% OPHTH SOLN 3ML",
  "MOXIFLOXACIN 400MG TABLETS",
  "MULTAQ 400MG TABLETS",
  "MULTIGEN FOLIC TABLETS",
  "MULTIGEN PLUS TABLETS",
  "MULTIGEN TABLETS",
  "MULTI-NATE DHA EXTR PAK",
  "MULTITRACE-4 CONC INJ , 1ML",
  "MULTITRACE-4 PED INJ, 3ML",
  "MULTIVIT/F 0.25MG CHEWABLE TAB",
  "MULTIVIT/F 0.25MG CHEWABLE TABS",
  "MULTI-VIT/FE /FL 0.25MG DROPS 50ML",
  "MULTI-VIT/FE/ FL 0.25MG DROPS 50ML",
  "MULTI-VIT/FL 0.25MG DROPS 50ML",
  "MULTI-VIT/FLUORIDE 1MG CHEW TAB",
  "MULTI-VITA-F 0.5MG CHEW TAB",
  "MULTIVITAMIN W/FL .5MG/ML ORAL DROP",
  "MULTIVITAMIN W/FL .5MG/ML ORAL DROP",
  "MULTIVITAMINS W/ FL 1.0MG CHEW TAB",
  "MULTIVITS W/FL 1MG & IRON CHEW TAB",
  "MUPIROCIN 2% CREAM 15GM",
  "MUPIROCIN 2% OINTMENT 22GM",
  "MYCOPHENOLATE 200MG/ML SUSP 160ML",
  "MYCOPHENOLATE 250MG CAPSULES",
  "MYCOPHENOLATE 500MG TABLETS",
  "MYCOPHENOLIC 180MG DR TABLETS",
  "MYCOPHENOLIC ACID 360MG DR TABLETS",
  "NABUMETONE 500MG TABLETS",
  "NABUMETONE 750MG TABLETS",
  "NADOLOL 20MG TABLETS",
  "NADOLOL 40MG TABLETS",
  "NADOLOL 80MG TABLETS",
  "NADOLOL/BEND 40/5MG TABLETS",
  "NAFCILLIN 10GM INJ, 1VIAL",
  "NAFCILLIN 2GM INJ, 1VIAL",
  "NAFTIFINE 2% CREAM 45GM",
  "NAFTIFINE HCL 1% CREAM 90GM",
  "NAFTIN 1% CREAM 60GM",
  "NAFTIN 1% CREAM 90GM",
  "NAFTIN 1% GEL 40GM",
  "NALBUPHINE 10MG/ML INJ , 10ML",
  "NALBUPHINE 10MG/ML INJECTION 10X1ML",
  "NALBUPHINE 20MG/ML INJ, 10ML",
  "NALBUPHINE 20MG/ML INJ, 1ML",
  "NALTREXONE 50MG TABLETS",
  "NAPHAZOLINE 0.1% OPTH SOL 15ML",
  "NAPROXEN 125MG/5ML SUSPENSION",
  "NAPROXEN 250MG TAB",
  "NAPROXEN 375MG TAB",
  "NAPROXEN 500MG TAB",
  "NAPROXEN DR 500MG TAB",
  "NAPROXEN DR/EC 375MG TABLETS",
  "NAPROXEN DR/EC 500MG TABLETS",
  "NAPROXEN SOD 500MG CR TABLETS",
  "NAPROXEN SODIUM 275MG TABLETS",
  "NAPROXEN SODIUM 550MG TABLETS",
  "NARATRIPTAN 1MG TABLETS",
  "NARATRIPTAN 2.5MG TABLETS",
  "NASONEX 50MCG NASAL SPRAY (120 SP)",
  "NATALCARE PLUS TAB (1MG FOLIC ACID)",
  "NATAZIA TABLETS 28",
  "NATEGLINIDE 120MG TABLETS",
  "NATEGLINIDE 60MG TABLETS",
  "NATURE-THROID 0.5GR (32.5MG) TAB",
  "NATURE-THROID 113.75MG TABLETS",
  "NATURE-THROID 1GR (65MG)TABLETS",
  "NATURE-THROID 3GR (195MG) TABLETS",
  "NEBULIZER *VIOS LC PLUS (PARI)",
  "NEBULIZER REPLACEMENT KIT",
  "NECON 0.5/35 TABLETS 28 (BLUE)",
  "NECON 1/35 TAB",
  "NECON 1/50 TABLETS 28S",
  "NECON 10/11 TABLETS 28",
  "NECON 7/ 7/ 7 TABLETS 28S",
  "NEFAZODONE 100MG TABLETS",
  "NEFAZODONE 150MG TABLETS",
  "NEFAZODONE 200MG TABLETS",
  "NEFAZODONE 250MG TABLETS",
  "NEFAZODONE 50MG TABLETS",
  "NEO/POLY/DEX 0.1% OPTH OINT 3.5GM",
  "NEO/POLY/DEX OPHTH SUSP 5ML",
  "NEO/POLY/GRAM OPHTH SOLN10ML",
  "NEO/POLY/HC 1% OTIC SOL BLUE (EAR)",
  "NEO/POLY/HC 1% OTIC SUSPGREEN(EAR)",
  "NEO/POLY/HC OPTH SUSP 7.5ML",
  "NEOMYCIN 500MG TABLETS",
  "NEOMYCIN/POLYMY IRRIGATION ONLY SOL",
  "NEOSALUS FOAM 70GM",
  "NEPHPLEX RX TABLETS",
  "NERVIDOX-6 NR TABLETS",
  "NEULASTA 6MG/0.6ML SYR FOR INJ",
  "NEUPOGEN 300MCG/0.5ML, 0.5ML",
  "NEUPOGEN 300MCG/ML (480MCG/1.6ML)",
  "NEUPOGEN 300MCG/ML 1ML VIAL",
  "NEUPOGEN 480MCG/0.8ML(600MCG/ML)PFS",
  "NEURIN-SL TABLETS",
  "NEVIRAPINE 200MG TABLETS",
  "NEVIRAPINE 400MG ER TABLETS",
  "NEXIUM 10MG DR PWDR PKT FOR SUSP-30",
  "NEXIUM 20MG DR PWDR PKT FOR SUSP-30",
  "NEXIUM 40MG DR PWDR PKT FOR SUSP-30",
  "NIACIN 500MG ER TABLETS",
  "NIACIN 750MG ER TABLETS",
  "NIACIN ER 1000MG TABLETS",
  "NICARDIPINE 20MG CAPSULES",
  "NICARDIPINE 30MG CAPSULES",
  "NICOTINE 14MG/24H PATCH",
  "NICOTINE 7MG/24H PATCH",
  "NICOTINE TD 21MG/24H PATCH",
  "NIFEDIPINE 10MG CAPSULES",
  "NIFEDIPINE 20MG CAPSULES",
  "NIFEDIPINE 30MG ER (CC) TABLETS",
  "NIFEDIPINE 30MG ER (XL/OSM) TABLETS",
  "NIFEDIPINE 60MG ER (CC) TABLETS",
  "NIFEDIPINE 60MG ER (XL/OS) TABLETS",
  "NIFEDIPINE 90MG ER (CC) TABLETS",
  "NIFEDIPINE 90MG ER (XL/OSM) TABLET",
  "NIMODIPINE 30MG CAPSULES",
  "NISOLDIPINE ER 17MG TABLETS",
  "NISOLDIPINE ER 20MG TABLETS",
  "NISOLDIPINE ER 30MG TABLETS",
  "NISOLDIPINE ER 8.5MG TABLETS",
  "NITROFURANT MAC 25MG CAPSULES",
  "NITROFURANTOIN 25MG/5ML ORAL SUSP",
  "NITROFURANTOIN MACRO 100MG CAPSULES",
  "NITROFURANTOIN MACRO 50MG CAPSULES",
  "NITROFURANTOIN MONO/MAC 100MG CAPS",
  "NITROGLYCER 0.4MG/HR PATCHES 30'S",
  "NITROGLYCERIN 0.1 MG/HR PATCH 30'S",
  "NITROGLYCERIN 0.1 MG/HR PATCH 30'S",
  "NITROGLYCERIN 0.2MG/HR PATCHES",
  "NITROGLYCERIN 0.4MG SUB TAB 25",
  "NITROGLYCERIN 0.6MG SUB TABS 100",
  "NITROGLYCERIN 2.5MG TD CAPSULES",
  "NITROGLYCERIN 400MCG SPRAY 60 DOSES",
  "NITROGLYCERIN 6.5MG ER CAPSULES",
  "NITROGLYCERIN 9MG ER CAPSULES",
  "NITROQUICK 0.3MG SUBLINGUAL TABS",
  "NITRO-TIME 2.5MG ER CAPSULES",
  "NIVA-PLUS TABLETS",
  "NIZATIDINE 150MG CAP",
  "NIZATIDINE 15MG/ML SOLUTION",
  "NIZATIDINE 300MG CAPSULES",
  "NOHIST TAB",
  "NORDITROPIN FLEXPRO 10MG/1.5ML INJ",
  "NORDITROPIN FLEXPRO 5MG/1.5ML INJ",
  "NORETH/ETHIN 24 FE 1/20 CHEW TB 28S",
  "NORETH/ETHIN EST 0.5-2.5MCG TABLETS",
  "NORETHINDRONE 0.35MG TABLETS 28'S",
  "NORETHINDRONE 5MG TABLETS",
  "NORITATE 1% CREAM 60GM",
  "NORMOSOL -R INJ SOLUTION 1000ML",
  "NORPACE CR 100MG CAPSULES",
  "NORPACE CR 150MG CAPSULES",
  "NORTREL 1/35 TABLETS 28",
  "NORTRIPTYLINE 10MG CAP",
  "NORTRIPTYLINE 10MG/5ML SOLN",
  "NORTRIPTYLINE 25MG CAP",
  "NORTRIPTYLINE 25MG CAPSULES",
  "NORTRIPTYLINE 50MG CAPSULES",
  "NORTRIPTYLINE 75MG CAP",
  "NORTRIPTYLINE 75MG CAPSULES",
  "NORTUSS-EX LIQUID",
  "NORVIR 80MG/ML ORAL SOLUTION",
  "NOVOLIN 70/30 100 UNIT/ML VIAL",
  "NOVOLIN INSULIN 70/30 HUMAN",
  "NOVOLIN INSULIN NPH U-100 HUMAN",
  "NOVOLIN INSULIN REG. U-100 HUMAN",
  "NOVOLIN N 100 UNITS/ML VIAL",
  "NOVOLIN R 100 UNITS/ML VIAL",
  "NOVOLOG 100 UNIT/ML VIAL",
  "NOVOLOG FLEXPEN",
  "NOVOLOG FLEXPEN INJ 5X3ML (ORANGE)",
  "NOVOLOG MIX 70/30 FLEXPEN",
  "NOVOLOG MIX 70/30 FLEXPEN SYR(BLUE)",
  "NOVOLOG MIX 70/30 SUS VL10ML(BLUE)",
  "NOVOLOG MIX 70/30 VIAL",
  "NOVOLOG PENFILL 3 ML",
  "NOVOLOG PENFILL 3ML (ORANGE)",
  "NOVOLOG U-100 INSULIN VL10ML(ORANG)",
  "NOXAFIL 40MG/ML SUSPENSION",
  "NP THYROID 15MG TABLETS",
  "NP THYROID 1GR (60MG) TABLETS",
  "NP THYROID 2GR (120MG) TABLETS",
  "NULYTELY SOLUTION WITH FLAVOR PACK",
  "NUMOISYN LIQUID 300ML",
  "NUMOISYN LOZENGES",
  "NUOX GEL",
  "NUQUIN HP 4% CREAM 56.7GM",
  "NUQUIN HP 4% GEL 28.40GM",
  "NUTRILYTE INJ , 20ML",
  "NUTROPIN AQ 10MG/2ML PEN CARTRIDGE",
  "NUVARING",
  "NYSTATIN 500,000 UNITS ORAL TABLETS",
  "NYSTATIN CREAM 15GM",
  "NYSTATIN CREAM 30GM",
  "NYSTATIN OINT 15GM",
  "NYSTATIN OINTMENT 30GM",
  "NYSTATIN ORAL SUSP 100000UNIT/ML",
  "NYSTATIN PWDR FOR ORAL SUSP 500MMU",
  "NYSTATIN PWDR FOR ORAL SUSP 50MMU",
  "NYSTATIN/TRIAMCINOLONE CREAM 15GM",
  "NYSTATIN/TRIAMCINOLONE OINT 15GM",
  "NYSTATIN/TRIAMCINOLONE OINT 30GM",
  "NYSTOP 100,000 U/GM TOP POWDER 60GM",
  "OBSTETRIX EC TABLETS",
  "OBTREX DHA PAK",
  "OBTREX PRENATAL CAPLETS",
  "O-CAL PRENATAL TABLETS",
  "OCTREOTIDE 0.2MG/ML INJ,5ML",
  "OCTREOTIDE 100MCG INJ, 1ML",
  "OCTREOTIDE 50MCG/ML INJ, 1ML",
  "OFLOXACIN 0.3% OPH SOLN 5ML (EYE)",
  "OFLOXACIN 0.3% OTIC SOLN 5ML (EAR)",
  "OFLOXACIN 400MG TABLETS",
  "OLANZAPINE 10MG TABLETS",
  "OLANZAPINE 15MG TABLETS",
  "OLANZAPINE 2.5MG TABLETS",
  "OLANZAPINE 20MG TABLETS",
  "OLANZAPINE 5MG TABLETS",
  "OLANZAPINE 7.5MG TABLETS",
  "OLANZAPINE ODT 10MG TABLETS",
  "OLANZAPINE ODT 20MG TABLETS",
  "OLANZAPINE ODT 5MG TABLETS",
  "OLANZAPINE/FLUOXETINE 12-25MG CAPS",
  "OLANZAPINE/FLUOXETINE 12-50MG CAPS",
  "OLANZAPINE/FLUOXETINE 6-25MG CAPS",
  "OLANZAPINE/FLUOXETINE 6-50MG CAPS",
  "OLMESARTAN MEDOX/HCTZ 20-12.5MG TAB",
  "OLMESARTAN MEDOX/HCTZ 40-12.5MG TAB",
  "OLMESARTAN MEDOX/HCTZ 40-25MG TAB",
  "OLMESARTAN MEDOXOMIL 20MG TABLETS",
  "OLMESARTAN MEDOXOMIL 40MG TABLETS",
  "OLMESARTAN MEDOXOMIL 5MG TABLETS",
  "OLMESARTAN/AMLOD/HCTZ 40-10-25MG T",
  "OLOPATADINE 0.1% OPTH SOLN 5ML",
  "OLOPATADINE 0.2% OPHTH SOLN 2.5ML",
  "OLOPATADINE 0.6% NASAL SPR (240 SP)",
  "OMEGA-3-ACID 1GM CAPSULES (RX)",
  "OMEPRAZOL 20MG/SOD BICARB 1100MG CP",
  "OMEPRAZOL 40MG/SOD BICARB 1100MG CP",
  "OMEPRAZOLE 10MG CAPSULES",
  "OMEPRAZOLE 20MG CAPSULES",
  "OMEPRAZOLE 40MG CAPSULES",
  "ONDANSETRON 2MG/ML INJ, 20ML",
  "ONDANSETRON 4MG TABLETS",
  "ONDANSETRON 4MG/2ML INJ, 2ML",
  "ONDANSETRON 4MG/5ML SOLUTION",
  "ONDANSETRON 8MG TABLETS",
  "ONDANSETRON ODT 4MG TABLETS",
  "ONDANSETRON ODT 8MG TABLETS",
  "ONEXTON 1.2% - 3.75% GEL 50GM",
  "OPIUM 10MG/ML (1%) TINCTURE",
  "OPTICHAMBER ADV W/MED MASK",
  "OPTICHAMBER DMD LG MSK 5 YRS-ADLT",
  "ORASEP SOLUTION",
  "ORASEP SPRAY",
  "ORENCIA 250MG INJ, 1 VIAL",
  "ORGAN-I NR 200MG TAB",
  "ORPHENADRINE 30MG/ML INJ, 2ML",
  "ORPHENADRINE 30MG/ML INJ, 2ML",
  "ORPHENADRINE CITRATE 100MG ER TABS",
  "ORTHO EVRA PATCHES",
  "ORTHOVISC 15MG/ML INJ, 2ML",
  "OSCION 3% CLEANSER 170.3GM",
  "OSCION 6% CLEANSER 170.3GM",
  "OSCION 9% CLEANSER 340.2GM",
  "OSELTAMIVIR 30MG CAPSULES",
  "OSELTAMIVIR 45MG CAPSULES",
  "OSELTAMIVIR 6MG/ML SUSPENSION 60ML",
  "OSELTAMIVIR 75MG CAPSULES",
  "OTICIN OTIC DROPS 10ML (EAR)",
  "OXACILLIN 10GM INJ , 1VIAL",
  "OXACILLIN 1GM INJ, 1VIAL",
  "OXACILLIN 2GM INJ , 1VIAL",
  "OXACILLIN 2GM VIAL FOR INJECTION",
  "OXANDROLONE 10MG TABLETS",
  "OXANDROLONE 2.5MG TABLETS",
  "OXAPROZIN 600MG TABLETS",
  "OXAZEPAM 10MG CAPSULES",
  "OXAZEPAM 15MG CAPSULES",
  "OXAZEPAM 30MG CAPSULES",
  "OXCARBAZEPINE 150MG TABLETS",
  "OXCARBAZEPINE 300MG TABLETS",
  "OXCARBAZEPINE 300MG/5ML ORAL SUSP",
  "OXCARBAZEPINE 600MG TABLETS",
  "OXISTAT 1% CREAM 30GM",
  "OXISTAT 1% CREAM 60GM",
  "OXYBUTYNIN 5MG TABLETS",
  "OXYBUTYNIN 5MG/5ML SYRUP",
  "OXYBUTYNIN ER 10MG TABLETS",
  "OXYBUTYNIN ER 15MG TABLETS",
  "OXYBUTYNIN ER 5MG TABLETS",
  "OXYCODONE 10MG IMMEDIATE REL TABS",
  "OXYCODONE 15MG* IMMEDIATE REL TABS",
  "OXYCODONE 20MG IMMEDIATE REL TABS",
  "OXYCODONE 20MG/ML SOLUTION 30ML",
  "OXYCODONE 30MG IMMEDIATE REL TABS",
  "OXYCODONE 40MG ER TABLETS",
  "OXYCODONE 5MG IMMEDIATE REL CAPS",
  "OXYCODONE 5MG IMMEDIATE REL TABS",
  "OXYCODONE 5MG/5ML SOLUTION",
  "OXYCODONE/ACETAMINOPHEN 10-325MG TB",
  "OXYCODONE/ACETAMINOPHEN 5-325MG TAB",
  "OXYCODONE/ACETAMINOPHN 7.5-325MG TB",
  "OXYCODONE/ACETAMINOPHN 7.5-325MG TB",
  "OXYCODONE/ASA 4.835/325MGTABS",
  "OXYCONTIN 10MG CONTROLLED REL TABS",
  "OXYCONTIN 15MG CONTROLLED REL TABS",
  "OXYCONTIN 20MG CONTROLLED REL TABS",
  "OXYCONTIN 30MG CONTROLLED REL TABS",
  "OXYCONTIN 40MG CONTROLLED REL TABS",
  "OXYCONTIN 60MG CONTROLLED REL TABS",
  "OXYCONTIN 80MG CONTROLLED REL TABS",
  "OXYMORPHONE 10MG TABLETS",
  "OXYMORPHONE 5MG TABLETS",
  "OXYMORPHONE ER 15MG TABLETS",
  "OXYMORPHONE ER 20MG TABLETS",
  "OXYMORPHONE ER 40MG TABLETS",
  "PACLITAXEL 300MG/50ML INJ, 50ML",
  "PALIPERIDONE ER 1.5MG TABLETS",
  "PALIPERIDONE ER 3MG TABLETS",
  "PALIPERIDONE ER 6MG TABLETS",
  "PALIPERIDONE ER 9MG TABLETS",
  "PAMIDRONATE 3MG/ML SOL 10ML",
  "PAMIDRONATE 90MG INJ, 1 VIAL",
  "PANATUSS DXP PEDIATRIC DROPS 60ML",
  "PANTOPRAZOLE 20MG TABLETS",
  "PANTOPRAZOLE 40MG TABLETS",
  "PAPAVERINE 30MG/ML SOL",
  "PAREGORIC LIQUID",
  "PARICALCITOL 1MCG CAPSULES",
  "PARICALCITOL 2MCG CAPSULES",
  "PARICALCITOL 4MCG CAPSULES",
  "PAROXETINE 10MG TAB",
  "PAROXETINE 20MG TAB",
  "PAROXETINE 30MG TAB",
  "PAROXETINE 40MG TABLETS",
  "PAROXETINE 7.5MG CAPSULES",
  "PAROXETINE ER 12.5MG TABLETS",
  "PAROXETINE ER 25MG TABLETS",
  "PAROXETINE ER 37.5MG TABLETS",
  "PATANOL 0.1% OPHTH SOLN 5ML",
  "PBM ALLERGY SYRUP",
  "PEG-3350 & ELECTROLYTES UNFLAV",
  "PEG-3350/KCL /SOD LEMON-LIME 4000ML",
  "PEG-INTRON 120MCG REDIPENKIT-4 PEN",
  "PEG-INTRON 150MCG REDIPENKIT-4 PEN",
  "PEN G PROC 600000 INJ, 2ML",
  "PENICILL GK/ DEX 3MU INJ, 50ML",
  "PENICILLIN G SODIUM 5 MILLION UNITS",
  "PENICILLIN GK 5MU INJ , 1 VIAL",
  "PENICILLIN VK 125MG/5ML SOLN 100ML",
  "PENICILLIN VK 125MG/5ML SOLN 200ML",
  "PENICILLIN VK 250MG TAB",
  "PENICILLIN VK 250MG/5ML SOLN 100ML",
  "PENICILLIN VK 250MG/5ML SOLN 200ML",
  "PENICILLIN VK 500MG TAB",
  "PENTASA 250MG CAPSULES",
  "PENTASA 500MG CAPSULES",
  "PENTAZOCINE/NALOXONE TABLETS",
  "PENTOXIFYLLINE 400MG ER TABLETS",
  "PERFOROMIST 20MCG INH SOL60X2ML",
  "PERINDOPRIL 2MG TABLETS",
  "PERINDOPRIL 4MG TABLETS",
  "PERINDOPRIL 8MG TABLETS",
  "PERMETHRIN 5% CREAM 60GM",
  "PERPHENAZINE 16MG TABLETS",
  "PERPHENAZINE 2MG TABLETS",
  "PERPHENAZINE 4MG TABLETS",
  "PERPHENAZINE 8MG TABLETS",
  "PERPHENAZINE/AMITRIPTYLINE 2-10 TAB",
  "PERPHENAZINE/AMITRIPTYLINE 2-25 TAB",
  "PERPHENAZINE/AMITRIPTYLINE 4-10 TAB",
  "PERPHENAZINE/AMITRIPTYLINE 4-25 TAB",
  "PERPHENAZINE/AMITRIPTYLINE 4-50 TAB",
  "PHENAZOPYRIDINE 100MG TABLETS",
  "PHENAZOPYRIDINE 200MG TABLETS",
  "PHENDIMETRAZINE 105MG CR CAPSULES",
  "PHENDIMETRAZINE 35MG TABLETS",
  "PHENELZINE SULFATE 15MG TABLETS",
  "PHENOBARBITAL 100MG TABLETS",
  "PHENOBARBITAL 15MG TABLETS",
  "PHENOBARBITAL 16.2MG TABLETS",
  "PHENOBARBITAL 20MG/5ML SOLUTION",
  "PHENOBARBITAL 30MG TABLETS",
  "PHENOBARBITAL 32.4MG TABLETS",
  "PHENOBARBITAL 60MG TABLETS",
  "PHENOBARBITAL 64.8MG TABLETS",
  "PHENOBARBITAL 97.2MG TABLETS",
  "PHENOBARBITAL SOD 65MG/ML INJ",
  "PHENOXYBENZAMINE 10MG CAPSULES",
  "PHENTERMINE 37.5MG CAPSULES",
  "PHENTERMINE 37.5MG TABLETS",
  "PHENTERMINE HCL 15MG CAPSULES",
  "PHENTERMINE HCL 30MG CAPSULES",
  "PHENTOLAMINE MESYLATE INJ, 1 VIAL",
  "PHENYLEPHRIN 2.5% OPHTH SOL 15ML",
  "PHENYLEPHRINE 10% OPHTH SOLN 5ML",
  "PHENYLEPHRINE/GUAIFENESIN DROP 30ML",
  "PHENYLTOLOXAMINE PE CPM SYRUP",
  "PHENYTOIN 100MG/4ML SUSPENSION",
  "PHENYTOIN 125MG/5ML ORAL SUSPENSION",
  "PHENYTOIN 200MG ER CAPSULES",
  "PHENYTOIN 50MG CHEW TABLETS",
  "PHENYTOIN 50MG/ML INJ, 5ML",
  "PHENYTOIN 50MG/ML INJ, 5ML",
  "PHENYTOIN SOD 300MG ER CAPSULES",
  "PHENYTOIN SODIUM 100MG EXT CAPSULES",
  "P-HIST DM DROPS 30ML",
  "PHOSPHA 250 NEUTRAL TABLETS",
  "PILOCARPINE 0.5% OPHTH SOLN",
  "PILOCARPINE 1% OPHTH SOLN 15ML",
  "PILOCARPINE 2% OPHTH SOLN 15ML",
  "PILOCARPINE 4% OPHTH SOLN 15ML",
  "PILOCARPINE 5MG TABLETS",
  "PILOCARPINE 7.5MG TABLETS",
  "PIMOZIDE 1MG TABLETS",
  "PIMOZIDE 2MG TABLETS",
  "PINDOLOL 10MG TABLETS",
  "PINDOLOL 5MG TABLETS",
  "PIOGLITAZONE 15MG TABLETS",
  "PIOGLITAZONE 30MG TABLETS",
  "PIOGLITAZONE 45MG TABLETS",
  "PIOGLITAZONE/GLIMEPIRIDE 30-2MG TAB",
  "PIOGLITAZONE/GLIMEPIRIDE 30-4MG TAB",
  "PIOGLITAZONE/METFORMIN 15-500MG TAB",
  "PIOGLITAZONE/METFORMIN 15-850MG TB",
  "PIROXICAM 10MG CAPSULES",
  "PIROXICAM 20MG CAPSULES",
  "PNV 29-1MG TABLETS",
  "PNV-DHA+DOCUSATE CAPSULES",
  "PODOCON-25 LIQUID",
  "PODOFILOX 0.5% SOLUTION 3.5ML",
  "POLYETH GLYCOL 3350 NF POWDER 527GM",
  "POLYETHYLENE GLYCOL 3350POW 14'S",
  "POLY-IRON 150 CAP",
  "POLY-IRON 150 FORTE CAP",
  "POLYMYXIN-B/TRIMETHOPRIMOPHTH SOLN",
  "POLY-VIT/F 0.5MG/ML DROP 50ML",
  "PORTIA TABLETS 28",
  "POT BICAR/CL 25MEQ EF TABLETS",
  "POT CHLORIDE 8MEQ CR CAPSULES",
  "POT CITRATE-CITRIC ACID CRYSTAL PAK",
  "POTASSIUM CHLOR 10% LIQ(20MEQ/15ML)",
  "POTASSIUM CHLOR 20% LIQ(40MEQ/15ML)",
  "POTASSIUM CHLORIDE 20MEQ ER TABLETS",
  "POTASSIUM CHLORIDE 20MEQ POWDER",
  "POTASSIUM CHLORIDE 2MEQ/ML INJ,10ML",
  "POTASSIUM CHLORIDE ER 8MEQ TABLETS",
  "POTASSIUM CIT 1080MG (10MEQ) TABS",
  "POTASSIUM CIT 540MG (5MEQ) TABLETS",
  "POTASSIUM CIT ER 1620MG (15MEQ) TAB",
  "POTASSIUM CITRATE CITRIC ACID SOL",
  "POTASSIUM CL 10MEQ ER CAPSULES",
  "POTASSIUM CL 10MEQ ER CAPSULES",
  "POTASSIUM CL 10MEQ ER TAB",
  "POTASSIUM CL 10MEQ ER TABLETS",
  "POTASSIUM CL 20MEQ ER TABLETS",
  "PR BENZOYL 7% WASH LIQUID 473ML",
  "PRAMIPEXOLE 0.125MG TABLETS",
  "PRAMIPEXOLE 0.25MG TAB",
  "PRAMIPEXOLE 0.5MG TABLETS",
  "PRAMIPEXOLE 0.75MG TABLETS",
  "PRAMIPEXOLE 1.5MG TABLETS",
  "PRAMIPEXOLE 1MG TABLETS",
  "PRAMIPEXOLE ER 0.375MG TABLETS",
  "PRAMIPEXOLE ER 0.75MG TABLETS",
  "PRAMIPEXOLE ER 1.5MG TABLETS",
  "PRAMIPEXOLE ER 2.25MG TABLETS",
  "PRAMIPEXOLE ER 3MG TABLETS",
  "PRAMIPEXOLE ER 4.5MG TABLETS",
  "PRASCION CLEANSER 170.3GM",
  "PRASCION RA W/SUNSRN CREAM 45GM",
  "PRASUGREL 10MG TABLETS",
  "PRASUGREL 5MG TABLETS",
  "PRASUGREL 5MG TABLETS",
  "PRAVASTATIN 10MG TAB",
  "PRAVASTATIN 20MG TAB",
  "PRAVASTATIN 40MG TAB",
  "PRAVASTATIN 80MG TAB",
  "PRAZOSIN 1MG CAP",
  "PRAZOSIN 2MG CAPSULES",
  "PRAZOSIN HCL 5MG CAPSULES",
  "PREDNICARBATE 0.1% OINT 60GM",
  "PREDNICARBATE-E 0.1% CREAM 60GM",
  "PREDNISOLONE 15MG/5ML SOLN PREDNISOLONE SOD PHOS 15MG/5ML SOL PREDNISONE 1MG TAB",
  "PREDNISOLONE 25MG/5ML SOLUTION",
  "PREDNISOLONE AC 1% OPHTH SUSP 10ML",
  "PREDNISOLONE AC 1% OPHTH SUSP 5ML",
  "PREDNISOLONE ODT 10MG TABLETS",
  "PREDNISOLONE ODT 15MG TABLETS",
  "PREDNISOLONE ODT 30MG TABLETS",
  "PREDNISOLONE SOD 1% OPHTH SOLN 10ML",
  "PREDNISOLONE SOD PHOS 5MG/5ML SOL",
  "PREDNISONE 10MG TABS PACK 21'S",
  "PREDNISONE 10MG TABS PACK48'S",
  "PREDNISONE 10MG** TAB",
  "PREDNISONE 2.5MG TAB PREDNISONE 5MG TAB",
  "PREDNISONE 50MG (FIFTY MG) TABLETS",
  "PREDNISONE 5MG TABLETS PACK 21'S",
  "PREDNISONE INTENSOL 5MG/1ML CONC.",
  "PREDNISONE SOLN 5MG/5ML (1MG/1ML)",
  "PREMARIN 0.3MG TABLETS",
  "PREMARIN 0.45MG TABS",
  "PREMARIN 0.625MG TABS",
  "PREMARIN 0.9MG TABS",
  "PREMARIN 1.25MG TABLETS",
  "PREMASOL 10% SOLUTION",
  "PREMASOL 6% SOLUTION, 500ML",
  "PREMPRO 0.3MG/1.5MG TABS28'S",
  "PREMPRO 0.45MG/1.5MG TABS 28'S",
  "PRENAFIRST TAB",
  "PRENATAB FA TAB",
  "PRENATAL - U CAPSULES",
  "PRENATAL 19 TAB",
  "PRENATAL PLUS TAB",
  "PREPLUS TABLETS",
  "PRETAB 29-1MG TABLETS",
  "PREVACID 15MG SOLU TABS",
  "PREVACID 30MG SOLU TABS",
  "PREVALITE POWDER PACKETS(BOX)42'S",
  "PREVIDENT 5000 BSTR PLUS PASTE/MINT",
  "PREVIDENT 5000 SENSITIVE PASTE/MINT",
  "PREZISTA 150MG TABLETS",
  "PREZISTA 600MG TABLETS",
  "PRIMIDONE 50MG TAB",
  "PROAIR HFA ORAL INH (200 PFS) 8.5G",
  "PROBENECID 500MG TABLETS",
  "PROBENECID/COLCHICINE TABLETS",
  "PROCHAMBER AERO SPACER",
  "PROCHLORPERAZINE 10MG TAB",
  "PROCHLORPERAZINE 25MG SUPPOSITORIES",
  "PROCHLORPERAZINE 5MG TAB",
  "PROCRIT 10,000 U/ML 1ML SD VIAL",
  "PROCRIT 2,000 U/ML 1ML SD VIAL",
  "PROCRIT 20,000U/ML, 1ML VIAL",
  "PROCRIT 3,000 U/ML 1ML SD VIAL",
  "PROCRIT 4,000 U/ML 1ML SD VIAL",
  "PROCRIT 40,000 U/ML 1ML SD VIAL",
  "PROCTOFOAM-HC 1-1% AERO FOAM 10GM",
  "PROCTOZONE-HC 2.5% CREAM",
  "PROCTOZONE-HC 2.5% CREAM 30GM",
  "PROGESTERONE 100MG CAPSULES",
  "PROGESTERONE 200MG CAPSULES",
  "PROGESTERONE/OIL 50MG/ML MDV 10ML",
  "PROLENSA 0.07% OPTH SOLUTION 3ML",
  "PROMETHAZINE 12.5MG SUPPOSITORIES",
  "PROMETHAZINE 12.5MG TAB",
  "PROMETHAZINE 25MG TAB",
  "PROMETHAZINE 25MG/ML INJ, 1ML",
  "PROMETHAZINE 50MG TAB",
  "PROMETHAZINE 50MG/ML INJ, 1ML",
  "PROMETHAZINE 50MG/ML INJ, 1ML",
  "PROMETHAZINE 6.25MG/5ML SYRUP",
  "PROMETHAZINE DM SYRUP",
  "PROMETHAZINE VC PLAIN SYRUP",
  "PROMETHAZINE VC W/CODEINE SYRUP",
  "PROMETHAZINE W/ CODEINE SYRUP",
  "PROMETHEGAN 25MG SUPPOSITORIES",
  "PROMISEB CREAM 30GM",
  "PROPAFENONE 150MG TABLETS",
  "PROPAFENONE 300MG TABLETS",
  "PROPAFENONE 425MG SR CAPSULES",
  "PROPAFENONE SR 225MG CAPSULES",
  "PROPAFENONE SR 325MG CAPSULES",
  "PROPANTHELINE BROMIDE 15MG TABS",
  "PROPARACAINE 0.5% OPHTH SOLN 15ML",
  "PROPRANOLOL 10MG TABLETS",
  "PROPRANOLOL 20MG TABLETS",
  "PROPRANOLOL 40MG TABLETS",
  "PROPRANOLOL 40MG/5ML SOLN",
  "PROPRANOLOL 60MG TAB\r\nQUINAPRIL 5MG TAB",
  "PROPRANOLOL 80MG TABLETS",
  "PROPRANOLOL ER 120MG CAPSULES",
  "PROPRANOLOL ER 160MG CAPSULES",
  "PROPRANOLOL ER 60MG CAPSULES",
  "PROPRANOLOL ER 80MG CAPSULES",
  "PROPRANOLOL/HCTZ 40/25 MG TABS",
  "PROPRANOLOL/HCTZ 80/25MG TABS",
  "PROPYLTHIOURACIL 50MG TABLETS",
  "PROTRIPTYLINE 10MG TABLETS",
  "PROTRIPTYLINE 5MG TABLETS",
  "PRUTECT EMULSION 45GM",
  "PRUTECT EMULSION 90GM",
  "PULMO-AIDE COMPACT NEBULIZER",
  "PULMOZYME 1MG/ML INH SOL 30 X 2.5ML",
  "PULMOZYME 1MG/ML INH SOL 30 X 2.5ML",
  "PULMOZYME 1MG/ML INH SOL 30 X 2.5ML",
  "PYRAZINAMIDE 500MG TABLETS",
  "PYRIDOSTIGMINE 180MG TABLETS",
  "PYRIDOSTIGMINE 180MG TABLETS",
  "PYRIDOSTIGMINE 60MG TABLETS",
  "PYRIDOXINE 100MG/ML INJ 1ML VIAL",
  "QNASL 80MCG NASAL AEROSOL 120SPRAYS",
  "QSYMIA 7.5-46MG CAPSULES",
  "QUARTUSS DM DROPS 30ML",
  "QUASENSE TABLETS 91S",
  "QUETIAPINE 100MG TABLETS",
  "QUETIAPINE 200MG TABLETS",
  "QUETIAPINE 25MG TABLETS",
  "QUETIAPINE 300MG TABLETS",
  "QUETIAPINE 400MG TABLETS",
  "QUETIAPINE 50MG ER TABLETS",
  "QUETIAPINE 50MG TABLETS",
  "QUETIAPINE ER 150MG TABLETS",
  "QUETIAPINE ER 200MG TABLETS",
  "QUETIAPINE ER 300MG TABLETS",
  "QUETIAPINE ER 400MG TABLETS",
  "QUINAPRIL 10MG TAB",
  "QUINAPRIL 20MG TAB",
  "QUINAPRIL 40MG TAB",
  "QUINAPRIL/HCTZ 10-12.5MG TABLETS",
  "QUINAPRIL/HCTZ 20-12.5MG TABLETS",
  "QUINAPRIL/HCTZ 20-25MG TABLETS",
  "QUINIDINE GLUCONATE 324MG CR TABS",
  "QUINIDINE SULFATE 200MG (3GR) TABS",
  "QUINIDINE SULFATE 300MG TABLETS",
  "QUININE SULFATE 324MG CAPSULES",
  "QV-ALLERGY SYRUP",
  "QVAR 40MCG ORAL INHALER 120 DOSES",
  "QVAR 80MCG ORAL INHALER 120 DOSES",
  "RABEPRAZOLE DR 20MG TABLETS",
  "RALOXIFENE 60MG TABLETS",
  "RAMIPRIL 1.25MG CAP",
  "RAMIPRIL 10MG CAPSULES",
  "RAMIPRIL 2.5MG CAPSULES",
  "RAMIPRIL 5MG CAPSULES",
  "RANEXA 500MG TABLETS",
  "RANITIDINE 150MG CAPSULES",
  "RANITIDINE 150MG TAB",
  "RANITIDINE 15MG/ML (75MG/5ML) SYRUP",
  "RANITIDINE 300MG CAPSULES",
  "RANITIDINE 300MG TAB",
  "RANITIDINE 50MG/2ML INJ, 2ML",
  "RASAGILINE 1MG TABLETS",
  "RASAGILINE MESYLATE 0.5MG TABLETS",
  "RE DUALVIT F CAP",
  "RE DUALVIT PLUS CAPSULES",
  "RE PRENATAL MULTIVIT W/IRON CHEW TB",
  "REA LO 40% CREAM 85GM",
  "REBIF 22MCG/0.5 ML SYR (6ML/PKG)",
  "REBIF 44MCG/0.5 ML SYR (6ML/PKG)",
  "RELAGARD GEL 50GM",
  "REME TUSSIN DM SYRUP",
  "REMEVEN 50% CREAM 142GM",
  "REMICADE 100MG INJ VIAL",
  "REMODULIN 10MG/ML INJ., 20ML",
  "RENAGEL 800MG TABLETS",
  "RENA-VITE RX TAB",
  "RENOVA 0.02% CREAM 40GM",
  "REPAGLINIDE 0.5MG TABLETS",
  "REPAGLINIDE 1MG TABLETS",
  "REPAGLINIDE 2MG TABLETS",
  "REPRONEX 75IU FOR INJECTION",
  "RESTASIS 0.05% OPHTH SINGLE USE 30",
  "RETIN-A MICRO 0.08% GEL PUMP 50GM",
  "REYATAZ 200MG CAPSULES",
  "REYATAZ 300MG CAPSULES",
  "RHOGAM PLUS 300MCG INJ",
  "RIBAVIRIN 200MG TABLETS",
  "RIFABUTIN 150MG CAPSULES",
  "RIFAMPIN 150MG CAPSULES",
  "RIFAMPIN 300MG CAPSULES",
  "RILUZOLE 50MG TABLETS",
  "RIMANTADINE 100MG TABLETS",
  "RIOMET 500MG/5ML SOLUTION",
  "RISEDRONATE SOD 150MG TABLETS",
  "RISEDRONATE SOD 30MG TABLETS",
  "RISEDRONATE SOD 35MG DELAYED REL TB",
  "RISEDRONATE SOD 35MG IMM REL TB PK",
  "RISEDRONATE SOD 5MG TABLETS",
  "RISPERIDONE 0.25MG TABLETS",
  "RISPERIDONE 0.5MG TABLETS",
  "RISPERIDONE 1MG TABLETS",
  "RISPERIDONE 1MG/ML ORAL SOLN 30ML",
  "RISPERIDONE 2MG TABLETS",
  "RISPERIDONE 3MG TABLETS",
  "RISPERIDONE 4MG ODT TABLETS",
  "RISPERIDONE 4MG TABLETS",
  "RISPERIDONE M TAB 3MG TABLETS",
  "RISPERIDONE ODT 0.25MG TABLETS",
  "RISPERIDONE ODT 0.5MG TABLETS",
  "RISPERIDONE ODT 1MG TABLETS",
  "RISPERIDONE ODT 2MG TABLETS",
  "RITUXAN 100MG INJ, 10ML",
  "RIVASTIGMINE 1.5MG CAPSULES",
  "RIVASTIGMINE 13.3MG/24H PATCH",
  "RIVASTIGMINE 3MG CAPSULES",
  "RIVASTIGMINE 4.5MG CAPSULES",
  "RIVASTIGMINE 4.6MG/24H PATCH",
  "RIVASTIGMINE 6MG CAPSULES",
  "RIVASTIGMINE 9.5MG/24H PATCH",
  "RIZATRIPTAN 10MG TABLETS",
  "RIZATRIPTAN 5MG TABLETS",
  "RIZATRIPTAN ODT 10MG TABLETS",
  "RIZATRIPTAN ODT 5MG TABLETS",
  "ROPINIROLE 0.25MG TABLETS",
  "ROPINIROLE 0.5MG TABLETS",
  "ROPINIROLE 1MG TABLETS",
  "ROPINIROLE 2MG TABLETS",
  "ROPINIROLE 3MG TABLETS",
  "ROPINIROLE 4MG TABLETS",
  "ROPINIROLE 5MG TABLETS",
  "ROPINIROLE ER 12MG TABLETS",
  "ROPINIROLE ER 2MG TABLETS",
  "ROPINIROLE ER 4MG TABLETS",
  "ROPINIROLE ER 6MG TABLETS",
  "ROPINIROLE ER 8MG TABLETS",
  "ROPIVACAINE 10MG/ML INJ, 20ML",
  "ROPIVACAINE 5MG/ML INJ, 30ML",
  "ROSUVASTATIN 10MG TAB",
  "ROSUVASTATIN 20MG TAB",
  "ROSUVASTATIN 40MG TAB",
  "ROSUVASTATIN 5MG TAB",
  "ROSUVASTATIN CALCIUM 10MG TABLETS",
  "ROSUVASTATIN CALCIUM 20MG TABLETS",
  "ROSUVASTATIN CALCIUM 40MGTABLETS",
  "ROSUVASTATIN CALCIUM 5MG TABLETS",
  "ROZEREM 8MG TABLETS",
  "SAIZEN 5MG VIAL FOR INJECTION",
  "SAIZEN 8.8MG COOL CLICK VIAL",
  "SALICYLIC AC 6% KIT",
  "SALICYLIC AC 6% LOTION 414GM",
  "SALICYLIC AC 6% SHAMPOO 177ML",
  "SALICYLIC ACID 27.5% LIQUID",
  "SALICYLIC ACID 6% FOAM 70GM",
  "SALICYLIC ACID 6% GEL 40GM",
  "SALICYLIC ACID 6% LOTION KIT",
  "SALICYLIC ACID POWDER 454GM",
  "SALINE 0.9% FLUSH INJ, 10ML",
  "SALSALATE 500MG TABLETS",
  "SALSALATE 750MG TABLETS",
  "SANCUSO TRANSDERMAL SYSTEM",
  "SANDIMMUNE 100MG/ML ORALSOLN",
  "SANTYL COLLAGNS 250U/GM OINT 30GM",
  "SAVELLA TITRATION PACK",
  "SECONAL SODIUM 100MG CAPSULES",
  "SELEGILINE 5MG CAPSULES",
  "SELEGILINE 5MG TABLETS",
  "SELENIUM SULFIDE 2.25% SHAMPOO",
  "SELENIUM SULFIDE 2.5% SHAMPOO (LOTN)",
  "SE-NATAL 19 CHEWABLE TABLETS",
  "SE-NATAL 19 TABLETS",
  "SENSIPAR 60MG TABLETS",
  "SEREVENT DISKUS 50MCG ORAL INH (60)",
  "SEROSTIM 4MG FOR INJECTION",
  "SEROSTIM 6MG FOR INJECTION",
  "SERTRALINE 100MG TAB",
  "SERTRALINE 20MG/ML CONCENTRATE",
  "SERTRALINE 25MG TAB",
  "SERTRALINE 50MG TAB",
  "SEVELAMER 800MG TABLETS",
  "SF 1.1% MINT GEL 56GM",
  "SF 5000 PLUS 1.1% CREAM 51GM",
  "SILDEC PE-DM SYRUP",
  "SILDEC-PE SYRUP",
  "SILDENAFIL 100MG TABLETS",
  "SILDENAFIL 20MG TABLETS",
  "SILDENAFIL 25MG TABLETS",
  "SILDENAFIL 50MG TABLETS",
  "SILENOR 6MG TABLETS",
  "SILVER SULFADIAZINE 1% CREAM 50GM",
  "SIMPONI 50MG/0.5ML PF SYR, 0.5ML",
  "SIMPONI 50MG/0.5ML SMTJTAUTO INJ",
  "SIMVASTATIN 10MG TAB",
  "SIMVASTATIN 20MG TAB",
  "SIMVASTATIN 40MG TAB",
  "SIMVASTATIN 5MG TAB",
  "SIMVASTATIN 80MG TAB",
  "SIROLIMUS 0.5MG TABLETS",
  "SIROLIMUS 1MG TABLETS",
  "SIROLIMUS 2MG TABLETS",
  "SMZ/TMP REGULAR STRENGTH TAB",
  "SOD CHLORIDE 0.9% INJECTION 25X10ML",
  "SOD CHLORIDE 0.9% NEB SOL 100 X 3ML",
  "SOD CHLORIDE 4MEQ/ML INJ, 25X30ML",
  "SOD FLUORIDE 0.2% MINT SOLUTION",
  "SOD FLUORIDE 1.1 (.5MG)/ML DRP 50ML",
  "SOD SULFA/SULFUR 10-2% CREAM 57GM",
  "SOD SULFA/SULFUR 10-5% CREAM 28GM",
  "SOD SULFACET 9%/SULF 4% WASH 473ML",
  "SOD SULFACET&SULFUR WASH 473ML",
  "SOD SULFACETAMIDE 10% WSH GL 340.2G",
  "SOD SULFACETAMIDE/SULFUR8-4% SUSP",
  "SODIUM BICARBONATE 8.4% INJ 50ML",
  "SODIUM CHLORIDE 0.9% INJ, 100ML",
  "SODIUM CHLORIDE 0.9% IRR SOL 1000ML",
  "SODIUM CHLORIDE 2.5MEQ/ML INJ, 40ML",
  "SODIUM CHLORIDE 7% NEB SOL 60X4ML",
  "SODIUM CITRATE CITRIC ACID SOLUTION",
  "SODIUM POLYSTYRENE 15GM/60ML SUSP",
  "SODIUM POLYSTYRENE SULFONATE POWDER",
  "SODIUM SUL/SULF 9-4.5% LIQUID WASH",
  "SODIUM SULF/SULFUR IN UREA CLEANSER",
  "SODIUM SULF-10%/SULFUR-5% SUSP 30GM",
  "SODIUM SULFA 10% WASH LIQUID 355ML",
  "SODIUM SULFACETAM 10% LOTN(TOPICAL)",
  "SODIUM SULFACETAMIDE/SULF 10-2% LIQ",
  "SODIUM THIOSULFATE 25% INJ, 50ML",
  "SOLIA TABS 28",
  "SOLODYN 105MG ER TABLETS",
  "SOLODYN 115MG ER TABLETS",
  "SOLODYN 55MG ER TABLETS",
  "SOLODYN 80MG ER TABLETS",
  "SOLODYN ER 65MG TABLETS",
  "SOMATULINE 90MG/0.3ML INJ, 0.3ML",
  "SOTALOL 120MG TAB",
  "SOTALOL 160MG TABLETS",
  "SOTALOL 240MG TABLETS",
  "SOTALOL 80MG TABLETS",
  "SPINOSAD 0.9% TOPICAL SUSP 120ML",
  "SPIRIVA 18MCG CAPS 30S &HANDIHALER",
  "SPIRONOLACTONE 100MG TABLETS",
  "SPIRONOLACTONE 25MG TAB",
  "SPIRONOLACTONE 25MG W/HCTZ 25MG TAB",
  "SPIRONOLACTONE 50MG TAB",
  "SPORANOX 100MG/10ML SOLN 150ML",
  "SSD 1% CREAM (TUBE) 85GM",
  "STALEVO 100 TABLETS",
  "STALEVO 150 TABLETS",
  "STANNOUS FLUORIDE 0.63% RINSE",
  "STAVUDINE 20MG CAPSULES",
  "STAVUDINE 30MG CAPSULES",
  "STAVUDINE 40MG CAPSULES",
  "STAXYN 10MG ODT TABLETS",
  "STERIL WATER IRRIG SOLUTION, 500ML",
  "STERILE WATER FOR INJECTION 10ML",
  "SUBOXONE 2MG/0.5MG SUBL/BUCC FILM",
  "SUBOXONE 8MG/2MG SUBL/BUCC FILM",
  "SUCRALFATE 1GM TABLETS",
  "SUFENTANIL 50MCG/ML INJ, 1ML AMPULE",
  "SUFENTANIL 50MCG/ML INJ, 5ML VIAL",
  "SULFACET/PREDNISOLONE OPH SOL 10ML",
  "SULFACET/PREDNISOLONE OPH SOL 5ML",
  "SULFACETAMIDE 10%/SULFUR 5% LOTION",
  "SULFACETAMIDE NA 10% OPH SOL 15ML",
  "SULFACETAMIDE NA 10% OPH SOLN 15ML",
  "SULFADIAZINE 500MG TABLETS",
  "SULFAMETH/TRIMETH 400-80MG TAB",
  "SULFAMETH/TRIMETHOPRIM 800/160 TAB",
  "SULFAMETHOX/TMP 400-80MG/5ML INJ",
  "SULFAMETH-TRIMETH 200-40MG/5ML SUSP",
  "SULFASALAZINE 500MG TABLETS",
  "SULFASALAZINE EC 500MG DR TABLETS",
  "SULINDAC 150MG TABLETS",
  "SULINDAC 200MG TABLETS",
  "SUMATRIPTAN 100MG TABLETS",
  "SUMATRIPTAN 20MG NASAL SPRAY(6 SPR)",
  "SUMATRIPTAN 25MG TABLETS",
  "SUMATRIPTAN 4MG/0.5ML INJ, 2X0.5ML",
  "SUMATRIPTAN 50MG TABLETS",
  "SUMATRIPTAN 5MG NASAL SPRAY (6 SPR)",
  "SUMATRIPTAN 6MG REFILL INJECTION",
  "SUMATRIPTAN 6MG/0.5ML PF INJ2X0.5ML",
  "SUMATRIPTAN 6MG/0.5ML PF INJ2X0.5ML",
  "SUMATRIPTAN 6MG/0.5ML VIAL FOR INJ",
  "SUPPORT-500 CAPSULES",
  "SUPRAX 400MG CAPSULES",
  "SUPREP BOWEL PREP SOLN",
  "SUPRESS-DX PED DROPS 30ML",
  "SUPRESS-PE PEDIATRIC DROPS 30ML",
  "SUSTIVA 200MG CAPSULES",
  "SUSTIVA 600MG TABLETS",
  "SYMBICORT 160/4.5MCG (120 ORAL INH)",
  "SYNAREL 2MG/ML NASAL SOLN(60 SPR)",
  "SYNTHROID 0.025MG (25MCG)TABLETS",
  "SYNTHROID 0.05MG (50MCG)TABLETS",
  "SYNTHROID 0.075MG (75MCG)TABLETS",
  "SYNTHROID 0.088MG (88MCG)TABLETS",
  "SYNTHROID 0.112MG (112MCG) TABLETS",
  "SYNTHROID 0.125MG (125MCG) TABLETS",
  "SYNTHROID 0.137MG (137MCG) TABLETS",
  "SYNTHROID 0.15MG (150MCG)TABLETS",
  "SYNTHROID 0.175MG (175MCG) TABLETS",
  "SYNTHROID 0.1MG (100MCG)TABLETS",
  "SYNTHROID 0.2MG (200MCG)TABLETS",
  "SYNTHROID 0.3MG (300MCG)TABLETS",
  "SYNVISC 8MG/ML INJ, 2ML SYRINGE",
  "SYNVISC ONE 8MG/ML INJ, 6ML",
  "TACLONEX SUSPENSION 60GM",
  "TACROLIMUS 0.03% OINTMENT 30GM",
  "TACROLIMUS 0.1% OINTMENT 30GM",
  "TACROLIMUS 0.5MG (HALF MG) CAPSULES",
  "TACROLIMUS 1MG CAPSULES",
  "TACROLIMUS 5MG (FIVE MG)CAPSULES",
  "TAMIFLU 6MG/ML SUSPENSION",
  "TAMOXIFEN 10MG TABLETS",
  "TAMOXIFEN 20MG TABLETS",
  "TAMSULOSIN 0.4MG CAPSULES",
  "TARCEVA 100MG TABLETS",
  "TARCEVA 150MG TABLETS",
  "TARON FORTE CAPSULES",
  "TAZICEF 2GM INJ, 1 VIAL",
  "TAZTIA XT 180MG CAPSULES",
  "TAZTIA XT 300MG CAPSULES",
  "TAZTIA XT 360MG CAPSULES",
  "TEARS AGAIN HYDRATE CAPSULES",
  "TEGRETOL-XR 100MG TABLETS",
  "TELMISARTAN 20MG TABLETS",
  "TELMISARTAN 40MG TABLETS",
  "TELMISARTAN 80MG TABLETS",
  "TELMISARTAN/AMLODIPINE 40-10MG TABS",
  "TELMISARTAN/AMLODIPINE 40-5MG TABS",
  "TELMISARTAN/AMLODIPINE 80-10MG TABS",
  "TELMISARTAN/AMLODIPINE 80-5MG TABS",
  "TELMISARTAN/HCTZ 40-12.5MG TABS",
  "TELMISARTAN/HCTZ 80-12.5MG TABS",
  "TELMISARTAN/HCTZ 80-25MG TABS",
  "TEMAZEPAM 22.5MG CAPSULES",
  "TEMAZEPAM 30MG CAPSULES",
  "TEMAZEPAM 7.5MG CAPSULES",
  "TEMOZOLOMIDE 100MG CAPSULES",
  "TEMOZOLOMIDE 140MG CAPSULES",
  "TEMOZOLOMIDE 180MG CAPSULES",
  "TENOFOVIR 300MG TABLETS",
  "TERAZOSIN 10MG CAP",
  "TERAZOSIN 1MG CAP",
  "TERAZOSIN 2MG CAP",
  "TERAZOSIN 5MG CAP",
  "TERBINAFINE 250MG TAB",
  "TERBUTALINE 1MG/ML INJ, 1ML",
  "TERBUTALINE 2.5MG TABLETS",
  "TERBUTALINE 5MG TABLETS",
  "TERCONAZOLE 0.4% VAGINAL CRM 45GM",
  "TERCONAZOLE 0.8% VAGINAL CRM 20GM",
  "TERCONAZOLE 80MG VAGINAL SUPP 3'S",
  "TERSI FOAM 2.25% AEROSOL70GM",
  "TESTOSTERONE 1% (12.5MG/1.25GM)PUMP",
  "TESTOSTERONE 1% GEL 150GM (30X5GM)",
  "TESTOSTERONE 1% GEL(25MG)30 X 2.5GM",
  "TESTOSTERONE 1%(50MG) GEL 30X5GM PK",
  "TESTOSTERONE 10MG/ACT GEL(120PUMPS)",
  "TESTOSTERONE CYP 100MG/ML INJ, 10ML",
  "TESTOSTERONE CYP 200MG/ML INJ, 10ML",
  "TESTOSTERONE CYP 200MG/ML INJ, 1ML",
  "TESTOSTERONE ENAN 200MG/ML INJ, 5ML",
  "TESTOSTERONE PROPIONATE POWDER 5GM",
  "TETRABENAZINE 12.5MG TABLETS",
  "TETRABENAZINE 25MG TABLETS",
  "TETRACYCLINE 250MG CAPSULES",
  "TETRACYCLINE 500MG CAPSULES",
  "THALOMID 100MG CAPSULES 28'S",
  "THALOMID 50MG CAPSULES 28'S",
  "THEOPHYLLINE 300MG ER TABLETS",
  "THEOPHYLLINE 400MG ER TABLETS",
  "THEOPHYLLINE 450MG ER TABLETS",
  "THEOPHYLLINE 600MG ER TABLETS",
  "THERA-FLUR-N GEL DROPS 24 ML",
  "THEROBEC TABLETS",
  "THIAMINE 100MG/ML INJ, 2ML",
  "THIORIDAZINE 100MG** TABLETS",
  "THIORIDAZINE 10MG TABLETS",
  "THIORIDAZINE 25MG TABLETS",
  "THIORIDAZINE 50MG TABLETS",
  "THIOTHIXENE 10MG** CAPSULES",
  "THIOTHIXENE 1MG CAPSULES",
  "THIOTHIXENE 2MG CAPSULES",
  "THIOTHIXENE 5MG CAPSULES",
  "THYROGEN 1.1MG INJECTION",
  "THYROID (ARMOUR) 0.25GR (15MG) TAB",
  "THYROID (ARMOUR) 0.5GR (30MG) TABS",
  "THYROID (ARMOUR) 1.5GR (90MG) TABS",
  "THYROID (ARMOUR) 1GR (60MG) TABS",
  "THYROID (ARMOUR) 2GR (120MG) TABS",
  "THYROID (ARMOUR) 4GR (240MG) TABS",
  "THYROID 0.5GR (30MG) TABS",
  "THYROID 0.5GR NP (30MG) TABLETS",
  "THYROID TABS USP 1GR (65MG)",
  "TIAGABINE 2MG TABLETS",
  "TIAGABINE 4MG TABLETS",
  "TICLOPIDINE 250MG TAB",
  "TILIA FE TABLETS 28S",
  "TIMOLOL 0.25% GF OPHTH SOLN 5ML",
  "TIMOLOL 0.5% GF OPTH SOLN 5ML",
  "TIMOLOL 0.5% GF OPTH SOLN 5ML",
  "TIMOLOL MALEATE .25% OPHTH SOL 5ML",
  "TIMOLOL MALEATE 0.5% OPHTH SOLN 5ML",
  "TIMOLOL MALEATE 10MG TABLETS",
  "TIMOLOL MALEATE 20MG TABLETS",
  "TIMOLOL MALEATE 5MG TABLETS",
  "TIMOPTIC 0.25% OCUDOSE 60'S",
  "TIMOPTIC 0.5% OCUDOSE 60S",
  "TINIDAZOLE 500MG TABLETS",
  "TIROSINT 100MCG CAPSULES",
  "TIROSINT 112MCG CAPSULES",
  "TIROSINT 125MCG CAPSULES",
  "TIROSINT 13 MCG CAPSULES",
  "TIROSINT 137 MCG CAPSULES",
  "TIROSINT 150MCG CAPSULES",
  "TIROSINT 25MCG CAPSULES",
  "TIROSINT 50MCG CAPSULES",
  "TIROSINT 75MCG CAPSULES",
  "TIROSINT 88MCG CAPSULES",
  "TIZANIDINE 2MG CAPSULES",
  "TIZANIDINE 2MG TABLETS",
  "TIZANIDINE 4MG TABLETS",
  "TL-HEM 150 TABLETS",
  "TOBRADEX OPHTH OINT 3.5GM",
  "TOBRAMYCIN 0.3% OPH SOL 5ML",
  "TOBRAMYCIN 300MG/5ML INH SOL 56X5ML",
  "TOBRAMYCIN 40MG/ML 2ML INJ",
  "TOBRAMYCIN/DEXAMETHASONESUSP 5ML",
  "TOBREX 0.3% OPTH OINT 3.5GM",
  "TOLAZAMIDE 250MG TABLETS",
  "TOLBUTAMIDE 500MG TABLETS",
  "TOLCAPONE 100MG TABLETS",
  "TOLMETIN SODIUM 400MG CAPSULES",
  "TOLMETIN SODIUM 600MG TABLETS",
  "TOLTERODINE TART 2MG ER CAPSULES",
  "TOLTERODINE TART ER 4MG CAPSULES",
  "TOLTERODINE TARTRATE 1MG TABLETS",
  "TOPIRAMATE 100MG TABLETS",
  "TOPIRAMATE 15MG SPRINKLE CAPSULES",
  "TOPIRAMATE 200MG TABLETS",
  "TOPIRAMATE 25MG SPRINKLE CAPSULES",
  "TOPIRAMATE 25MG TABLETS",
  "TOPIRAMATE 50MG TABLETS",
  "TOPIRAMATE ER 150MG CAPSULES",
  "TOPIRAMATE ER 25MG CAPSULES",
  "TOPIRAMATE ER 50MG CAPSULES",
  "TOPOSAR 20MG/ML INJ, 5ML",
  "TORSEMIDE 100MG (HUNDREDMG) TABLET",
  "TORSEMIDE 10MG TAB",
  "TORSEMIDE 20MG TAB",
  "TORSEMIDE 5MG TAB",
  "TOVIAZ 8MG TABLETS",
  "TRADJENTA 5MG TABLETS",
  "TRAMADOL 50MG TABLETS",
  "TRAMADOL ER 100MG CAPSULES",
  "TRAMADOL ER 100MG TABLETS",
  "TRAMADOL ER 200MG BIPHASIC TAB",
  "TRAMADOL ER 200MG CAPSULES",
  "TRAMADOL ER 200MG TABLETS",
  "TRAMADOL ER 300MG CAPSULES",
  "TRAMADOL ER 300MG TABLETS",
  "TRAMADOL/APAP 37.5MG/325MG TABS",
  "TRANDOLAPRIL 1MG TAB",
  "TRANDOLAPRIL 2MG TAB",
  "TRANDOLAPRIL 4MG TAB",
  "TRANDOLAPRIL-VERAPAMIL ER 1-240MG T",
  "TRANDOLAPRIL-VERAPAMIL ER 2-180MG T",
  "TRANDOLAPRIL-VERAPAMIL ER 2-240MG T",
  "TRANDOLAPRIL-VERAPAMIL ER 4-240MG T",
  "TRANSDERM-SCOP PATCHES",
  "TRANYLCYPROMINE 10MG TABLETS",
  "TRAVATAN Z 0.004% OPHTH SOL 2.5ML",
  "TRAZODONE 100MG TAB",
  "TRAZODONE 150MG TAB",
  "TRAZODONE 300MG TABLETS",
  "TRAZODONE 50MG TAB",
  "TRETINOIN 0.01% GEL 15GM",
  "TRETINOIN 0.025% CREAM 45GM",
  "TRETINOIN 0.025% GEL 15GM",
  "TRETINOIN 0.05% CREAM 45GM",
  "TRETINOIN 0.05% EMOLLIENT CRM 40GM",
  "TRETINOIN 0.05% GEL 45GM",
  "TRETINOIN 0.1% CREAM 45GM",
  "TRETINOIN MICRO 0.04% GEL 45GM",
  "TRETINOIN MICRO 0.04% GEL 50GM",
  "TRETINOIN MICRO 0.1% GEL 20GM",
  "TRETINOIN MICRO 0.1% GEL 45GM",
  "TRETINOIN MICRO 0.1% GEL PUMP 50GM",
  "TREXALL 15MG TABLETS",
  "TRIAMCIN/ORABAS 0.1% DENT-PAST 5GM",
  "TRIAMCINOLONE 0.025% CREAM 15GM",
  "TRIAMCINOLONE 0.025% CREAM 15GM",
  "TRIAMCINOLONE 0.025% LOTION 60ML",
  "TRIAMCINOLONE 0.025% OINTMENT 15GM",
  "TRIAMCINOLONE 0.025% OINTMENT 454GM",
  "TRIAMCINOLONE 0.1% CREAM 30GM",
  "TRIAMCINOLONE 0.1% CREAM 80GM",
  "TRIAMCINOLONE 0.1% LOTION 60ML",
  "TRIAMCINOLONE 0.1% OINT 80GM",
  "TRIAMCINOLONE 0.1% OINTMENT 30GM",
  "TRIAMCINOLONE 0.5% CREAM 15GM",
  "TRIAMCINOLONE 0.5% OINT 15GM",
  "TRIAMCINOLONE NASAL SPRAY (120 SPR)",
  "TRIAMCINOLONE TOPICAL SPRAY 63GM",
  "TRIAMTERENE 37.5MG/ HCTZ 25MG CAP",
  "TRIAMTERENE 37.5MG/ HCTZ 25MG TAB",
  "TRIAMTERENE 50MG / HCTZ 25MG CAPS",
  "TRIAMTERENE 75MG/ HCTZ 50MG TAB",
  "TRIAZ 3% GEL 42.5GM",
  "TRIAZOLAM 0.125MG TABLETS",
  "TRIAZOLAM 0.25MG TABLETS",
  "TRICARE PRENATAL TABLETS",
  "TRIFLUOPERAZINE 10MG TABLETS",
  "TRIFLUOPERAZINE 1MG TABLETS",
  "TRIFLUOPERAZINE 2MG TABS",
  "TRIFLUOPERAZINE 5MG TABLETS",
  "TRIFLURIDINE 1% OPHTH SOLN 7.5ML",
  "TRIGELS-F FORTE CAPSULES",
  "TRIGLIDE 160MG TABLETS",
  "TRIHEXYPHENIDYL 0.4MG/ML ELIXIR",
  "TRIHEXYPHENIDYL 2MG TAB",
  "TRIHEXYPHENIDYL 5MG TAB",
  "TRI-LUMA CREAM 30GM",
  "TRIMETHOBENZAMIDE 300MG CAPSULES",
  "TRIMETHOPRIM 100MG TAB",
  "TRIMIPRAMINE 100MG CAPSULES",
  "TRIMIPRAMINE 25MG CAPSULES",
  "TRI-NASAL 50MCG SPRAY",
  "TRINATE TABLETS",
  "TRINESSA LO TABS 28S",
  "TRINTELLIX 20MG TB (WAS BRINTELLIX)",
  "TRIPLE ANTIBIOTIC OINTMENT 14GM",
  "TRIPOHIST LIQUID",
  "TRI-VIT/FE FL .25MG DROPS",
  "TRI-VITAMIN/FL 0.25MG/ML DROPS 50ML",
  "TRIZIVIR TB (ABC300/3TC150/ZDV300)",
  "TROPICAMIDE 0.5% OPHTH SOLN 15ML",
  "TROPICAMIDE 1% OPHTH SOLN15ML",
  "TROSPIUM CL 60MG ER CAPSULES",
  "TRUVADA 200MG-300MG TABLETS",
  "TUSNEL PEDIATRIC LIQUID",
  "ULORIC 40MG TABLETS",
  "ULORIC 80MG TABLETS",
  "ULTIMATECARE ONE CAPSULE",
  "UMECTA 40% NAIL FILM SUSP 18ML",
  "UMECTA PD 40% EMULSION 198.5GM",
  "UMECTA PD 40% SUSPENSION 255.1GM",
  "UREA 20% CREAM 85GM",
  "UREA 39% CREAM 226.8GM",
  "UREA 40% GEL 15ML",
  "UREA 40% LOTION 236.6ML",
  "UREA 50% NAIL GEL 18ML",
  "UREA 50% OINTMENT 45GM",
  "UREA POWDER",
  "UREA TOPICAL 40% SUSPENSION 283.4GM",
  "UREACIN-20 20% CREAM 113.4GM",
  "URETRON D-S TABLETS",
  "URIBEL 118MG CAPSULES",
  "URO-458 TABLETS",
  "UROSEX TABLETS",
  "URSODIOL 250MG TABLETS",
  "URSODIOL 300MG CAPSULES",
  "URSODIOL 500MG TABLETS",
  "VALACYCLOVIR 1GM TABLETS",
  "VALACYCLOVIR 500MG TABLETS",
  "VALCYTE 50MG/ML ORAL SOLUTION",
  "VALGANCICLOVIR 450MG TABLETS",
  "VALPROIC ACID 250MG CAPSULES",
  "VALPROIC ACID 250MG/5ML SOLUTION",
  "VALSARTAN 160MG TABLETS",
  "VALSARTAN 320MG TABLETS",
  "VALSARTAN 40MG TABLETS",
  "VALSARTAN 80MG TABLETS",
  "VALSARTAN/HCTZ 160MG/12.5MG TABLETS",
  "VALSARTAN/HCTZ 160MG/25MG TABLETS",
  "VALSARTAN/HCTZ 320MG/12.5MG TABLETS",
  "VALSARTAN/HCTZ 320MG/25MG TABLETS",
  "VALSARTAN/HCTZ 80MG/12.5MG TABLETS",
  "VANACOF LIQUID",
  "VANCOMYCIN 1000MG INJ",
  "VANCOMYCIN 10GM INJ",
  "VANCOMYCIN 125MG CAPSULES",
  "VANCOMYCIN 250MG CAPSULES",
  "VANCOMYCIN 5GM INJ",
  "VANIQA 13.9% CREAM 45GM",
  "VASOPRESSIN 20U/ML INJ, 1ML",
  "V-C FORTE CAPSULES",
  "VENA-BAL DHA TABLETS",
  "VENLAFAXINE 100MG TABLETS",
  "VENLAFAXINE 25MG TABLETS",
  "VENLAFAXINE 37.5MG TABLETS",
  "VENLAFAXINE 50MG TABLETS",
  "VENLAFAXINE 75MG TABLETS",
  "VENLAFAXINE ER 150MG CAPSULES",
  "VENLAFAXINE ER 150MG TABLETS",
  "VENLAFAXINE ER 150MG TABLETS",
  "VENLAFAXINE ER 225MG TABLETS",
  "VENLAFAXINE ER 37.5MG CAPSULES",
  "VENLAFAXINE ER 37.5MG TABLETS",
  "VENLAFAXINE ER 37.5MG TABLETS",
  "VENLAFAXINE ER 75MG CAPSULES",
  "VENLAFAXINE ER 75MG TABLETS",
  "VENLAFAXINE ER 75MG TABLETS",
  "VENTOLIN HFA INH W/DOS CTR 200PUFFS",
  "VERAMYST 27.5MCG NASAL SP (120 INH)",
  "VERAPAMIL 120MG SR CAPSULES",
  "VERAPAMIL 120MG TAB",
  "VERAPAMIL 180MG SR CAPSULES",
  "VERAPAMIL 2.5MG/ML INJ, 2ML",
  "VERAPAMIL 240MG SR CAPS",
  "VERAPAMIL 360MG SR CAPSULES",
  "VERAPAMIL 40MG TAB",
  "VERAPAMIL 80MG TAB",
  "VERAPAMIL ER 100MG CAPSULES (24 HR)",
  "VERAPAMIL ER 120MG TABLETS",
  "VERAPAMIL ER 180MG TABLETS",
  "VERAPAMIL ER 200MG CAPSULES (24 HR)",
  "VERAPAMIL ER 240MG TABLETS",
  "VERAPAMIL ER 300MG CAPSULES (24 HR)",
  "VERSICLEAR LOTION 120ML",
  "VESICARE 5MG TABLETS",
  "VESTURA 3MG/0.02MG TABLETS 28'S",
  "VFEND 40MG/ML SUSPENSION",
  "VIAGRA 100MG TABLETS",
  "VIAGRA 25MG TABLETS",
  "VIAGRA 50MG TABLETS",
  "VICODIN HP 10-300MG TABLETS (NEW)",
  "VICTOZA 18MG/3ML INJ PEN 3 X 3ML",
  "VIGAMOX 0.5% OPHTH SOLUTION 3ML",
  "VIIBRYD 40MG TABLETS",
  "VINATE GT TAB",
  "VINATE II TABLETS (REFORMULATED)",
  "VINATE M TAB",
  "VINATE ONE TAB",
  "VINBLASTINE 10MG INJ, 1 VIAL",
  "VINCRISTINE 1MG/ML INJ",
  "VIORELE TABLETS 28S",
  "VIRACEPT 250MG TABLETS",
  "VIRACEPT 625MG TABLETS",
  "VIREAD 300MG TABLETS",
  "VIRT PN DHA CAPSULES",
  "VIRT-C DHA CAPSULES",
  "VIRT-PN PLUS CAPSULES",
  "VIRTRATE-3 SOLUTION",
  "VIRTUSSIN AC SYRUP",
  "VIRT-VITE FORTE TABLETS",
  "VIRT-VITE PLUS TABLETS",
  "VITAFOL-OB +DHA CAPSULES",
  "VITAFOL-OB TABLETS",
  "VITAL-D RX TABLETS",
  "VITAMIN B-12 100MCG TAB",
  "VITAMIN D 50,000IU CAP",
  "VITAMIN D AQ 400U/ML INFANT LIQUID",
  "VITAMIN K1 10MG/ML FOR INJ, 1ML",
  "VOLTAREN 1% GEL 100GM",
  "VORICONAZOLE 200MG TABLETS",
  "VORICONAZOLE 40MG/ML SUSP 75ML",
  "VORICONAZOLE 50MG TABLETS",
  "VOTRIENT 200MG TABLETS",
  "VP-GSTN CAPSULES",
  "VP-ZEL TABLETS",
  "VP-ZEL TABLETS",
  "VP-ZEL TABLETS",
  "VSL#3 DS POWDER PAK FOR SOLUTION",
  "VYFEMLA TABLETS 28S",
  "VYVANSE 20MG CAPSULES",
  "VYVANSE 30MG CAPSULES",
  "VYVANSE 40MG CAPSULES",
  "VYVANSE 50MG CAPSULES",
  "VYVANSE 60MG CAPSULES",
  "VYVANSE 70MG CAPSULES",
  "WARFARIN SOD 10MG** TAB",
  "WARFARIN SOD 1MG TAB",
  "WARFARIN SOD 2.5MG TAB",
  "WARFARIN SOD 2MG TAB",
  "WARFARIN SOD 3MG TAB",
  "WARFARIN SOD 4MG TAB",
  "WARFARIN SOD 5MG TAB",
  "WARFARIN SOD 6MG TAB",
  "WARFARIN SOD 7.5MG TAB",
  "WP THYROID 48.75MG TABLETS",
  "XARELTO 10MG TABLETS",
  "XARELTO 15MG TABLETS",
  "XARELTO 20MG TABLETS",
  "XENICAL 120MG CAPSULES",
  "XERAC AC SOLUTION 35ML",
  "XERESE 5-1% CREAM 5GM",
  "XIFAXAN 200MG TABLETS",
  "XIFAXAN 550MG TABLETS",
  "XIIDRA 5% OPHTH SOLUTION",
  "XOPENEX HFA ORAL INH (200 PFS) 15GM",
  "XULANE PATCHES",
  "YDROCHLOROTHIAZIDE 12.5MG TAB",
  "ZAFIRLUKAST 20MG TABLETS",
  "ZALEPLON 10MG CAPSULES",
  "ZALEPLON 5MG CAPSULES",
  "ZEMPLAR 2MCG/ML INJ , 1ML",
  "ZENCHENT FE CHEWABLE TABLETS",
  "ZENPEP 10000 IU CAPSULES",
  "ZENZEDI 10MG TABLETS",
  "ZIDOVUDINE 100MG CAPSULES",
  "ZIDOVUDINE 10MG/ML SYRUP",
  "ZIDOVUDINE 300MG TABLETS",
  "ZIOPTAN 0.0015% DROPS 30 VIALS",
  "ZIPRASIDONE HCL 20MG CAPSULES",
  "ZIPRASIDONE HCL 40MG CAPSULES",
  "ZIPRASIDONE HCL 60MG CAPSULES",
  "ZIPRASIDONE HCL 80MG CAPSULES",
  "ZIRGAN 0.15% OPHTH GEL 5GM",
  "ZMAX ER 2 GRAM ORAL SUSPENSION",
  "ZOLADEX 3.6MG IMPLANT SYRINGE",
  "ZOLEDRONIC 5MG/100ML INJ, 100ML",
  "ZOLMITRIPTAN 2.5MG ODT TABLETS",
  "ZOLMITRIPTAN 2.5MG TABLET",
  "ZOLMITRIPTAN 5MG ODT TABLETS",
  "ZOLMITRIPTAN 5MG TABLETS",
  "ZOLPIDEM 10MG TABLETS",
  "ZOLPIDEM 5MG TABLETS",
  "ZOLPIDEM ER 12.5MG TABLETS",
  "ZOLPIDEM ER 6.25MG TABLETS",
  "ZONISAMIDE 100MG CAPSULES",
  "ZONISAMIDE 25MG CAPSULES",
  "ZONISAMIDE 50MG CAPSULES",
  "ZORTRESS 0.75MG TABLETS",
  "ZOVIA 1/50 TABLETS 28",
];

export const medicationData = Array.from(new Set(medication));

export const CERTIFICATION_TYPE_CHOICES: Record<string, string> = {
  state: "State",
  federal: "Federal",
};

export const EMPLOYMENT_TYPE_CHOICES: Record<string, string> = {
  self_pay: "SELF PAY",
  owner_operator: "OWNER OPERATOR",
  employed: "EMPLOYED",
};

export const VISIT_STATUS_TYPE_CHOICES: Record<string, string> = {
  started_5875: "Started 5875",
  open_for_scheduling: "Open For Scheduling",
  ready_for_ma: "Ready For MA",
  ready_for_provider: "Ready For Provider",
  complete: "Complete",
  pre_screening_pending: "Pre-Screening Pending",
  action_plan_sent: "Action Plan Sent",
  driver_submitted: "Driver Submitted",
  pre_screening_approved: "Pre-Screening Approved",
};

export const VISIT_TYPE_CHOICES: Record<string, string> = {
  office_visit: "Office Visit",
};

export const CERTIFICATION_STATUS_CHOICES: Record<string, string> = {
  meet_standard: "Meet Standard",
  not_meet_standard: "Does Not Meet Standard",
  monitor: "Monitor",
  incomplete: "Incomplete",
  determination_pending: "Determination Pending",
};

export const stateWaivers = [
  {
    state: "Alabama",
    link: "https://www.alea.gov/dps/driver-license/cdl-frequently-asked-questions",
  },
  {
    state: "Alaska",
    link: "http://doa.alaska.gov/dmv/akol/cdl/commercial-requirement-medical.htm",
  },
  {
    state: "Arizona",
    link: "https://azdot.gov/",
  },
  {
    state: "Arkansas",
    link: "https://www.dfa.arkansas.gov/driver-services",
  },
  {
    state: "California",
    link: "https://www.dmv.ca.gov/portal/dmv/detail/dl/driversafety/cdl_guidelines",
  },
  {
    state: "Colorado",
    link: "https://www.colorado.gov/pacific/csp/medical-waivers",
  },
  {
    state: "Connecticut",
    link: "https://portal.ct.gov/DMV/Online-Forms/Online-Forms/DMV-Forms---Medical-Matters#28116",
  },
  {
    state: "Delaware",
    link: "https://www.dmv.de.gov/forms/forms_manuals.shtml",
  },
  {
    state: "Florida",
    link: "https://www.flhsmv.gov/driver-licenses-id-cards/general-information/medical-visual-problems/",
  },
  {
    state: "Georgia",
    link: "https://dds.georgia.gov/documents/forms",
  },
  {
    state: "Hawaii",
    link: "http://hidot.hawaii.gov/highways/library/motor-vehicle-safety-office/",
  },
  {
    state: "Idaho",
    link: "https://itd.idaho.gov//itddmv/?target=drivers-license-id-cards&target=drivers-license-id-cards",
  },
  {
    state: "Illinois",
    link: "https://www.cyberdriveillinois.com/departments/drivers/drivers_license/CDL/cdl.html",
  },
  {
    state: "Indiana",
    link: "https://www.in.gov/bmv/2529.htm",
  },
  {
    state: "Iowa",
    link: "https://iowadot.gov/mvd/cdl/medical-cards-and-certification",
  },
  {
    state: "Kansas",
    link: "https://kcc.ks.gov/transportation",
  },
  {
    state: "Kentucky",
    link: "https://drive.ky.gov/driver-licensing/Pages/Commercial-Drivers-License-Information.aspx",
  },
  {
    state: "Maine",
    link: "https://www.maine.gov/sos/bmv/licenses/commercialexam.html",
  },
  {
    state: "Maryland",
    link: "http://www.mva.maryland.gov/_resources/docs/cdl-medical-waiver-information-packet.pdf",
  },
  {
    state: "Massachusetts",
    link: "https://www.mass.gov/lists/rmv-forms-and-applications",
  },
  {
    state: "Michigan",
    link: "https://www.michigan.gov/msp/0,4643,7-123-72297_59877_62894---,00.html",
  },
  {
    state: "Minnesota",
    link: "http://www.dot.state.mn.us/cvo/medicalwaivers.html",
  },
  {
    state: "Mississippi",
    link: "http://mdot.ms.gov/portal/home.aspx",
  },
  {
    state: "Missouri",
    link: "https://www.modot.org/MCResources",
  },
  {
    state: "Montana",
    link: "https://dojmt.gov/driving/medical-certification/",
  },
  {
    state: "Nebraska",
    link: "https://dmv.nebraska.gov/cdl/cdl",
  },
  {
    state: "Nevada",
    link: "https://dmvnv.com/cdl.htm",
  },
  {
    state: "New Hampshire",
    link: "https://www.nh.gov/safety/divisions/dmv/driver-licensing/commercial/",
  },
  {
    state: "New Jersey",
    link: "https://www.state.nj.us/mvc/drivertopics/gettingcdl.htm",
  },
  {
    state: "New Mexico",
    link: "http://www.mvd.newmexico.gov/driver-medical-conditions.aspx",
  },
  {
    state: "New York",
    link: "https://dmv.ny.gov/commercial-drivers/cdl-medical-certification-requirements",
  },
  {
    state: "North Carolina",
    link: "https://www.ncdot.gov/dmv/license-id/driver-licenses/commercial/Pages/medical-certification.aspx",
  },
  {
    state: "North Dakota",
    link: "https://www.dot.nd.gov/divisions/mv/vehicle.htm#motor-carrier-services",
  },
  {
    state: "Ohio",
    link: "https://www.bmv.ohio.gov/dl-cdl-self-certification.aspx",
  },
  {
    state: "Oregon",
    link: "https://www.oregon.gov/ODOT/DMV/pages/driverid/cdlmedex.aspx",
  },
  {
    state: "Oklahoma",
    link: "https://www.ok.gov/dps/FAQs/Commercial_Driver_License_(CDL)/CDL_Self-Medical_Certification_FAQ.html",
  },
  {
    state: "Pennsylvania",
    link: "https://www.dmv.pa.gov/Driver-Services/Commercial-Driver/Pages/Sample-Medical-Examiners-Certificate.aspx",
  },
  {
    state: "Rhode Island",
    link: "http://www.dmv.ri.gov/licenses/commercial/",
  },
  {
    state: "South Carolina",
    link: "http://www.scdmvonline.com/Driver-Services/Commercial-Licenses",
  },
  {
    state: "South Dakota",
    link: "https://dps.sd.gov/driver-licensing/commercial-drivers-license",
  },
  {
    state: "Tennessee",
    link: "https://www.tn.gov/safety/driver-services/commercial-driver-license.html",
  },
  {
    state: "Texas",
    link: "https://www.dps.texas.gov/DriverLicense/commerciallicense.htm",
  },
  {
    state: "Utah",
    link: "https://dld.utah.gov/dotmedical-informationintrastate/",
  },
  {
    state: "Vermont",
    link: "https://dmv.vermont.gov/licenses/types-of-licenses-ids/commercial-drivers-license-cdl",
  },
  {
    state: "Virginia",
    link: "https://www.dmv.virginia.gov/drivers/#medical/index.asp",
  },
  {
    state: "Washington",
    link: "https://www.dol.wa.gov/driverslicense/cdlmedicalwaivers.html",
  },
  {
    state: "West Virginia",
    link: "http://transportation.wv.gov/DMV/DMVFormSearch/DLAB-1_2-6-2012.pdf",
  },
  {
    state: "Wisconsin",
    link: "https://wisconsindot.gov/Pages/dmv/license-drvs/mdcl-cncrns/waivers.aspx",
  },
  {
    state: "Wyoming",
    link: "http://www.dot.state.wy.us/home/driver_license_records/commercial-license.html",
  },
];

export const faqData = [
  {
    category: "General",
    questions: [
      {
        question: "What is MedScreen?",
        answer: `MedScreen is a comprehensive service used to expedite the DOT medical certification process based on FMCSA regulations 49 CFR 391.41 – 391.49. It helps drivers by screening them before their DOT examination to ensure that necessary testing, follow-up, and paperwork are completed.`,
      },
      {
        question: "How does MedScreen help drivers?",
        answer: `MedScreen reduces the number of required DOT physicals, provides an option for finding doctors, completing medical forms, and storing medical records. It is free for drivers.`,
      },
      {
        question: "How does MedScreen help fleets?",
        answer: `MedScreen provides modern data analytics to help fleet managers reduce DOT physicals, overhead, and streamline operations while maintaining HIPAA compliance.`,
      },
      {
        question: "How does MedScreen help clinics?",
        answer: `MedScreen is the first DOT-based EMR system designed to simplify the DOT examination process with intelligent automation, HIPAA secure chat, and embedded DOT resources.`,
      },
      {
        question: "Is MedScreen device-specific?",
        answer: `No, MedScreen works on any device, PC, or tablet. Landscape mode is preferred for the best experience.`,
      },
    ],
  },
  {
    category: "Security & Privacy",
    questions: [
      {
        question:
          "Is my personal medical information available to other people?",
        answer: `No, your information is secure and protected by HIPAA-compliant standards. If you need to update your release of information, please complete the Release of Information Form.`,
      },
    ],
  },
  {
    category: "DOT Medical Certification",
    questions: [
      {
        question:
          "What determines the duration of a driver’s medical certification?",
        answer: `A DOT Medical Examiner determines the certification duration based on FMCSA regulations. Most chronic conditions are limited to a 1-year certification, but the examiner has discretion.`,
      },
      {
        question:
          "What is the maximum allowable certification time for a DOT medical certificate?",
        answer: `Two (2) years, if the driver is healthy and does not have any acute or chronic conditions that interfere with the safe operation of a commercial motor vehicle.`,
      },
      {
        question:
          "What are the minimum physical requirements for a commercial driver?",
        answer: `The minimum physical requirements are listed on the FMCSA website. [Learn more](https://www.fmcsa.dot.gov)`,
      },
      {
        question:
          "What is the vision requirement for the DOT medical examination?",
        answer: `Drivers must have distant vision of 20/40 or better in each eye and a peripheral vision of at least 70 degrees. Corrective lenses are allowed.`,
      },
      {
        question:
          "What are the blood pressure requirements for the DOT medical examination?",
        answer: `Blood pressure should be less than or equal to 140/90. Higher readings may limit the medical certification duration.`,
      },
      {
        question: "What is BMI and why is it used?",
        answer: `Body Mass Index (BMI) is a calculation based on height and weight. If BMI is over 35, additional testing such as a sleep apnea study may be required.`,
      },
      {
        question:
          "Which medications are not approved for operating a commercial motor vehicle?",
        answer: `Controlled substances listed in 21 CFR 1308.11 Schedule I, amphetamines, narcotics, or any habit-forming drugs unless prescribed by a medical practitioner.`,
      },
      {
        question:
          "Are there any disqualifying medical conditions for operating a commercial motor vehicle?",
        answer: `Yes. Conditions include epilepsy, dementia, malignant brain tumors, untreated sleep apnea, schizophrenia, severe traumatic brain injuries, and more.`,
      },
    ],
  },
  {
    category: "Licensing & Regulations",
    questions: [
      {
        question: "What is a CDL or CLP?",
        answer: `“CDL” stands for Commercial Driver’s License. “CLP” stands for Certified Learner’s Permit.`,
      },
      {
        question: "What are the different types of commercial licenses?",
        answer: `CDLs are classified into:
        - **Class A**: Vehicles over 26,001 lbs towing over 10,000 lbs.
        - **Class B**: Single vehicles over 26,001 lbs, towing under 10,000 lbs.
        - **Class C**: Vehicles transporting 16+ passengers or hazardous materials.`,
      },
      {
        question: "What is the difference between INTRAstate and INTERstate?",
        answer: `INTRAstate drivers operate within a single state and can be 18+. INTERstate drivers cross state lines and must be at least 21 years old.`,
      },
      {
        question:
          "What is self-certification and how do I choose my driver type?",
        answer: `Drivers must determine whether they operate INTRAstate or INTERstate, and if they are EXCEPTED or NON-EXCEPTED under federal and state regulations.`,
      },
    ],
  },
  {
    category: "Waivers & Exemptions",
    questions: [
      {
        question: "What is the difference between a waiver and an exemption?",
        answer: `Exemptions are granted for medical conditions requiring clearance. Waivers are state-based allowances for specific conditions.`,
      },
      {
        question: "Which medical conditions require an exemption?",
        answer: `Federal exemptions exist for vision, diabetes, hearing, and limb loss. Seizure exemptions are rarely approved.`,
      },
      {
        question: "How long does it take to get a federal exemption approved?",
        answer: `It can take up to 180 days (3-4 months) due to review, public commenting, and final approval.`,
      },
    ],
  },
  {
    category: "Sleep Apnea & DOT Requirements",
    questions: [
      {
        question: "What is the latest update on sleep apnea screening?",
        answer: `As of 2017, FMCSA does not mandate sleep apnea screening, but medical examiners can require it if necessary.`,
      },
      {
        question: "Which factors indicate a need for sleep apnea screening?",
        answer: `Risk factors include:
        - BMI ≥ 35
        - Neck size ≥ 17” (male) / 16” (female)
        - Age ≥ 50
        - History of stroke, heart disease, or diabetes`,
      },
      {
        question: "What are the CPAP compliance requirements?",
        answer: `Drivers using a CPAP must show compliance (4+ hours per night, 70% of nights). They should provide at least 90 days of compliance data.`,
      },
    ],
  },
  {
    category: "Diabetes & Blood Sugar Requirements",
    questions: [
      {
        question: "Can insulin be used by commercial drivers?",
        answer: `Yes, drivers can use insulin without any waiver/exemption, but do require a form that can be found <a href="https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/2023-08/Insulin-Treated%20Diabetes%20Mellitus%20Assessment%20Form%20MCSA-5870_508.pdf" target="_blank" rel="noopener noreferrer">here</a>`,
      },
      {
        question: "What is the maximum allowable A1C level?",
        answer: `There is no strict FMCSA requirement, but most DOT medical examiners prefer A1C below 10%. Some examiners require A1C < 8%.`,
      },
    ],
  },
  {
    category: "Additional Questions",
    questions: [
      {
        question: "Where can I find more medical FAQs?",
        answer: `You can find additional FAQs on the FMCSA website: <a href="https://www.fmcsa.dot.gov/regulations/national-registry/national-registry-certified-medical-examiners-faqs" target="_blank" rel="noopener noreferrer">FMCSA Medical FAQs</a>`,
      },
      {
        question: "Where can I find more general FAQs?",
        answer: `For non-medical FAQs, visit the FMCSA FAQ page: <a href="https://www.fmcsa.dot.gov/faq" target="_blank" rel="noopener noreferrer">FMCSA General FAQs</a>`,
      },
    ],
  },
];

export const forms = {
  clearance_forms: [
    { title: "Cardiac Clearance", file: "CardiacClearance6.pdf" },
    { title: "Diabetes Mellitus Clearance", file: "DMClearance4.pdf" },
    { title: "General Clearance", file: "GeneralClearance1.pdf" },
    { title: "Hypertension Clearance", file: "HTNClearance2.pdf" },
    { title: "Medication Clearance", file: "MedicationClearanceForm7.pdf" },
    {
      title: "Musculoskeletal Clearance",
      file: "MusculoskeletalClearance9.pdf",
    },
    { title: "Neurology Clearance", file: "NeurologyClearance3.pdf" },
    { title: "Psychiatric Clearance", file: "PsychiatricClearance5.pdf" },
    { title: "Pulmonary Clearance", file: "PulmonaryClearance8.pdf" },
    { title: "Sleep Apnea Clearance", file: "SleepApneaClearance10.pdf" },
  ],
  federal_exemptions: [
    {
      title: "Vision Exemption Package (09/18)",
      file: "vision-exemption-package-0918.pdf",
    },
    {
      title: "Indiana Vision Exemption Package",
      file: "indiana-vision-exemption-package.pdf",
    },
    {
      title: "Federal Hearing Exemption Application",
      file: "federalhearingexemptionapplication.pdf",
    },
    {
      title: "Medical Release Sample (Hearing Exemption)",
      file: "medical-release-sample-hearing-exemption.pdf",
    },
    { title: "Medical Release Form", file: "medical-release-form.pdf" },
    {
      title: "Medical Release Sample (Seizure Exemption)",
      file: "medical-release-sample-seizure-exemption.pdf",
    },
    {
      title: "Medical Release Form (Seizure)",
      file: "medical-release-formseizure.pdf",
    },
    {
      title: "New Driver Application Package (SPE)",
      file: "NewDriverApplicationPackageSPE.pdf",
    },
    { title: "SPE Renewal Application", file: "SPERenewalApplication4.pdf" },
    { title: "ITDM Assessment Form", file: "itdm-assessment-form-final.pdf" },
  ],
  state_resources: {
    Alabama:
      "https://www.alea.gov/dps/driver-license/cdl-frequently-asked-questions",
    Alaska:
      "http://doa.alaska.gov/dmv/akol/cdl/commercial-requirement-medical.htm",
    Arizona: "https://azdot.gov/",
    Arkansas: "https://www.dfa.arkansas.gov/driver-services",
    California:
      "https://www.dmv.ca.gov/portal/driver-licenses-identification-cards/commercial-driver-licenses-cdl/commercial-driver-license-medical-eligibility-exams/",
    Colorado: "https://www.colorado.gov/pacific/csp/medical-waivers",
    Connecticut:
      "https://portal.ct.gov/DMV/Online-Forms/Online-Forms/DMV-Forms---Medical-Matters#28116",
    Delaware:
      "https://dmv.de.gov/DriverServices/drivers_license/CDL/index.shtml",
    Florida:
      "https://www.flhsmv.gov/driver-licenses-id-cards/general-information/medical-visual-problems/",
    Georgia: "https://dds.georgia.gov/georgia-licenseid/commercial",
    Hawaii:
      "http://hidot.hawaii.gov/highways/library/motor-vehicle-safety-office/",
    Idaho:
      "https://itd.idaho.gov//itddmv/?target=drivers-license-id-cards&target=drivers-license-id-cards",
    Illinois:
      "https://www.cyberdriveillinois.com/departments/drivers/drivers_license/CDL/cdl.html",
    Indiana: "https://www.in.gov/bmv/2529.htm",
    Iowa: "https://iowadot.gov/mvd/cdl/medical-cards-and-certification",
    Kansas: "https://kcc.ks.gov/transportation",
    Kentucky:
      "https://drive.ky.gov/driver-licensing/Pages/Commercial-Drivers-License-Information.aspx",
    Maine: "https://www.maine.gov/sos/bmv/licenses/commercialexam.html",
    Maryland: "https://mva.maryland.gov/drivers/Pages/cdl-commercial.aspx",
    Massachusetts: "https://www.mass.gov/lists/rmv-forms-and-applications",
    Michigan:
      "https://www.michigan.gov/msp/0,4643,7-123-72297_59877_62894---,00.html",
    Minnesota:
      "https://mn.gov/elicense/a-z/?id=1083-231305#/list/appId//filterType//filterValue//page/1/sort//order/",
    Mississippi:
      "https://www.driverservicebureau.dps.ms.gov/Drivers/Classes_A-D",
    Missouri: "https://www.modot.org/MCResources",
    Montana: "https://dojmt.gov/driving/medical-certification/",
    Nebraska: "https://dmv.nebraska.gov/cdl/cdl",
    Nevada: "https://dmvnv.com/cdl.htm",
    "New Hampshire":
      "https://www.nh.gov/safety/divisions/dmv/driver-licensing/commercial/",
    "New Jersey": "https://www.state.nj.us/mvc/drivertopics/gettingcdl.htm",
    "New Mexico":
      "https://www.mvd.newmexico.gov/commercial/commercial-drivers-licenses-cdl/",
    "New York":
      "https://dmv.ny.gov/commercial-drivers/cdl-medical-certification-requirements",
    "North Carolina":
      "https://www.ncdot.gov/dmv/license-id/driver-licenses/commercial/Pages/medical-certification.aspx",
    "North Dakota":
      "https://www.dot.nd.gov/divisions/mv/vehicle.htm#motor-carrier-services",
    Ohio: "https://www.bmv.ohio.gov/dl-cdl-classes.aspx",
    Oregon: "https://www.oregon.gov/ODOT/DMV/pages/driverid/cdlmedex.aspx",
    Oklahoma:
      "https://oklahoma.gov/service/all-pages/cdl-first-time-applicants.html",
    Pennsylvania:
      "https://www.dmv.pa.gov/Driver-Services/Commercial-Driver/Pages/Sample-Medical-Examiners-Certificate.aspx",
    "Rhode Island": "http://www.dmv.ri.gov/licenses/commercial/",
    "South Carolina":
      "http://www.scdmvonline.com/Driver-Services/Commercial-Licenses",
    "South Dakota":
      "https://dps.sd.gov/driver-licensing/commercial-drivers-license",
    Tennessee:
      "https://www.tn.gov/safety/driver-services/commercial-driver-license.html",
    Texas: "https://www.dps.texas.gov/DriverLicense/commerciallicense.htm",
    Utah: "https://dld.utah.gov/dotmedical-informationintrastate/",
    Vermont:
      "https://dmv.vermont.gov/licenses/types-of-licenses-ids/commercial-drivers-license-cdl",
    Virginia: "https://www.dmv.virginia.gov/drivers/#medical/index.asp",
    Washington: "https://www.dol.wa.gov/driverslicense/cdlmedicalwaivers.html",
    "West Virginia":
      "https://transportation.wv.gov/DMV/Motor-Carriers/CDL/Pages/default.aspx",
    Wisconsin:
      "https://wisconsindot.gov/Pages/dmv/license-drvs/mdcl-cncrns/waivers.aspx",
    Wyoming:
      "http://www.dot.state.wy.us/home/driver_license_records/commercial-license.html",
  },
  other_documents: [
    {
      title: "MCSA 5875 (Long Form Blank)",
      file: "5875.pdf",
    },
    {
      title: "MCSA 5876 (Medical Examiner Certificate Blank)",
      file: "5876.pdf",
    },
    {
      title: "MCSA 5895 (Medication Clarification)",
      file: "MCSA-5895.pdf",
    },
  ],
  release_of_information: [
    { title: "Release of Information Form", file: "ROIMMS.pdf" },
  ],
};

export const resources = [
  {
    key: "Medical Reports",
    documents: [
      {
        title: "ME Handbook (old)",
        resource: "fmcsamedicalexaminerhandbook.pdf",
      },
      {
        title: "Cochlear Implants and CMV Driver Safety (2011)",
        resource: "CochlearImplantRevison1142011-LibraryCopy.pdf",
      },
      {
        title: "Obstructive Sleep Apnea and CMV Driver Safety (2011)",
        resource: "OSAUpdate113020111.docx",
      },
      {
        title: "Diabetes and CMV Driver Safety (2011)",
        resource: "2010DiabetesUpdateFinalMay272011.pdf",
      },
      {
        title: "Traumatic Brain Injury (2010)",
        resource: "TBIandCMVDriverSafetyReport-Final.pdf",
      },
      {
        title: "Stroke (2009)",
        resource: "Stroke-and-CMV-Driver-Safety-Final-Exe-Sum-rev.pdf",
      },
      {
        title: "Multiple Sclerosis and Parkinson's Disease (2009)",
        resource: "ParkinsonsMSfinal.pdf",
      },
      {
        title: "Psychiatric Disease (2008)",
        resource: "PsychiatricDisorders-FINAL8-29-08.pdf",
      },
      {
        title: "Seizure Disorders (2007)",
        resource: "Final-SeizureDisordersandCMVDriverSafety.pdf",
      },
      {
        title: "Sleep Disorders (2007)",
        resource: "FinalSleepDisordersEvidReportVol1.pdf",
      },
      {
        title: "Renal Disease (2007)",
        resource: "ChronicKidneyDiseaseEvidenceReport-FINAL.pdf",
      },
      {
        title: "Musculoskeletal Disease (2007)",
        resource: "MusculoskeletalEvidenceReport-Final.pdf",
      },
      {
        title: "Hearing (2007)",
        resource: "HearingDOT-FMCSA-FINAL8-29-08.pdf",
      },
      {
        title: "Diabetes Mellitus (Endocrine Disease) (2006)",
        resource: "FinalDiabetesEvidenceReport.pdf",
      },
      {
        title: "Schedule II Licit Medications (2006)",
        resource: "FinalScheduleIIDrugsEvidenceReport.pdf",
      },
      {
        title: "Cardiovascular Disease (2006)",
        resource: "FinalCVDEvidenceReportv2.pdf",
      },
    ],
  },
  {
    key: "Additional Information",
    documents: [
      {
        title: "Commercial Driver Job Description",
        link: "https://www.fmcsa.dot.gov/regulations/medical/medical-regulations-and-guidance-resource-linksf",
      },
      {
        title: "National Registry FAQ",
        link: "https://www.fmcsa.dot.gov/regulations/national-registry/national-registry-certified-medical-examiners-faqs",
      },
      {
        title: "Medical Examiner Brochure",
        resource: "MedicalExaminer-trifoldfinalversionforwebsite.pdf",
      },
      {
        title: "Driver Examination Forms FAQ",
        resource: "FAQsNationalRegistryDriverExaminationForms.pdf",
      },
      {
        title: "CMV Driver Brochure",
        resource: "CMVDriver-trifoldfinalversionforwebsite.pdf",
      },
      {
        title: "FMCSA Complete Guide to ME Certification",
        resource: "CompleteGuidetoMECertification.pdf",
      },
      {
        title: "CMV Driver Fact Sheet",
        resource: "FactSheetCMVDrivers.pdf",
      },
      {
        title: "New 2019 Diabetic Rule FAQ",
        resource: "ADAFMCSAFinalRuleFAQ.pdf",
      },
    ],
  },
  {
    key: "External Links",
    documents: [
      {
        title: "Hartenbaum (Login)",
        link: "https://digital.oempress.com/",
      },
      {
        title: "Hartenbaum (Purchase)",
        link: "https://oempress.com/the-dot-medical-examination-an-unofficial-guide-to-commercial-drivers-medical-certification-7th-edition/?srsltid=AfmBOoosM18iTP9TGOmG7ptvJ3pD3s8LgZH3pBoYnuAtPUE4nbzQMfCe",
      },
      {
        title: "FMCSA Medical Regulations",
        link: "https://www.fmcsa.dot.gov/regulations/medical",
      },
      {
        title: "FMCSA Regulations (All)",
        link: "https://www.fmcsa.dot.gov/regulations",
      },
      {
        title: "New Diabetes Standard (2018)",
        link: "https://www.fmcsa.dot.gov/regulations/medical/new-diabetes-standard-overview-webinar",
      },
      {
        title: "Qualifications of Diabetic Drivers 09/19/2018",
        link: "https://www.federalregister.gov/documents/2018/09/19/2018-20161/qualifications-of-drivers-diabetes-standard",
      },
    ],
  },
];

export interface PlanTier {
  id: string;
  name: string;
  price: number;
  certsIncluded: number;
  overageRate: string;
  description: string;
  popular?: boolean;
  features: string[];
}

export const PLAN_TIERS: PlanTier[] = [
  {
    id: "basic",
    name: "Basic",
    price: 99,
    certsIncluded: 50,
    overageRate: "$3.00",
    description: "Ideal for small clinics starting out with DOT physicals.",
    features: [
      "50 DOT Certificates included per month",
      "$3.00 per additional certificate",
      "AI-powered certification recommendations",
      "AI One-Click Certification",
      "Kiosk mode & Driver pre-screening",
      "Complete Driver History & Vitals module",
      "NRCME form auto-filling & PDF generation",
      "Auto submit to federal database",
      "Free marketplace listing",
    ],
  },
  {
    id: "essential",
    name: "Essential",
    price: 199,
    certsIncluded: 150,
    overageRate: "$1.50",
    description: "Best value for growing practice volume and regular testing.",
    popular: true,
    features: [
      "150 DOT Certificates included per month",
      "$1.50 per additional certificate",
      "AI-powered certification recommendations",
      "AI One-Click Certification",
      "Kiosk mode & Driver pre-screening",
      "Complete Driver History & Vitals module",
      "NRCME form auto-filling & PDF generation",
      "Auto submit to federal database",
      "Free marketplace listing",
    ],
  },
  {
    id: "volume",
    name: "Volume",
    price: 299,
    certsIncluded: 500,
    overageRate: "$0.50",
    description: "Maximum cost savings for high-volume clinic operations.",
    features: [
      "500 DOT Certificates included per month",
      "$0.50 per additional certificate",
      "AI-powered certification recommendations",
      "AI One-Click Certification",
      "Kiosk mode & Driver pre-screening",
      "Complete Driver History & Vitals module",
      "NRCME form auto-filling & PDF generation",
      "Auto submit to federal database",
      "Free marketplace listing",
    ],
  },
];
